//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { User } from 'oidc-client-ts';
export class BaseApiClient {
    /**
     * Base class for all generated nswag clients.
     *
     * If something is changed in this file the clients will need to be re-generated using the nswag cli.
     *
     * The comment is placed inside the class as nswag will place it at the end of all generated api files if moved
     * above the class declaration.
     */

    /** The locale to set as the Accept-Language header */
    public locale: string | null = null;

    /** The authorization header to set */
    public authorization: string | null = null;

    /** Sets the credentials options of the fetch request */
    public credentials: RequestCredentials | null = null;

    /**
     * Sets the authorization header from a user object.
     */
    public setAuthorizationFromUser(user: User): void {
        this.authorization = `${user.token_type} ${user.access_token}`;
    }

    /**
     * Transforms the request options right before sending the api request.
     */
    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        const headers = new Headers(options.headers);

        if (this.locale) {
            headers.set('Accept-Language', this.locale);
        }

        if (this.authorization) {
            headers.set('Authorization', this.authorization);
        }

        const credentials = this.credentials ?? undefined;

        return { ...options, headers, credentials };
    }
}

export class ApplicationNoticeApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get notices for a specific location.
    Cached for 10 minutes.
     * @param locationId The location to get notices for.
     * @param type (optional) The application notice type to retrieve, null to retrieve all notices.
     * @return OK
     */
    apiApplicationNoticeByLocationByLocationIdGet(locationId: string, type: ApplicationNoticeType | undefined, signal?: AbortSignal): Promise<ApplicationNoticeDto[]> {
        let url_ = this.baseUrl + "/api/application-notice/by-location/{locationId}?";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiApplicationNoticeByLocationByLocationIdGet(_response);
        });
    }

    protected processApiApplicationNoticeByLocationByLocationIdGet(response: Response): Promise<ApplicationNoticeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationNoticeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationNoticeDto[]>(null as any);
    }
}

export class AreaApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve an area by id.
     * @param id The id of the area.
     * @return OK
     */
    apiAreaGetByIdGet(id: string, signal?: AbortSignal): Promise<AreaDto> {
        let url_ = this.baseUrl + "/api/Area/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiAreaGetByIdGet(_response);
        });
    }

    protected processApiAreaGetByIdGet(response: Response): Promise<AreaDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaDto>(null as any);
    }

    /**
     * @return OK
     */
    apiAreaListByParentGet(parent: string, signal?: AbortSignal): Promise<AreaDto[]> {
        let url_ = this.baseUrl + "/api/Area/List/{parent}";
        if (parent === undefined || parent === null)
            throw new Error("The parameter 'parent' must be defined.");
        url_ = url_.replace("{parent}", encodeURIComponent("" + parent));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiAreaListByParentGet(_response);
        });
    }

    protected processApiAreaListByParentGet(response: Response): Promise<AreaDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AreaDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaDto[]>(null as any);
    }
}

export class ChildClassApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieving childclasses for a specific playground with data needed for gui presentation.
     * @param playgroundId The playground Id
     * @return OK
     */
    apiChildClassByPlaygroundByPlaygroundIdGet(playgroundId: string, signal?: AbortSignal): Promise<ChildClassesAvailableModel[]> {
        let url_ = this.baseUrl + "/api/child-class/by-playground/{playgroundId}";
        if (playgroundId === undefined || playgroundId === null)
            throw new Error("The parameter 'playgroundId' must be defined.");
        url_ = url_.replace("{playgroundId}", encodeURIComponent("" + playgroundId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiChildClassByPlaygroundByPlaygroundIdGet(_response);
        });
    }

    protected processApiChildClassByPlaygroundByPlaygroundIdGet(response: Response): Promise<ChildClassesAvailableModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChildClassesAvailableModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChildClassesAvailableModel[]>(null as any);
    }

    /**
     * Get available t-shirt sizes.
     * @return OK
     */
    apiChildClassTShirtSizesGet(signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/child-class/t-shirt-sizes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiChildClassTShirtSizesGet(_response);
        });
    }

    protected processApiChildClassTShirtSizesGet(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ChildClassBookingApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create a new booking.
     * @param body (optional) The booking model.
     * @return OK
     */
    apiChildClassBookingPost(body: CreateChildClassBookingCommand | undefined, signal?: AbortSignal): Promise<CreateChildClassBookingResultDto> {
        let url_ = this.baseUrl + "/api/child-class/booking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiChildClassBookingPost(_response);
        });
    }

    protected processApiChildClassBookingPost(response: Response): Promise<CreateChildClassBookingResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateChildClassBookingResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateChildClassBookingResultDto>(null as any);
    }

    /**
     * Get the confirmation summary for a given booking.
     * @param bookingId The id of the booking.
     * @param orderReference The order reference for the booking.
     * @return OK
     */
    apiChildClassBookingByBookingIdConfirmationInformationByOrderReferenceGet(bookingId: string, orderReference: string, signal?: AbortSignal): Promise<ChildClassBookingConfirmationSummaryModel> {
        let url_ = this.baseUrl + "/api/child-class/booking/{bookingId}/confirmation-information/{orderReference}";
        if (bookingId === undefined || bookingId === null)
            throw new Error("The parameter 'bookingId' must be defined.");
        url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
        if (orderReference === undefined || orderReference === null)
            throw new Error("The parameter 'orderReference' must be defined.");
        url_ = url_.replace("{orderReference}", encodeURIComponent("" + orderReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiChildClassBookingByBookingIdConfirmationInformationByOrderReferenceGet(_response);
        });
    }

    protected processApiChildClassBookingByBookingIdConfirmationInformationByOrderReferenceGet(response: Response): Promise<ChildClassBookingConfirmationSummaryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChildClassBookingConfirmationSummaryModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChildClassBookingConfirmationSummaryModel>(null as any);
    }
}

export class ChildClassBookingPaymentApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create a payment session for the given booking.
     * @param body (optional) The command model.
     * @return OK
     */
    apiChildClassPaymentPost(body: CreateChildClassBookingPaymentCommand | undefined, signal?: AbortSignal): Promise<ChildClassBookingPaymentModel> {
        let url_ = this.baseUrl + "/api/child-class/payment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiChildClassPaymentPost(_response);
        });
    }

    protected processApiChildClassPaymentPost(response: Response): Promise<ChildClassBookingPaymentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChildClassBookingPaymentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChildClassBookingPaymentModel>(null as any);
    }

    /**
     * Get receipts for a given booking.
     * @param bookingId The id of the booking to get the receipt for.
     * @return OK
     */
    apiChildClassByBookingIdReceiptsGet(bookingId: string, signal?: AbortSignal): Promise<ChildClassBookingReceiptModel[]> {
        let url_ = this.baseUrl + "/api/child-class/{bookingId}/receipts";
        if (bookingId === undefined || bookingId === null)
            throw new Error("The parameter 'bookingId' must be defined.");
        url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiChildClassByBookingIdReceiptsGet(_response);
        });
    }

    protected processApiChildClassByBookingIdReceiptsGet(response: Response): Promise<ChildClassBookingReceiptModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChildClassBookingReceiptModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChildClassBookingReceiptModel[]>(null as any);
    }

    /**
     * Get the payment status for a specific booking.
     * @param bookingId (optional) The id of the booking to get payment status for.
     * @return OK
     */
    apiChildClassStatusGet(bookingId: string | undefined, signal?: AbortSignal): Promise<ChildClassBookingPaymentStatus> {
        let url_ = this.baseUrl + "/api/child-class/status?";
        if (bookingId === null)
            throw new Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiChildClassStatusGet(_response);
        });
    }

    protected processApiChildClassStatusGet(response: Response): Promise<ChildClassBookingPaymentStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChildClassBookingPaymentStatus>(null as any);
    }
}

export class CountryApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve a country by id.
     * @param id The id of the country.
     * @return OK
     */
    apiCountryGetByIdGet(id: string, signal?: AbortSignal): Promise<CountryDto> {
        let url_ = this.baseUrl + "/api/Country/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiCountryGetByIdGet(_response);
        });
    }

    protected processApiCountryGetByIdGet(response: Response): Promise<CountryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDto>(null as any);
    }

    /**
     * @param includeregions (optional) 
     * @return OK
     */
    apiCountryListGet(includeregions: boolean | undefined, signal?: AbortSignal): Promise<CountryDto[]> {
        let url_ = this.baseUrl + "/api/Country/List?";
        if (includeregions === null)
            throw new Error("The parameter 'includeregions' cannot be null.");
        else if (includeregions !== undefined)
            url_ += "includeregions=" + encodeURIComponent("" + includeregions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiCountryListGet(_response);
        });
    }

    protected processApiCountryListGet(response: Response): Promise<CountryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDto[]>(null as any);
    }

    /**
     * Retrieve phone metadata for a country.
     * @return OK
     */
    apiCountryMetadataGet(signal?: AbortSignal): Promise<CountryMetadataDto> {
        let url_ = this.baseUrl + "/api/Country/Metadata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiCountryMetadataGet(_response);
        });
    }

    protected processApiCountryMetadataGet(response: Response): Promise<CountryMetadataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryMetadataDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryMetadataDto>(null as any);
    }

    /**
     * Retrieve a cached variant of the country list.
     * @param includeregions (optional) True if the regions should be included, false otherwise. Defaults to false.
     * @return OK
     */
    apiCountryFrontEndListGet(includeregions: boolean | undefined, signal?: AbortSignal): Promise<CountryDto[]> {
        let url_ = this.baseUrl + "/api/Country/FrontEndList?";
        if (includeregions === null)
            throw new Error("The parameter 'includeregions' cannot be null.");
        else if (includeregions !== undefined)
            url_ += "includeregions=" + encodeURIComponent("" + includeregions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiCountryFrontEndListGet(_response);
        });
    }

    protected processApiCountryFrontEndListGet(response: Response): Promise<CountryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDto[]>(null as any);
    }
}

export class EntranceBookingApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Fetches the currently authenticated users entrance bookings.
     * @return OK
     */
    apiEntranceBookingMyBookingsGet(signal?: AbortSignal): Promise<UserEntranceBookingDto[]> {
        let url_ = this.baseUrl + "/api/entrance/booking/MyBookings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiEntranceBookingMyBookingsGet(_response);
        });
    }

    protected processApiEntranceBookingMyBookingsGet(response: Response): Promise<UserEntranceBookingDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserEntranceBookingDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserEntranceBookingDto[]>(null as any);
    }
}

export class GiftCardArticlesApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve a gift card article.
     * @param id The id of the gift card article to retrieve.
     * @return OK
     */
    apiShopGiftCardsByIdGet(id: number, signal?: AbortSignal): Promise<SellableGiftCardArticleModel> {
        let url_ = this.baseUrl + "/api/shop/gift-cards/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopGiftCardsByIdGet(_response);
        });
    }

    protected processApiShopGiftCardsByIdGet(response: Response): Promise<SellableGiftCardArticleModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SellableGiftCardArticleModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellableGiftCardArticleModel>(null as any);
    }

    /**
     * Retrieve all available, active, gift card articles by country.
     * @param locationId The country to get the gift cards for.
     * @return OK
     */
    apiShopGiftCardsByLocationByLocationIdGet(locationId: string, signal?: AbortSignal): Promise<GiftCardArticleSummaryModel[]> {
        let url_ = this.baseUrl + "/api/shop/gift-cards/by-location/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopGiftCardsByLocationByLocationIdGet(_response);
        });
    }

    protected processApiShopGiftCardsByLocationByLocationIdGet(response: Response): Promise<GiftCardArticleSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GiftCardArticleSummaryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GiftCardArticleSummaryModel[]>(null as any);
    }
}

export class GiftCardOrderApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get an order summary, without placing an order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopGiftCardOrdersSummaryPost(body: GetGiftCardOrderSummaryQuery | undefined, signal?: AbortSignal): Promise<GiftCardOrderSummaryModel> {
        let url_ = this.baseUrl + "/api/shop/gift-card/orders/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopGiftCardOrdersSummaryPost(_response);
        });
    }

    protected processApiShopGiftCardOrdersSummaryPost(response: Response): Promise<GiftCardOrderSummaryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GiftCardOrderSummaryModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GiftCardOrderSummaryModel>(null as any);
    }

    /**
     * Create a new order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopGiftCardOrdersPost(body: CreateGiftCardOrderCommand | undefined, signal?: AbortSignal): Promise<GiftCardOrderPaymentModel> {
        let url_ = this.baseUrl + "/api/shop/gift-card/orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopGiftCardOrdersPost(_response);
        });
    }

    protected processApiShopGiftCardOrdersPost(response: Response): Promise<GiftCardOrderPaymentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GiftCardOrderPaymentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GiftCardOrderPaymentModel>(null as any);
    }

    /**
     * Retrieve the payment status of an order.
     * @param orderReference The order reference.
     * @return OK
     */
    apiShopGiftCardOrdersByOrderReferenceStatusGet(orderReference: string, signal?: AbortSignal): Promise<GiftCardOrderPaymentStatus> {
        let url_ = this.baseUrl + "/api/shop/gift-card/orders/{orderReference}/status";
        if (orderReference === undefined || orderReference === null)
            throw new Error("The parameter 'orderReference' must be defined.");
        url_ = url_.replace("{orderReference}", encodeURIComponent("" + orderReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopGiftCardOrdersByOrderReferenceStatusGet(_response);
        });
    }

    protected processApiShopGiftCardOrdersByOrderReferenceStatusGet(response: Response): Promise<GiftCardOrderPaymentStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GiftCardOrderPaymentStatus>(null as any);
    }

    /**
     * Retrieve the tracking event of an order.
     * @param orderReference The order reference.
     * @return OK
     */
    apiShopGiftCardOrdersByOrderReferenceTrackingEventGet(orderReference: string, signal?: AbortSignal): Promise<ShopPurchaseEvent> {
        let url_ = this.baseUrl + "/api/shop/gift-card/orders/{orderReference}/tracking-event";
        if (orderReference === undefined || orderReference === null)
            throw new Error("The parameter 'orderReference' must be defined.");
        url_ = url_.replace("{orderReference}", encodeURIComponent("" + orderReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopGiftCardOrdersByOrderReferenceTrackingEventGet(_response);
        });
    }

    protected processApiShopGiftCardOrdersByOrderReferenceTrackingEventGet(response: Response): Promise<ShopPurchaseEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShopPurchaseEvent.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShopPurchaseEvent>(null as any);
    }
}

export class LocationApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Fetch locations by category
     * @param category (optional) The category to fetch locations for
     * @return OK
     */
    apiLocationGetLocationsByCategoryGet(category: string | undefined, signal?: AbortSignal): Promise<LocationDto[]> {
        let url_ = this.baseUrl + "/api/Location/GetLocationsByCategory?";
        if (category === null)
            throw new Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiLocationGetLocationsByCategoryGet(_response);
        });
    }

    protected processApiLocationGetLocationsByCategoryGet(response: Response): Promise<LocationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationDto[]>(null as any);
    }

    /**
     * Get location by id.
     * @param id The id of the location.
     * @return OK
     */
    apiLocationGetLocationByIdGet(id: string, signal?: AbortSignal): Promise<LocationDto> {
        let url_ = this.baseUrl + "/api/Location/GetLocation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiLocationGetLocationByIdGet(_response);
        });
    }

    protected processApiLocationGetLocationByIdGet(response: Response): Promise<LocationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationDto>(null as any);
    }

    /**
     * Delete a location by id.
     * @param id The id of the location.
     * @return OK
     */
    apiLocationDeleteLocationByIdDelete(id: string, signal?: AbortSignal): Promise<LocationDto> {
        let url_ = this.baseUrl + "/api/Location/DeleteLocation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiLocationDeleteLocationByIdDelete(_response);
        });
    }

    protected processApiLocationDeleteLocationByIdDelete(response: Response): Promise<LocationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationDto>(null as any);
    }

    /**
     * Retrieve the location tree list (Countries, regions, playgrounds etc.) given a specific scope.
     * @param scope (optional) The scope, if omitted all levels will be returned (except tables).
     * @return OK
     */
    apiLocationGetTreeGet(scope: LocationTreeLevels | undefined, signal?: AbortSignal): Promise<LocationTreeDto> {
        let url_ = this.baseUrl + "/api/Location/GetTree?";
        if (scope === null)
            throw new Error("The parameter 'scope' cannot be null.");
        else if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiLocationGetTreeGet(_response);
        });
    }

    protected processApiLocationGetTreeGet(response: Response): Promise<LocationTreeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationTreeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationTreeDto>(null as any);
    }

    /**
     * Get a list of all locations.
     * @return OK
     */
    apiLocationGetListGet(signal?: AbortSignal): Promise<LocationListDto> {
        let url_ = this.baseUrl + "/api/Location/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiLocationGetListGet(_response);
        });
    }

    protected processApiLocationGetListGet(response: Response): Promise<LocationListDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationListDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationListDto>(null as any);
    }

    /**
     * Get a list of all locations for a given scope.
     * @param scope The scope to retrieve locations for.
     * @return OK
     */
    apiLocationGetListByScopeGet(scope: LocationTreeLevels, signal?: AbortSignal): Promise<LocationListItem[]> {
        let url_ = this.baseUrl + "/api/Location/GetList/{scope}";
        if (scope === undefined || scope === null)
            throw new Error("The parameter 'scope' must be defined.");
        url_ = url_.replace("{scope}", encodeURIComponent("" + scope));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiLocationGetListByScopeGet(_response);
        });
    }

    protected processApiLocationGetListByScopeGet(response: Response): Promise<LocationListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationListItem[]>(null as any);
    }

    /**
     * Get a cached list of all locations for a given scope.
     * @param scope (optional) The scope to retrieve locations for.
     * @return OK
     */
    apiLocationFontEndGetListGet(scope: LocationTreeLevels | undefined, signal?: AbortSignal): Promise<LocationListItem[]> {
        let url_ = this.baseUrl + "/api/Location/FontEndGetList?";
        if (scope === null)
            throw new Error("The parameter 'scope' cannot be null.");
        else if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiLocationFontEndGetListGet(_response);
        });
    }

    protected processApiLocationFontEndGetListGet(response: Response): Promise<LocationListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationListItem[]>(null as any);
    }

    /**
     * Search for a location.
     * @param query (optional) The search query.
     * @param loctype (optional) The location type.
     * @return OK
     */
    apiLocationSearchLocationGet(query: string | undefined, loctype: string | undefined, signal?: AbortSignal): Promise<LocationDto[]> {
        let url_ = this.baseUrl + "/api/Location/SearchLocation?";
        if (query === null)
            throw new Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (loctype === null)
            throw new Error("The parameter 'loctype' cannot be null.");
        else if (loctype !== undefined)
            url_ += "loctype=" + encodeURIComponent("" + loctype) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiLocationSearchLocationGet(_response);
        });
    }

    protected processApiLocationSearchLocationGet(response: Response): Promise<LocationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationDto[]>(null as any);
    }
}

export class MediaApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Resize a Leo.Domain.Entities.Media.MediaItem.
     * @param mediaId The id of the media
     * @param version The version of the image to retrieve, used as a cache buster when an image is updated.
     * @param resizedOption The crop option
     * @param outputFormat The output format.
     * @param quality (optional) The output quality, 0-100 where 100 is the best quality.
     * @param width (optional) The output width, if left empty a default width (250px) will be used if height is also left empty (max 6000).
     * @param height (optional) The output height, if left empty a default height will be used (max 6000).
     * @param backgroundColor (optional) The background color as a hexidecimal 8 character string (RRGGBBAA) where AA is the alpha value, defaults to black.
     * @param focusX (optional) Horizontal offset, 0 = left, 0.5 = center, 1 = right
     * @param focusY (optional) Vertical offset, 0 = top, 0.5 = center, 1 = bottom.
     * @param preventUpScaling (optional) True to disable up-scaling, false otherwise.
     * @return OK
     */
    mediaResizeMediaByMediaIdByVersionByResizedOptionByOutputFormatGet(mediaId: string, version: number, resizedOption: ImageCropOptions, outputFormat: MediaType, quality: number | undefined, width: number | undefined, height: number | undefined, backgroundColor: string | undefined, focusX: number | undefined, focusY: number | undefined, preventUpScaling: boolean | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/media/ResizeMedia/{mediaId}/{version}/{resizedOption}/{outputFormat}?";
        if (mediaId === undefined || mediaId === null)
            throw new Error("The parameter 'mediaId' must be defined.");
        url_ = url_.replace("{mediaId}", encodeURIComponent("" + mediaId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (resizedOption === undefined || resizedOption === null)
            throw new Error("The parameter 'resizedOption' must be defined.");
        url_ = url_.replace("{resizedOption}", encodeURIComponent("" + resizedOption));
        if (outputFormat === undefined || outputFormat === null)
            throw new Error("The parameter 'outputFormat' must be defined.");
        url_ = url_.replace("{outputFormat}", encodeURIComponent("" + outputFormat));
        if (quality === null)
            throw new Error("The parameter 'quality' cannot be null.");
        else if (quality !== undefined)
            url_ += "quality=" + encodeURIComponent("" + quality) + "&";
        if (width === null)
            throw new Error("The parameter 'width' cannot be null.");
        else if (width !== undefined)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        if (height === null)
            throw new Error("The parameter 'height' cannot be null.");
        else if (height !== undefined)
            url_ += "height=" + encodeURIComponent("" + height) + "&";
        if (backgroundColor === null)
            throw new Error("The parameter 'backgroundColor' cannot be null.");
        else if (backgroundColor !== undefined)
            url_ += "backgroundColor=" + encodeURIComponent("" + backgroundColor) + "&";
        if (focusX === null)
            throw new Error("The parameter 'focusX' cannot be null.");
        else if (focusX !== undefined)
            url_ += "focusX=" + encodeURIComponent("" + focusX) + "&";
        if (focusY === null)
            throw new Error("The parameter 'focusY' cannot be null.");
        else if (focusY !== undefined)
            url_ += "focusY=" + encodeURIComponent("" + focusY) + "&";
        if (preventUpScaling === null)
            throw new Error("The parameter 'preventUpScaling' cannot be null.");
        else if (preventUpScaling !== undefined)
            url_ += "preventUpScaling=" + encodeURIComponent("" + preventUpScaling) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMediaResizeMediaByMediaIdByVersionByResizedOptionByOutputFormatGet(_response);
        });
    }

    protected processMediaResizeMediaByMediaIdByVersionByResizedOptionByOutputFormatGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OpeningHoursApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get opening hours for a location
     * @param location (optional) The location to fetch opening hours for
     * @param from (optional) From which date to fetch opening hours for
     * @param to (optional) To which date to fetch opening hours for
     * @return OK
     */
    apiOpeninghoursOverviewGet(location: string | undefined, from: Date | undefined, to: Date | undefined, signal?: AbortSignal): Promise<OpeningHoursDto[]> {
        let url_ = this.baseUrl + "/api/openinghours/overview?";
        if (location === null)
            throw new Error("The parameter 'location' cannot be null.");
        else if (location !== undefined)
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiOpeninghoursOverviewGet(_response);
        });
    }

    protected processApiOpeninghoursOverviewGet(response: Response): Promise<OpeningHoursDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OpeningHoursDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OpeningHoursDto[]>(null as any);
    }

    /**
     * Get opening hours for the upcoming week for a location
     * @param locationId (optional) The location id to fetch opening hours for
     * @return OK
     */
    apiOpeninghoursOverviewwpGet(locationId: string | undefined, signal?: AbortSignal): Promise<OpeningHoursDto[]> {
        let url_ = this.baseUrl + "/api/openinghours/overviewwp?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiOpeninghoursOverviewwpGet(_response);
        });
    }

    protected processApiOpeninghoursOverviewwpGet(response: Response): Promise<OpeningHoursDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OpeningHoursDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OpeningHoursDto[]>(null as any);
    }
}

export class PartyBookingApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    apiPartyBookingGetByIdGet(id: string, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingGetByIdGet(_response);
        });
    }

    protected processApiPartyBookingGetByIdGet(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * Remind all guests that have yet to answer the invitation.
     * @param bookingId The party booking id.
     * @return OK
     */
    apiPartyBookingRemindPendingGuestsByBookingIdPost(bookingId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/party/booking/RemindPendingGuests/{bookingId}";
        if (bookingId === undefined || bookingId === null)
            throw new Error("The parameter 'bookingId' must be defined.");
        url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingRemindPendingGuestsByBookingIdPost(_response);
        });
    }

    protected processApiPartyBookingRemindPendingGuestsByBookingIdPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingRemindGuestPost(body: RemindGuestDto | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/party/booking/RemindGuest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingRemindGuestPost(_response);
        });
    }

    protected processApiPartyBookingRemindGuestPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Remind a specific guest.
     * @param body (optional) The remind model.
     * @return OK
     */
    apiPartyBookingSendPartyInvitesPost(body: RemindGuestDto | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/party/booking/SendPartyInvites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingSendPartyInvitesPost(_response);
        });
    }

    protected processApiPartyBookingSendPartyInvitesPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingMakeReservationPost(body: PartyReservationMakeRequestDto | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/MakeReservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingMakeReservationPost(_response);
        });
    }

    protected processApiPartyBookingMakeReservationPost(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingChangeReservationPut(body: PartyReservationChangeRequestDto | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/ChangeReservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingChangeReservationPut(_response);
        });
    }

    protected processApiPartyBookingChangeReservationPut(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingChangeBackgroundPut(body: PartyBookingChangeBackgroundDto | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/ChangeBackground";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingChangeBackgroundPut(_response);
        });
    }

    protected processApiPartyBookingChangeBackgroundPut(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingChangePut(body: PartyBookingChangeRequestDto | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/Change";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingChangePut(_response);
        });
    }

    protected processApiPartyBookingChangePut(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingConfirmDateChangePut(body: PartyBookingChangeRequestDto | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/ConfirmDateChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingConfirmDateChangePut(_response);
        });
    }

    protected processApiPartyBookingConfirmDateChangePut(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * Cancel a party booking.
     * @param body What party and why do we want to cancel.
     * @return No Content
     */
    apiPartyBookingCancelPut(body: CancelPartyBookingCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/party/booking/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingCancelPut(_response);
        });
    }

    protected processApiPartyBookingCancelPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Set the booking articles for a booking.
     * @param confirmdirect (optional) Temporary parameter while changing confirmation flow
     * @param body (optional) The dto containing the requested changes.
     * @return OK
     */
    apiPartyBookingSetBookingArticlesPost(confirmdirect: boolean | undefined, body: BookingArticlesRequestDto | undefined, signal?: AbortSignal): Promise<BookingArticlesResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/SetBookingArticles?";
        if (confirmdirect === null)
            throw new Error("The parameter 'confirmdirect' cannot be null.");
        else if (confirmdirect !== undefined)
            url_ += "confirmdirect=" + encodeURIComponent("" + confirmdirect) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingSetBookingArticlesPost(_response);
        });
    }

    protected processApiPartyBookingSetBookingArticlesPost(response: Response): Promise<BookingArticlesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingArticlesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookingArticlesResponseDto>(null as any);
    }

    /**
     * Fetches information when the party booking opens up for new bookings.
     * @param playgroundId The playground id to fetch information for.
     * @return OK
     */
    apiPartyBookingOpeningInfoByPlaygroundIdGet(playgroundId: string, signal?: AbortSignal): Promise<PartyBookingOpeningInfoDto> {
        let url_ = this.baseUrl + "/api/party/booking/OpeningInfo/{playgroundId}";
        if (playgroundId === undefined || playgroundId === null)
            throw new Error("The parameter 'playgroundId' must be defined.");
        url_ = url_.replace("{playgroundId}", encodeURIComponent("" + playgroundId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingOpeningInfoByPlaygroundIdGet(_response);
        });
    }

    protected processApiPartyBookingOpeningInfoByPlaygroundIdGet(response: Response): Promise<PartyBookingOpeningInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingOpeningInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingOpeningInfoDto>(null as any);
    }

    /**
     * @param playgroundid (optional) 
     * @param daysforward (optional) 
     * @param fromdate (optional) 
     * @param changebookingid (optional) 
     * @param showrealstatus (optional) 
     * @return OK
     */
    apiPartyBookingFindFreeDatesGet(playgroundid: string | undefined, daysforward: number | undefined, fromdate: string | undefined, changebookingid: string | undefined, showrealstatus: boolean | undefined, signal?: AbortSignal): Promise<FreeDatesCollectionDto> {
        let url_ = this.baseUrl + "/api/party/booking/FindFreeDates?";
        if (playgroundid === null)
            throw new Error("The parameter 'playgroundid' cannot be null.");
        else if (playgroundid !== undefined)
            url_ += "playgroundid=" + encodeURIComponent("" + playgroundid) + "&";
        if (daysforward === null)
            throw new Error("The parameter 'daysforward' cannot be null.");
        else if (daysforward !== undefined)
            url_ += "daysforward=" + encodeURIComponent("" + daysforward) + "&";
        if (fromdate === null)
            throw new Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent("" + fromdate) + "&";
        if (changebookingid === null)
            throw new Error("The parameter 'changebookingid' cannot be null.");
        else if (changebookingid !== undefined)
            url_ += "changebookingid=" + encodeURIComponent("" + changebookingid) + "&";
        if (showrealstatus === null)
            throw new Error("The parameter 'showrealstatus' cannot be null.");
        else if (showrealstatus !== undefined)
            url_ += "showrealstatus=" + encodeURIComponent("" + showrealstatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingFindFreeDatesGet(_response);
        });
    }

    protected processApiPartyBookingFindFreeDatesGet(response: Response): Promise<FreeDatesCollectionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FreeDatesCollectionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FreeDatesCollectionDto>(null as any);
    }

    /**
     * Retrieve configuration for party location
     * @param playgroundId (optional) The playground to retrieve the setting for
     * @return OK
     */
    apiPartyBookingPartyLocationConfigurationGet(playgroundId: string | undefined, signal?: AbortSignal): Promise<PartyLocationConfigurationDto> {
        let url_ = this.baseUrl + "/api/party/booking/PartyLocationConfiguration?";
        if (playgroundId === null)
            throw new Error("The parameter 'playgroundId' cannot be null.");
        else if (playgroundId !== undefined)
            url_ += "playgroundId=" + encodeURIComponent("" + playgroundId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingPartyLocationConfigurationGet(_response);
        });
    }

    protected processApiPartyBookingPartyLocationConfigurationGet(response: Response): Promise<PartyLocationConfigurationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyLocationConfigurationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyLocationConfigurationDto>(null as any);
    }

    /**
     * Get a list of distributions of play time for a party
     * @param playgroundid (optional) The playground to retrieve play times for
     * @param partyDate (optional) The date of the party
     * @param partyLengthMinutes (optional) The duration of the party in minutes (play time + party room)
     * @param timeSlotId (optional) The selected time slot for the party
     * @return OK
     */
    apiPartyBookingPlaytimesGet(playgroundid: string | undefined, partyDate: Date | undefined, partyLengthMinutes: number | undefined, timeSlotId: string | undefined, signal?: AbortSignal): Promise<PartyBookingPlayTime[]> {
        let url_ = this.baseUrl + "/api/party/booking/Playtimes?";
        if (playgroundid === null)
            throw new Error("The parameter 'playgroundid' cannot be null.");
        else if (playgroundid !== undefined)
            url_ += "playgroundid=" + encodeURIComponent("" + playgroundid) + "&";
        if (partyDate === null)
            throw new Error("The parameter 'partyDate' cannot be null.");
        else if (partyDate !== undefined)
            url_ += "partyDate=" + encodeURIComponent(partyDate ? "" + partyDate.toISOString() : "") + "&";
        if (partyLengthMinutes === null)
            throw new Error("The parameter 'partyLengthMinutes' cannot be null.");
        else if (partyLengthMinutes !== undefined)
            url_ += "partyLengthMinutes=" + encodeURIComponent("" + partyLengthMinutes) + "&";
        if (timeSlotId === null)
            throw new Error("The parameter 'timeSlotId' cannot be null.");
        else if (timeSlotId !== undefined)
            url_ += "timeSlotId=" + encodeURIComponent("" + timeSlotId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingPlaytimesGet(_response);
        });
    }

    protected processApiPartyBookingPlaytimesGet(response: Response): Promise<PartyBookingPlayTime[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartyBookingPlayTime.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingPlayTime[]>(null as any);
    }

    /**
     * Removes the invite and any associated guest specified by the invite id.
     * @param inviteid (optional) The guid of the invite to remove
     * @return OK
     */
    apiPartyBookingRemoveInviteDelete(inviteid: string | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/RemoveInvite?";
        if (inviteid === null)
            throw new Error("The parameter 'inviteid' cannot be null.");
        else if (inviteid !== undefined)
            url_ += "inviteid=" + encodeURIComponent("" + inviteid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingRemoveInviteDelete(_response);
        });
    }

    protected processApiPartyBookingRemoveInviteDelete(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingCreateInvitePost(body: InviteCreateNewDto | undefined, signal?: AbortSignal): Promise<InviteDto> {
        let url_ = this.baseUrl + "/api/party/booking/CreateInvite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingCreateInvitePost(_response);
        });
    }

    protected processApiPartyBookingCreateInvitePost(response: Response): Promise<InviteDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InviteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InviteDto>(null as any);
    }

    /**
     * Changes the number of guests for a booking.
     * @param confirmdirect (optional) Temporary parameter while changing confirmation flow
     * @param body (optional) The change number dto.
     * @return OK
     */
    apiPartyBookingChangeNumberOfGuestsPost(confirmdirect: boolean | undefined, body: ChangeNumberOfGuestsDto | undefined, signal?: AbortSignal): Promise<GuestDto[]> {
        let url_ = this.baseUrl + "/api/party/booking/ChangeNumberOfGuests?";
        if (confirmdirect === null)
            throw new Error("The parameter 'confirmdirect' cannot be null.");
        else if (confirmdirect !== undefined)
            url_ += "confirmdirect=" + encodeURIComponent("" + confirmdirect) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingChangeNumberOfGuestsPost(_response);
        });
    }

    protected processApiPartyBookingChangeNumberOfGuestsPost(response: Response): Promise<GuestDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuestDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GuestDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingSaveGuestPost(body: GuestDto | undefined, signal?: AbortSignal): Promise<GuestDto> {
        let url_ = this.baseUrl + "/api/party/booking/SaveGuest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingSaveGuestPost(_response);
        });
    }

    protected processApiPartyBookingSaveGuestPost(response: Response): Promise<GuestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GuestDto>(null as any);
    }

    /**
     * @return OK
     */
    apiPartyBookingGetGuestByIdGet(id: string, signal?: AbortSignal): Promise<GuestDto> {
        let url_ = this.baseUrl + "/api/party/booking/GetGuest/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingGetGuestByIdGet(_response);
        });
    }

    protected processApiPartyBookingGetGuestByIdGet(response: Response): Promise<GuestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GuestDto>(null as any);
    }

    /**
     * @param onlyConfirmed (optional) 
     * @return OK
     */
    apiPartyBookingMyBookingsGet(onlyConfirmed: boolean | undefined, signal?: AbortSignal): Promise<PartyBookingListDto> {
        let url_ = this.baseUrl + "/api/party/booking/MyBookings?";
        if (onlyConfirmed === null)
            throw new Error("The parameter 'onlyConfirmed' cannot be null.");
        else if (onlyConfirmed !== undefined)
            url_ += "onlyConfirmed=" + encodeURIComponent("" + onlyConfirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingMyBookingsGet(_response);
        });
    }

    protected processApiPartyBookingMyBookingsGet(response: Response): Promise<PartyBookingListDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingListDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingListDto>(null as any);
    }

    /**
     * Returns all the available invitation backgrounds for a specific playground.
     * @param id The id of the playground.
     * @return OK
     */
    apiPartyBookingGetInvitationBackgroundsByIdGet(id: string, signal?: AbortSignal): Promise<InvitationBackgroundDto[]> {
        let url_ = this.baseUrl + "/api/party/booking/GetInvitationBackgrounds/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingGetInvitationBackgroundsByIdGet(_response);
        });
    }

    protected processApiPartyBookingGetInvitationBackgroundsByIdGet(response: Response): Promise<InvitationBackgroundDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvitationBackgroundDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvitationBackgroundDto[]>(null as any);
    }

    /**
     * @param invitationid (optional) 
     * @param invitationkey (optional) 
     * @return OK
     */
    apiPartyBookingGetInviteGet(invitationid: string | undefined, invitationkey: string | undefined, signal?: AbortSignal): Promise<InviteDto> {
        let url_ = this.baseUrl + "/api/party/booking/GetInvite?";
        if (invitationid === null)
            throw new Error("The parameter 'invitationid' cannot be null.");
        else if (invitationid !== undefined)
            url_ += "invitationid=" + encodeURIComponent("" + invitationid) + "&";
        if (invitationkey === null)
            throw new Error("The parameter 'invitationkey' cannot be null.");
        else if (invitationkey !== undefined)
            url_ += "invitationkey=" + encodeURIComponent("" + invitationkey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingGetInviteGet(_response);
        });
    }

    protected processApiPartyBookingGetInviteGet(response: Response): Promise<InviteDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InviteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InviteDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingConfirmGuestAttendencePost(body: GuestAttendenceDto | undefined, signal?: AbortSignal): Promise<BoolResultDto> {
        let url_ = this.baseUrl + "/api/party/booking/ConfirmGuestAttendence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingConfirmGuestAttendencePost(_response);
        });
    }

    protected processApiPartyBookingConfirmGuestAttendencePost(response: Response): Promise<BoolResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BoolResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoolResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingAnswerInvitePost(body: InviteAnswerDto | undefined, signal?: AbortSignal): Promise<GuestDto> {
        let url_ = this.baseUrl + "/api/party/booking/AnswerInvite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingAnswerInvitePost(_response);
        });
    }

    protected processApiPartyBookingAnswerInvitePost(response: Response): Promise<GuestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GuestDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingConfirmBookingPost(body: PartyBookingConfirmRequestDto | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/ConfirmBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingConfirmBookingPost(_response);
        });
    }

    protected processApiPartyBookingConfirmBookingPost(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingConfirmBookingChangesPost(body: PartyBookingConfirmRequestDto | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/ConfirmBookingChanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingConfirmBookingChangesPost(_response);
        });
    }

    protected processApiPartyBookingConfirmBookingChangesPost(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * Cancels any pending booking changes on the booking.
     * @param id The id of the booking.
     * @return OK
     */
    apiPartyBookingCancelBookingChangesByIdDelete(id: string, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/CancelBookingChanges/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingCancelBookingChangesByIdDelete(_response);
        });
    }

    protected processApiPartyBookingCancelBookingChangesByIdDelete(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * @param bookingid (optional) 
     * @return OK
     */
    apiPartyBookingSetOwnerPost(bookingid: string | null | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/SetOwner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (bookingid !== null && bookingid !== undefined)
            content_.append("bookingid", bookingid.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingSetOwnerPost(_response);
        });
    }

    protected processApiPartyBookingSetOwnerPost(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    apiPartyBookingTestPutPut(signal?: AbortSignal): Promise<BoolResultDto> {
        let url_ = this.baseUrl + "/api/party/booking/TestPut";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingTestPutPut(_response);
        });
    }

    protected processApiPartyBookingTestPutPut(response: Response): Promise<BoolResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BoolResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoolResultDto>(null as any);
    }

    /**
     * @return OK
     */
    apiPartyBookingTestDeleteDelete(signal?: AbortSignal): Promise<BoolResultDto> {
        let url_ = this.baseUrl + "/api/party/booking/TestDelete";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingTestDeleteDelete(_response);
        });
    }

    protected processApiPartyBookingTestDeleteDelete(response: Response): Promise<BoolResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BoolResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoolResultDto>(null as any);
    }
}

export class PartyPackageApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param locationId (optional) 
     * @param date (optional) 
     * @param bookingDate (optional) 
     * @return OK
     */
    apiPartyPackageGetByIdGet(id: string, locationId: string | undefined, date: string | undefined, bookingDate: string | undefined, signal?: AbortSignal): Promise<PartyPackageDto> {
        let url_ = this.baseUrl + "/api/party/package/Get/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (bookingDate === null)
            throw new Error("The parameter 'bookingDate' cannot be null.");
        else if (bookingDate !== undefined)
            url_ += "bookingDate=" + encodeURIComponent("" + bookingDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyPackageGetByIdGet(_response);
        });
    }

    protected processApiPartyPackageGetByIdGet(response: Response): Promise<PartyPackageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyPackageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyPackageDto>(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param date (optional) 
     * @param bookingDate (optional) 
     * @return OK
     */
    apiPartyPackageListPackagesGet(locationId: string | undefined, date: string | undefined, bookingDate: string | undefined, signal?: AbortSignal): Promise<PartyPackageDto[]> {
        let url_ = this.baseUrl + "/api/party/package/ListPackages?";
        if (locationId === null)
            throw new Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (bookingDate === null)
            throw new Error("The parameter 'bookingDate' cannot be null.");
        else if (bookingDate !== undefined)
            url_ += "bookingDate=" + encodeURIComponent("" + bookingDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyPackageListPackagesGet(_response);
        });
    }

    protected processApiPartyPackageListPackagesGet(response: Response): Promise<PartyPackageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartyPackageDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyPackageDto[]>(null as any);
    }
}

export class PassArticlesApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve a shop card article.
     * @param id The id of the article to retrieve.
     * @return OK
     */
    apiShopPassArticlesByIdGet(id: number, signal?: AbortSignal): Promise<SellablePassArticleModel> {
        let url_ = this.baseUrl + "/api/shop/pass-articles/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassArticlesByIdGet(_response);
        });
    }

    protected processApiShopPassArticlesByIdGet(response: Response): Promise<SellablePassArticleModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SellablePassArticleModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellablePassArticleModel>(null as any);
    }

    /**
     * Retrieve all available, active, shop card articles by location.
    Result is cached for 10 minutes.
     * @param locationId The location to get the cards for.
     * @return OK
     */
    apiShopPassArticlesByLocationByLocationIdGet(locationId: string, signal?: AbortSignal): Promise<PassArticleSummaryDto[]> {
        let url_ = this.baseUrl + "/api/shop/pass-articles/by-location/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassArticlesByLocationByLocationIdGet(_response);
        });
    }

    protected processApiShopPassArticlesByLocationByLocationIdGet(response: Response): Promise<PassArticleSummaryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PassArticleSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassArticleSummaryDto[]>(null as any);
    }

    /**
     * Retrieve information about children that are and are not selectable for the given article.
    The children are returned for the currently authenticated user.
     * @param id The id of the article to retrieve the children for.
     * @return OK
     */
    apiShopPassArticlesByIdChildSummariesGet(id: number, signal?: AbortSignal): Promise<PassArticleChildSummaryDto[]> {
        let url_ = this.baseUrl + "/api/shop/pass-articles/{id}/child-summaries";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassArticlesByIdChildSummariesGet(_response);
        });
    }

    protected processApiShopPassArticlesByIdChildSummariesGet(response: Response): Promise<PassArticleChildSummaryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PassArticleChildSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassArticleChildSummaryDto[]>(null as any);
    }
}

export class PassOrderApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create a new order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopPassOrdersDirectPost(body: CreateDirectPassOrderCommand | undefined, signal?: AbortSignal): Promise<PassOrderPaymentModel> {
        let url_ = this.baseUrl + "/api/shop/pass-orders/direct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassOrdersDirectPost(_response);
        });
    }

    protected processApiShopPassOrdersDirectPost(response: Response): Promise<PassOrderPaymentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassOrderPaymentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassOrderPaymentModel>(null as any);
    }

    /**
     * Create a new order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopPassOrdersRedeemPost(body: CreateRedeemPassOrderCommand | undefined, signal?: AbortSignal): Promise<PassOrderPaymentModel> {
        let url_ = this.baseUrl + "/api/shop/pass-orders/redeem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassOrdersRedeemPost(_response);
        });
    }

    protected processApiShopPassOrdersRedeemPost(response: Response): Promise<PassOrderPaymentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassOrderPaymentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassOrderPaymentModel>(null as any);
    }

    /**
     * Get an order summary for a direct order, without placing an order.
    This endpoint should be called before creating an order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopPassOrdersDirectSummaryPost(body: GetDirectPassOrderSummaryQuery | undefined, signal?: AbortSignal): Promise<PassDirectOrderSummaryDto> {
        let url_ = this.baseUrl + "/api/shop/pass-orders/direct/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassOrdersDirectSummaryPost(_response);
        });
    }

    protected processApiShopPassOrdersDirectSummaryPost(response: Response): Promise<PassDirectOrderSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassDirectOrderSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassDirectOrderSummaryDto>(null as any);
    }

    /**
     * Get an order summary for a redeem order, without placing an order.
    This endpoint should be called before creating an order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopPassOrdersRedeemSummaryPost(body: GetRedeemPassOrderSummaryQuery | undefined, signal?: AbortSignal): Promise<PassRedeemOrderSummaryDto> {
        let url_ = this.baseUrl + "/api/shop/pass-orders/redeem/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassOrdersRedeemSummaryPost(_response);
        });
    }

    protected processApiShopPassOrdersRedeemSummaryPost(response: Response): Promise<PassRedeemOrderSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassRedeemOrderSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassRedeemOrderSummaryDto>(null as any);
    }

    /**
     * Retrieve the payment status of an order.
     * @param orderReference The order reference.
     * @return OK
     */
    apiShopPassOrdersByOrderReferenceStatusGet(orderReference: string, signal?: AbortSignal): Promise<PassOrderPaymentStatus> {
        let url_ = this.baseUrl + "/api/shop/pass-orders/{orderReference}/status";
        if (orderReference === undefined || orderReference === null)
            throw new Error("The parameter 'orderReference' must be defined.");
        url_ = url_.replace("{orderReference}", encodeURIComponent("" + orderReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassOrdersByOrderReferenceStatusGet(_response);
        });
    }

    protected processApiShopPassOrdersByOrderReferenceStatusGet(response: Response): Promise<PassOrderPaymentStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassOrderPaymentStatus>(null as any);
    }

    /**
     * Retrieve the tracking event of an order.
     * @param orderReference The order reference.
     * @return OK
     */
    apiShopPassOrdersByOrderReferenceTrackingEventGet(orderReference: string, signal?: AbortSignal): Promise<ShopPurchaseEvent> {
        let url_ = this.baseUrl + "/api/shop/pass-orders/{orderReference}/tracking-event";
        if (orderReference === undefined || orderReference === null)
            throw new Error("The parameter 'orderReference' must be defined.");
        url_ = url_.replace("{orderReference}", encodeURIComponent("" + orderReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassOrdersByOrderReferenceTrackingEventGet(_response);
        });
    }

    protected processApiShopPassOrdersByOrderReferenceTrackingEventGet(response: Response): Promise<ShopPurchaseEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShopPurchaseEvent.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShopPurchaseEvent>(null as any);
    }

    /**
     * Check if a photo can be uploaded for a direct pass order.
     * @param orderReference The order reference.
     * @return OK
     */
    apiShopPassOrdersByOrderReferencePhotoUploadStatusGet(orderReference: string, signal?: AbortSignal): Promise<PassPhotoUploadStatusDto> {
        let url_ = this.baseUrl + "/api/shop/pass-orders/{orderReference}/photo-upload-status";
        if (orderReference === undefined || orderReference === null)
            throw new Error("The parameter 'orderReference' must be defined.");
        url_ = url_.replace("{orderReference}", encodeURIComponent("" + orderReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassOrdersByOrderReferencePhotoUploadStatusGet(_response);
        });
    }

    protected processApiShopPassOrdersByOrderReferencePhotoUploadStatusGet(response: Response): Promise<PassPhotoUploadStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassPhotoUploadStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassPhotoUploadStatusDto>(null as any);
    }
}

export class PassRedeemApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create a new session for redeeming a pass.
     * @param body The redeem code to create the session for.
     * @return Created
     */
    apiPassRedeemByCodeSessionPost(body: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/pass-redeem/by-code/session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPassRedeemByCodeSessionPost(_response);
        });
    }

    protected processApiPassRedeemByCodeSessionPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get a redeem summary before performing a redeem.
    The summary contains information about what will be redeemed.
     * @param sessionId An active redeem session id.
     * @return OK
     */
    apiPassRedeemBySessionBySessionIdGet(sessionId: string, signal?: AbortSignal): Promise<PassRedeemInformationModel> {
        let url_ = this.baseUrl + "/api/pass-redeem/by-session/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPassRedeemBySessionBySessionIdGet(_response);
        });
    }

    protected processApiPassRedeemBySessionBySessionIdGet(response: Response): Promise<PassRedeemInformationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassRedeemInformationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassRedeemInformationModel>(null as any);
    }

    /**
     * Get a redeem summary before performing a redeem.
    The summary contains information about what will be redeemed.
     * @param sessionId An active redeem session id.
     * @param childId The child that the pass will later be connected to after a redeem.
     * @return OK
     */
    apiPassRedeemBySessionBySessionIdChildByChildIdSummaryGet(sessionId: string, childId: string, signal?: AbortSignal): Promise<PassRedeemSummaryDto> {
        let url_ = this.baseUrl + "/api/pass-redeem/by-session/{sessionId}/child/{childId}/summary";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (childId === undefined || childId === null)
            throw new Error("The parameter 'childId' must be defined.");
        url_ = url_.replace("{childId}", encodeURIComponent("" + childId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPassRedeemBySessionBySessionIdChildByChildIdSummaryGet(_response);
        });
    }

    protected processApiPassRedeemBySessionBySessionIdChildByChildIdSummaryGet(response: Response): Promise<PassRedeemSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassRedeemSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassRedeemSummaryDto>(null as any);
    }

    /**
     * Perform a redeem of a pass.
     * @param sessionId An active redeem session id.
     * @param body The child that the pass should be created for.
     * @return Created
     */
    apiPassRedeemBySessionBySessionIdRedeemPost(sessionId: string, body: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/pass-redeem/by-session/{sessionId}/redeem";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPassRedeemBySessionBySessionIdRedeemPost(_response);
        });
    }

    protected processApiPassRedeemBySessionBySessionIdRedeemPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PlaygroundApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    apiPlaygroundGetByIdGet(id: string, signal?: AbortSignal): Promise<PlaygroundDto> {
        let url_ = this.baseUrl + "/api/playground/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPlaygroundGetByIdGet(_response);
        });
    }

    protected processApiPlaygroundGetByIdGet(response: Response): Promise<PlaygroundDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlaygroundDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaygroundDto>(null as any);
    }

    /**
     * @return OK
     */
    apiPlaygroundListByParentGet(parent: string, signal?: AbortSignal): Promise<PlaygroundDto[]> {
        let url_ = this.baseUrl + "/api/playground/List/{parent}";
        if (parent === undefined || parent === null)
            throw new Error("The parameter 'parent' must be defined.");
        url_ = url_.replace("{parent}", encodeURIComponent("" + parent));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPlaygroundListByParentGet(_response);
        });
    }

    protected processApiPlaygroundListByParentGet(response: Response): Promise<PlaygroundDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaygroundDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaygroundDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiPlaygroundListByCountryByCountryGet(country: string, signal?: AbortSignal): Promise<PlaygroundDto[]> {
        let url_ = this.baseUrl + "/api/playground/ListByCountry/{country}";
        if (country === undefined || country === null)
            throw new Error("The parameter 'country' must be defined.");
        url_ = url_.replace("{country}", encodeURIComponent("" + country));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPlaygroundListByCountryByCountryGet(_response);
        });
    }

    protected processApiPlaygroundListByCountryByCountryGet(response: Response): Promise<PlaygroundDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaygroundDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaygroundDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiPlaygroundListAllPlaygroundsGet(signal?: AbortSignal): Promise<PlaygroundDto[]> {
        let url_ = this.baseUrl + "/api/playground/ListAllPlaygrounds";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPlaygroundListAllPlaygroundsGet(_response);
        });
    }

    protected processApiPlaygroundListAllPlaygroundsGet(response: Response): Promise<PlaygroundDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaygroundDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaygroundDto[]>(null as any);
    }
}

export class RegionApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    apiRegionGetByIdGet(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Region/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiRegionGetByIdGet(_response);
        });
    }

    protected processApiRegionGetByIdGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    apiRegionListByParentGet(parent: string, signal?: AbortSignal): Promise<RegionDto[]> {
        let url_ = this.baseUrl + "/api/Region/List/{parent}";
        if (parent === undefined || parent === null)
            throw new Error("The parameter 'parent' must be defined.");
        url_ = url_.replace("{parent}", encodeURIComponent("" + parent));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiRegionListByParentGet(_response);
        });
    }

    protected processApiRegionListByParentGet(response: Response): Promise<RegionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegionDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegionDto[]>(null as any);
    }
}

export class RoomApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    apiRoomGetByIdGet(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Room/Get/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiRoomGetByIdGet(_response);
        });
    }

    protected processApiRoomGetByIdGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    apiRoomListByPlaygroundByPlaygroundidGet(playgroundid: string, signal?: AbortSignal): Promise<RoomDto[]> {
        let url_ = this.baseUrl + "/api/Room/ListByPlayground/{playgroundid}";
        if (playgroundid === undefined || playgroundid === null)
            throw new Error("The parameter 'playgroundid' must be defined.");
        url_ = url_.replace("{playgroundid}", encodeURIComponent("" + playgroundid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiRoomListByPlaygroundByPlaygroundidGet(_response);
        });
    }

    protected processApiRoomListByPlaygroundByPlaygroundidGet(response: Response): Promise<RoomDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoomDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiRoomListByParentGet(parent: string, signal?: AbortSignal): Promise<RoomDto[]> {
        let url_ = this.baseUrl + "/api/Room/List/{parent}";
        if (parent === undefined || parent === null)
            throw new Error("The parameter 'parent' must be defined.");
        url_ = url_.replace("{parent}", encodeURIComponent("" + parent));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiRoomListByParentGet(_response);
        });
    }

    protected processApiRoomListByParentGet(response: Response): Promise<RoomDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoomDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiRoomGetThemesGet(signal?: AbortSignal): Promise<RoomThemeDto[]> {
        let url_ = this.baseUrl + "/api/Room/GetThemes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiRoomGetThemesGet(_response);
        });
    }

    protected processApiRoomGetThemesGet(response: Response): Promise<RoomThemeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoomThemeDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomThemeDto[]>(null as any);
    }
}

export class SerialTicketApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve a serial ticket by id.
     * @param ticketId The id of the serial ticket to retrieve.
     * @return OK
     */
    apiSerialTicketsByTicketIdGet(ticketId: string, signal?: AbortSignal): Promise<SerialTicketModel> {
        let url_ = this.baseUrl + "/api/serial-tickets/{ticketId}";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiSerialTicketsByTicketIdGet(_response);
        });
    }

    protected processApiSerialTicketsByTicketIdGet(response: Response): Promise<SerialTicketModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SerialTicketModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SerialTicketModel>(null as any);
    }

    /**
     * Retrieve a list of a users serial tickets.
     * @return OK
     */
    apiSerialTicketsByUserGet(signal?: AbortSignal): Promise<SerialTicketModel[]> {
        let url_ = this.baseUrl + "/api/serial-tickets/by-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiSerialTicketsByUserGet(_response);
        });
    }

    protected processApiSerialTicketsByUserGet(response: Response): Promise<SerialTicketModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SerialTicketModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SerialTicketModel[]>(null as any);
    }
}

export class SerialTicketConnectAccountApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create a new session for connecting a serial ticket to account
     * @param body The connect parameters.
     * @return Created
     */
    apiConnectSerialTicketByNumberSessionPost(body: CreateConnectToAccountSessionCommand, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/connect-serial-ticket/by-number/session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiConnectSerialTicketByNumberSessionPost(_response);
        });
    }

    protected processApiConnectSerialTicketByNumberSessionPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get information for connecting serial ticket to an account.
     * @param sessionId The id of the session.
     * @return OK
     */
    apiConnectSerialTicketBySessionBySessionIdGet(sessionId: string, signal?: AbortSignal): Promise<SerialTicketConnectToAccountInformationModel> {
        let url_ = this.baseUrl + "/api/connect-serial-ticket/by-session/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiConnectSerialTicketBySessionBySessionIdGet(_response);
        });
    }

    protected processApiConnectSerialTicketBySessionBySessionIdGet(response: Response): Promise<SerialTicketConnectToAccountInformationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SerialTicketConnectToAccountInformationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SerialTicketConnectToAccountInformationModel>(null as any);
    }

    /**
     * Connect a serial ticket to an account
     * @param sessionId An active connect to account session id.
     * @return Created
     */
    apiConnectSerialTicketBySessionBySessionIdConnectPost(sessionId: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/connect-serial-ticket/by-session/{sessionId}/connect";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiConnectSerialTicketBySessionBySessionIdConnectPost(_response);
        });
    }

    protected processApiConnectSerialTicketBySessionBySessionIdConnectPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : <any>null;
    
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get information for confirmation of connected serial ticket.
     * @param ticketId The id of the connected serial ticket.
     * @return OK
     */
    apiConnectSerialTicketByIdByTicketIdConfirmationGet(ticketId: string, signal?: AbortSignal): Promise<SerialTicketConnectToAccountInformationModel> {
        let url_ = this.baseUrl + "/api/connect-serial-ticket/by-id/{ticketId}/confirmation";
        if (ticketId === undefined || ticketId === null)
            throw new Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiConnectSerialTicketByIdByTicketIdConfirmationGet(_response);
        });
    }

    protected processApiConnectSerialTicketByIdByTicketIdConfirmationGet(response: Response): Promise<SerialTicketConnectToAccountInformationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SerialTicketConnectToAccountInformationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SerialTicketConnectToAccountInformationModel>(null as any);
    }
}

export class SerialTicketOrderApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create a new direct order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopSerialTicketsOrderDirectPost(body: CreateSerialTicketDirectOrderCommand | undefined, signal?: AbortSignal): Promise<SerialTicketOrderPaymentModel> {
        let url_ = this.baseUrl + "/api/shop/serial-tickets/order/direct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopSerialTicketsOrderDirectPost(_response);
        });
    }

    protected processApiShopSerialTicketsOrderDirectPost(response: Response): Promise<SerialTicketOrderPaymentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SerialTicketOrderPaymentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SerialTicketOrderPaymentModel>(null as any);
    }

    /**
     * Create a new redeem order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopSerialTicketsOrderRedeemPost(body: CreateSerialTicketRedeemOrderCommand | undefined, signal?: AbortSignal): Promise<SerialTicketOrderPaymentModel> {
        let url_ = this.baseUrl + "/api/shop/serial-tickets/order/redeem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopSerialTicketsOrderRedeemPost(_response);
        });
    }

    protected processApiShopSerialTicketsOrderRedeemPost(response: Response): Promise<SerialTicketOrderPaymentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SerialTicketOrderPaymentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SerialTicketOrderPaymentModel>(null as any);
    }

    /**
     * Get an order summary for a direct order, without placing an order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopSerialTicketsOrderDirectSummaryPost(body: GetSerialTicketDirectOrderSummaryQuery | undefined, signal?: AbortSignal): Promise<SerialTicketDirectOrderSummaryModel> {
        let url_ = this.baseUrl + "/api/shop/serial-tickets/order/direct/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopSerialTicketsOrderDirectSummaryPost(_response);
        });
    }

    protected processApiShopSerialTicketsOrderDirectSummaryPost(response: Response): Promise<SerialTicketDirectOrderSummaryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SerialTicketDirectOrderSummaryModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SerialTicketDirectOrderSummaryModel>(null as any);
    }

    /**
     * Get an order summary for a redeem order, without placing an order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopSerialTicketsOrderRedeemSummaryPost(body: GetSerialTicketRedeemOrderSummaryQuery | undefined, signal?: AbortSignal): Promise<SerialTicketRedeemOrderSummaryModel> {
        let url_ = this.baseUrl + "/api/shop/serial-tickets/order/redeem/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopSerialTicketsOrderRedeemSummaryPost(_response);
        });
    }

    protected processApiShopSerialTicketsOrderRedeemSummaryPost(response: Response): Promise<SerialTicketRedeemOrderSummaryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SerialTicketRedeemOrderSummaryModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SerialTicketRedeemOrderSummaryModel>(null as any);
    }

    /**
     * Retrieve the payment status of an order.
     * @param orderReference The order reference
     * @return OK
     */
    apiShopSerialTicketsOrderByOrderReferenceStatusGet(orderReference: string, signal?: AbortSignal): Promise<SerialTicketOrderPaymentStatus> {
        let url_ = this.baseUrl + "/api/shop/serial-tickets/order/{orderReference}/status";
        if (orderReference === undefined || orderReference === null)
            throw new Error("The parameter 'orderReference' must be defined.");
        url_ = url_.replace("{orderReference}", encodeURIComponent("" + orderReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopSerialTicketsOrderByOrderReferenceStatusGet(_response);
        });
    }

    protected processApiShopSerialTicketsOrderByOrderReferenceStatusGet(response: Response): Promise<SerialTicketOrderPaymentStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SerialTicketOrderPaymentStatus>(null as any);
    }

    /**
     * Retrieve the tracking event of an order.
     * @param orderReference The order reference.
     * @return OK
     */
    apiShopSerialTicketsOrderByOrderReferenceTrackingEventGet(orderReference: string, signal?: AbortSignal): Promise<ShopPurchaseEvent> {
        let url_ = this.baseUrl + "/api/shop/serial-tickets/order/{orderReference}/tracking-event";
        if (orderReference === undefined || orderReference === null)
            throw new Error("The parameter 'orderReference' must be defined.");
        url_ = url_.replace("{orderReference}", encodeURIComponent("" + orderReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopSerialTicketsOrderByOrderReferenceTrackingEventGet(_response);
        });
    }

    protected processApiShopSerialTicketsOrderByOrderReferenceTrackingEventGet(response: Response): Promise<ShopPurchaseEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShopPurchaseEvent.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShopPurchaseEvent>(null as any);
    }
}

export class ShopSerialTicketsApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve a shop serial ticket article.
     * @param id The id of the article to retrieve.
     * @return OK
     */
    apiShopSerialTicketsByIdGet(id: number, signal?: AbortSignal): Promise<SellableSerialTicketArticleModel> {
        let url_ = this.baseUrl + "/api/shop/serial-tickets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopSerialTicketsByIdGet(_response);
        });
    }

    protected processApiShopSerialTicketsByIdGet(response: Response): Promise<SellableSerialTicketArticleModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SellableSerialTicketArticleModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellableSerialTicketArticleModel>(null as any);
    }

    /**
     * Retrieve all available, active, shop serial ticket articles by country.
     * @param countryId The country to get the serial tickets for.
     * @return OK
     */
    apiShopSerialTicketsByLocationByCountryIdGet(countryId: string, signal?: AbortSignal): Promise<SellableSerialTicketArticleModel[]> {
        let url_ = this.baseUrl + "/api/shop/serial-tickets/by-location/{countryId}";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopSerialTicketsByLocationByCountryIdGet(_response);
        });
    }

    protected processApiShopSerialTicketsByLocationByCountryIdGet(response: Response): Promise<SellableSerialTicketArticleModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SellableSerialTicketArticleModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellableSerialTicketArticleModel[]>(null as any);
    }
}

export class SubscriptionApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve a subscription by id.
     * @param subscriptionId The id of the subscription to retrieve.
     * @return OK
     */
    apiSubscriptionBySubscriptionIdGet(subscriptionId: string, signal?: AbortSignal): Promise<PeriodSubscriptionDto> {
        let url_ = this.baseUrl + "/api/subscription/{subscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiSubscriptionBySubscriptionIdGet(_response);
        });
    }

    protected processApiSubscriptionBySubscriptionIdGet(response: Response): Promise<PeriodSubscriptionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = PeriodSubscriptionDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PeriodSubscriptionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PeriodSubscriptionDto>(null as any);
    }

    /**
     * Retrieve all subscriptions for the currently authenticated user's children for a specific country.
     * @param countryId The id of the country to retrieve subscriptions for.
     * @param activeAt (optional) An optional date to retrieve subscriptions for, this will check validity of the subscriptions for the given date.
     * @param skipSync (optional) True to skip retrieving the latest subscriptions.
     * @return OK
     */
    apiSubscriptionByCountryByCountryIdGet(countryId: string, activeAt: Date | undefined, skipSync: boolean | undefined, signal?: AbortSignal): Promise<PeriodSubscriptionSummaryDto> {
        let url_ = this.baseUrl + "/api/subscription/by-country/{countryId}?";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        if (activeAt === null)
            throw new Error("The parameter 'activeAt' cannot be null.");
        else if (activeAt !== undefined)
            url_ += "activeAt=" + encodeURIComponent(activeAt ? "" + activeAt.toISOString() : "") + "&";
        if (skipSync === null)
            throw new Error("The parameter 'skipSync' cannot be null.");
        else if (skipSync !== undefined)
            url_ += "skipSync=" + encodeURIComponent("" + skipSync) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiSubscriptionByCountryByCountryIdGet(_response);
        });
    }

    protected processApiSubscriptionByCountryByCountryIdGet(response: Response): Promise<PeriodSubscriptionSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PeriodSubscriptionSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PeriodSubscriptionSummaryDto>(null as any);
    }

    /**
     * Retrieve all subscriptions for the currently authenticated user's children.
    The subscriptions are always synced from NAV to database before being returned.
     * @return OK
     */
    apiSubscriptionAllGet(signal?: AbortSignal): Promise<PeriodSubscriptionSummaryDto> {
        let url_ = this.baseUrl + "/api/subscription/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiSubscriptionAllGet(_response);
        });
    }

    protected processApiSubscriptionAllGet(response: Response): Promise<PeriodSubscriptionSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PeriodSubscriptionSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PeriodSubscriptionSummaryDto>(null as any);
    }

    /**
     * Retrieve all subscriptions for the given child.
     * @param childId The id of the child to get subscriptions for.
     * @param countryId (optional) The id of the country to get subscriptions for.
     * @param activeAt (optional) An optional date to retrieve subscriptions for, this will check validity of the subscriptions for the given date.
     * @return OK
     */
    apiSubscriptionByChildByChildIdGet(childId: string, countryId: string | undefined, activeAt: Date | undefined, signal?: AbortSignal): Promise<PeriodSubscriptionSummaryDto> {
        let url_ = this.baseUrl + "/api/subscription/by-child/{childId}?";
        if (childId === undefined || childId === null)
            throw new Error("The parameter 'childId' must be defined.");
        url_ = url_.replace("{childId}", encodeURIComponent("" + childId));
        if (countryId === null)
            throw new Error("The parameter 'countryId' cannot be null.");
        else if (countryId !== undefined)
            url_ += "countryId=" + encodeURIComponent("" + countryId) + "&";
        if (activeAt === null)
            throw new Error("The parameter 'activeAt' cannot be null.");
        else if (activeAt !== undefined)
            url_ += "activeAt=" + encodeURIComponent(activeAt ? "" + activeAt.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiSubscriptionByChildByChildIdGet(_response);
        });
    }

    protected processApiSubscriptionByChildByChildIdGet(response: Response): Promise<PeriodSubscriptionSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PeriodSubscriptionSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PeriodSubscriptionSummaryDto>(null as any);
    }
}

export class TimeZoneApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get a map of all Windows timezones to Iana timezones.
    This can be used for moment as moment handles Iana time-zones but can't handle windows timezones.
     * @return OK
     */
    apiTimeZoneGetWindowsToIanaTimeZonesWindowsToIanaTimezonesGet(signal?: AbortSignal): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/TimeZone/GetWindowsToIanaTimeZones/windows-to-iana-timezones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiTimeZoneGetWindowsToIanaTimeZonesWindowsToIanaTimezonesGet(_response);
        });
    }

    protected processApiTimeZoneGetWindowsToIanaTimeZonesWindowsToIanaTimezonesGet(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] !== undefined ? resultData200[key] : <any>null;
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * Get all playground timezones.
     * @return OK
     */
    apiTimeZoneGetPlaygroundTimeZonesPlaygroundTimezonesGet(signal?: AbortSignal): Promise<PlaygroundTimeZoneInformationDto[]> {
        let url_ = this.baseUrl + "/api/TimeZone/GetPlaygroundTimeZones/playground-timezones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiTimeZoneGetPlaygroundTimeZonesPlaygroundTimezonesGet(_response);
        });
    }

    protected processApiTimeZoneGetPlaygroundTimeZonesPlaygroundTimezonesGet(response: Response): Promise<PlaygroundTimeZoneInformationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaygroundTimeZoneInformationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaygroundTimeZoneInformationDto[]>(null as any);
    }
}

export class UserApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Register a new user account.
     * @param body (optional) The user account information.
     * @return OK
     */
    apiUserRegisterPost(body: RegisterUserDto | undefined, signal?: AbortSignal): Promise<ApplicationUserDto> {
        let url_ = this.baseUrl + "/api/User/Register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserRegisterPost(_response);
        });
    }

    protected processApiUserRegisterPost(response: Response): Promise<ApplicationUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationUserDto>(null as any);
    }

    /**
     * @return OK
     */
    apiUserMeGet(signal?: AbortSignal): Promise<ApplicationUserDto> {
        let url_ = this.baseUrl + "/api/User/Me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserMeGet(_response);
        });
    }

    protected processApiUserMeGet(response: Response): Promise<ApplicationUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDto.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationUserDto>(null as any);
    }

    /**
     * Update the user profile.
     * @param body The new profile values.
     * @return OK
     */
    apiUserUpdateProfilePut(body: UpdateProfileModel, signal?: AbortSignal): Promise<ApplicationUserDto> {
        let url_ = this.baseUrl + "/api/User/UpdateProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserUpdateProfilePut(_response);
        });
    }

    protected processApiUserUpdateProfilePut(response: Response): Promise<ApplicationUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationUserDto>(null as any);
    }

    /**
     * Update the user playground.
     * @param body (optional) The new user playground.
     * @return OK
     */
    apiUserUpdateProfilePlaygroundPut(body: string | undefined, signal?: AbortSignal): Promise<ApplicationUserDto> {
        let url_ = this.baseUrl + "/api/User/UpdateProfilePlayground";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserUpdateProfilePlaygroundPut(_response);
        });
    }

    protected processApiUserUpdateProfilePlaygroundPut(response: Response): Promise<ApplicationUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationUserDto>(null as any);
    }

    /**
     * Create a new child.
     * @param body (optional) The child model.
     * @return OK
     */
    apiUserCreateAccountPost(body: CreateChildModel | undefined, signal?: AbortSignal): Promise<ChildDto> {
        let url_ = this.baseUrl + "/api/User/CreateAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserCreateAccountPost(_response);
        });
    }

    protected processApiUserCreateAccountPost(response: Response): Promise<ChildDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChildDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChildDto>(null as any);
    }

    /**
     * Get account information for the currently authenticated user.
     * @return OK
     */
    apiUserMyAccountsGet(signal?: AbortSignal): Promise<ChildDto[]> {
        let url_ = this.baseUrl + "/api/User/MyAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserMyAccountsGet(_response);
        });
    }

    protected processApiUserMyAccountsGet(response: Response): Promise<ChildDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChildDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDto.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChildDto[]>(null as any);
    }

    /**
     * Retrieve children for the currently authenticated user.
    The subscriptions for the children will be retrieved using the given country id.
     * @param countryId The country to get child subscriptions for.
     * @param validDate (optional) Optional date to match validity against, the subscriptions retrieved will be valid against this date. If no date is set the current date is used.
     * @return OK
     */
    apiUserGetChildrenByCountryByCountryIdGet(countryId: string, validDate: Date | undefined, signal?: AbortSignal): Promise<ChildDto[]> {
        let url_ = this.baseUrl + "/api/User/GetChildrenByCountry/{countryId}?";
        if (countryId === undefined || countryId === null)
            throw new Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        if (validDate === null)
            throw new Error("The parameter 'validDate' cannot be null.");
        else if (validDate !== undefined)
            url_ += "validDate=" + encodeURIComponent(validDate ? "" + validDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserGetChildrenByCountryByCountryIdGet(_response);
        });
    }

    protected processApiUserGetChildrenByCountryByCountryIdGet(response: Response): Promise<ChildDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChildDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChildDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiUserAddToRolePost(body: AddToRoleModel | undefined, signal?: AbortSignal): Promise<BoolResultDto> {
        let url_ = this.baseUrl + "/api/User/AddToRole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserAddToRolePost(_response);
        });
    }

    protected processApiUserAddToRolePost(response: Response): Promise<BoolResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BoolResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoolResultDto>(null as any);
    }

    /**
     * Request a password reset for a user.
     * @param body (optional) The model containing user information.
     * @return OK
     */
    apiUserForgotPasswordPost(body: ForgotPasswordModel | undefined, signal?: AbortSignal): Promise<ForgotPasswordModelResponse> {
        let url_ = this.baseUrl + "/api/User/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserForgotPasswordPost(_response);
        });
    }

    protected processApiUserForgotPasswordPost(response: Response): Promise<ForgotPasswordModelResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ForgotPasswordModelResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForgotPasswordModelResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiUserResetPasswordPost(body: ResetPasswordModelRequest | undefined, signal?: AbortSignal): Promise<ResetPasswordModelResponse> {
        let url_ = this.baseUrl + "/api/User/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserResetPasswordPost(_response);
        });
    }

    protected processApiUserResetPasswordPost(response: Response): Promise<ResetPasswordModelResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ResetPasswordModelResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResetPasswordModelResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiUserChangePasswordPost(body: ChangePasswordModelRequest | undefined, signal?: AbortSignal): Promise<ChangePasswordModelResponse> {
        let url_ = this.baseUrl + "/api/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserChangePasswordPost(_response);
        });
    }

    protected processApiUserChangePasswordPost(response: Response): Promise<ChangePasswordModelResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChangePasswordModelResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChangePasswordModelResponse>(null as any);
    }

    /**
     * Get users registered between two dates.
     * @param startDate (optional) The start date of the period.
     * @param endDate (optional) The end date of the period.
     * @param culture (optional) The culture to filter the users by.
     * @return OK
     */
    apiUserGetUsersWithinDatesGet(startDate: Date | undefined, endDate: Date | undefined, culture: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/User/GetUsersWithinDates?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (culture === null)
            throw new Error("The parameter 'culture' cannot be null.");
        else if (culture !== undefined)
            url_ += "culture=" + encodeURIComponent("" + culture) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserGetUsersWithinDatesGet(_response);
        });
    }

    protected processApiUserGetUsersWithinDatesGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieve password requirements.
     * @return OK
     */
    apiUserGetPasswordOptionsPasswordOptionsGet(signal?: AbortSignal): Promise<PasswordOptions> {
        let url_ = this.baseUrl + "/api/User/GetPasswordOptions/password/options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserGetPasswordOptionsPasswordOptionsGet(_response);
        });
    }

    protected processApiUserGetPasswordOptionsPasswordOptionsGet(response: Response): Promise<PasswordOptions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PasswordOptions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PasswordOptions>(null as any);
    }

    /**
     * Retrieves onboarding status for the authenticated user.
     * @param desiredStep (optional) The next desired step, if any. This is used to skip one or more steps in the onboarding process.
     * @param origin (optional) The origin of the auth session.
     * @param intent (optional) The intent of the auth session.
     * @return OK
     */
    apiUserGetUserOnboardingStatusOnboardingGet(desiredStep: UserOnboardingStep | undefined, origin: string | undefined, intent: string | undefined, signal?: AbortSignal): Promise<UserOnboardingStatusModel> {
        let url_ = this.baseUrl + "/api/User/GetUserOnboardingStatus/onboarding?";
        if (desiredStep === null)
            throw new Error("The parameter 'desiredStep' cannot be null.");
        else if (desiredStep !== undefined)
            url_ += "desiredStep=" + encodeURIComponent("" + desiredStep) + "&";
        if (origin === null)
            throw new Error("The parameter 'origin' cannot be null.");
        else if (origin !== undefined)
            url_ += "origin=" + encodeURIComponent("" + origin) + "&";
        if (intent === null)
            throw new Error("The parameter 'intent' cannot be null.");
        else if (intent !== undefined)
            url_ += "intent=" + encodeURIComponent("" + intent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserGetUserOnboardingStatusOnboardingGet(_response);
        });
    }

    protected processApiUserGetUserOnboardingStatusOnboardingGet(response: Response): Promise<UserOnboardingStatusModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserOnboardingStatusModel.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserOnboardingStatusModel>(null as any);
    }

    /**
     * Update email preferences for a user without authenticating.
     * @param body The command values.
     * @return No Content
     */
    apiUserUpdateEmailPreferencesEmailPreferencesPost(body: UpdateUserEmailPreferencesCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/User/UpdateEmailPreferences/email-preferences";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserUpdateEmailPreferencesEmailPreferencesPost(_response);
        });
    }

    protected processApiUserUpdateEmailPreferencesEmailPreferencesPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieve user email preferences.
     * @param userId The id of the user to retrieve the email preferences for.
     * @return OK
     */
    apiUserGetEmailPreferencesEmailPreferencesGet(userId: string, signal?: AbortSignal): Promise<UserEmailPreferencesModel> {
        let url_ = this.baseUrl + "/api/User/GetEmailPreferences/email-preferences?";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined and cannot be null.");
        else
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserGetEmailPreferencesEmailPreferencesGet(_response);
        });
    }

    protected processApiUserGetEmailPreferencesEmailPreferencesGet(response: Response): Promise<UserEmailPreferencesModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserEmailPreferencesModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserEmailPreferencesModel>(null as any);
    }
}

export class UserCouponsApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Fetches coupons for the currently authenticated user.
     * @return OK
     */
    apiUserCouponsCouponsGet(signal?: AbortSignal): Promise<UserCouponDto[]> {
        let url_ = this.baseUrl + "/api/user-coupons/coupons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserCouponsCouponsGet(_response);
        });
    }

    protected processApiUserCouponsCouponsGet(response: Response): Promise<UserCouponDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserCouponDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDto.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserCouponDto[]>(null as any);
    }

    /**
     * Fetches a coupons information based on the bar code.
     * @param barCode The bar code to fetch coupon information
     * @return OK
     */
    apiUserCouponsCouponByBarCodeGet(barCode: string, signal?: AbortSignal): Promise<NavUserCouponInformationDto> {
        let url_ = this.baseUrl + "/api/user-coupons/coupon/{barCode}";
        if (barCode === undefined || barCode === null)
            throw new Error("The parameter 'barCode' must be defined.");
        url_ = url_.replace("{barCode}", encodeURIComponent("" + barCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserCouponsCouponByBarCodeGet(_response);
        });
    }

    protected processApiUserCouponsCouponByBarCodeGet(response: Response): Promise<NavUserCouponInformationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NavUserCouponInformationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDto.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NavUserCouponInformationDto>(null as any);
    }
}

export class UserEntranceDiscountApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Fetches a single discount for the currently authorized user.
     * @return OK
     */
    apiUserEntranceDiscountGet(signal?: AbortSignal): Promise<UserEntranceDiscountDto> {
        let url_ = this.baseUrl + "/api/UserEntranceDiscount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserEntranceDiscountGet(_response);
        });
    }

    protected processApiUserEntranceDiscountGet(response: Response): Promise<UserEntranceDiscountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserEntranceDiscountDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDto.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserEntranceDiscountDto>(null as any);
    }

    /**
     * Retrieve a discount for a specific time slot and date.
     * @param timeSlotId The id of the time slot to get the discount for, this is used to validate the discount validity.
     * @param date (optional) The date that the time slot is for, this is used to validate the discount validity.
     * @return OK
     */
    apiUserEntranceDiscountByTimeslotByTimeSlotIdGet(timeSlotId: string, date: Date | undefined, signal?: AbortSignal): Promise<UserEntranceDiscountDto> {
        let url_ = this.baseUrl + "/api/UserEntranceDiscount/by-timeslot/{timeSlotId}?";
        if (timeSlotId === undefined || timeSlotId === null)
            throw new Error("The parameter 'timeSlotId' must be defined.");
        url_ = url_.replace("{timeSlotId}", encodeURIComponent("" + timeSlotId));
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent(date ? "" + date.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserEntranceDiscountByTimeslotByTimeSlotIdGet(_response);
        });
    }

    protected processApiUserEntranceDiscountByTimeslotByTimeSlotIdGet(response: Response): Promise<UserEntranceDiscountDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserEntranceDiscountDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDto.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserEntranceDiscountDto>(null as any);
    }
}

export class UserGatheringApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get number of offers, entrance bookings, party bookings etc for a User.
     * @param includeOffers (optional) Include active offers in the return, defaults to false
     * @param includeEntranceBookings (optional) Include active entrance bookings in the return, defaults to false
     * @param includePartyBookings (optional) Include active party bookings in the return, defaults to false
     * @param includeSportKidz (optional) Include active sport kidz bookings in the return, defaults to false
     * @param includeSubscriptions (optional) Include active subscriptions in the return, defaults to false
     * @param includeSerialTickets (optional) Include active serial tickets in the return, defaults to false
     * @param includeLeoCamps (optional) Include active leo camp bookings in the return, defaults to false
     * @param includeChildAccounts (optional) Include the number of child accounts connected to the account
     * @param includeAccountProgress (optional) Include the percentage amount of account completion for the user.
     * @return OK
     */
    apiUserGatheringUserGatheringGet(includeOffers: boolean | undefined, includeEntranceBookings: boolean | undefined, includePartyBookings: boolean | undefined, includeSportKidz: boolean | undefined, includeSubscriptions: boolean | undefined, includeSerialTickets: boolean | undefined, includeLeoCamps: boolean | undefined, includeChildAccounts: boolean | undefined, includeAccountProgress: boolean | undefined, signal?: AbortSignal): Promise<UserGatheringDto> {
        let url_ = this.baseUrl + "/api/UserGathering/user-gathering?";
        if (includeOffers === null)
            throw new Error("The parameter 'includeOffers' cannot be null.");
        else if (includeOffers !== undefined)
            url_ += "includeOffers=" + encodeURIComponent("" + includeOffers) + "&";
        if (includeEntranceBookings === null)
            throw new Error("The parameter 'includeEntranceBookings' cannot be null.");
        else if (includeEntranceBookings !== undefined)
            url_ += "includeEntranceBookings=" + encodeURIComponent("" + includeEntranceBookings) + "&";
        if (includePartyBookings === null)
            throw new Error("The parameter 'includePartyBookings' cannot be null.");
        else if (includePartyBookings !== undefined)
            url_ += "includePartyBookings=" + encodeURIComponent("" + includePartyBookings) + "&";
        if (includeSportKidz === null)
            throw new Error("The parameter 'includeSportKidz' cannot be null.");
        else if (includeSportKidz !== undefined)
            url_ += "includeSportKidz=" + encodeURIComponent("" + includeSportKidz) + "&";
        if (includeSubscriptions === null)
            throw new Error("The parameter 'includeSubscriptions' cannot be null.");
        else if (includeSubscriptions !== undefined)
            url_ += "includeSubscriptions=" + encodeURIComponent("" + includeSubscriptions) + "&";
        if (includeSerialTickets === null)
            throw new Error("The parameter 'includeSerialTickets' cannot be null.");
        else if (includeSerialTickets !== undefined)
            url_ += "includeSerialTickets=" + encodeURIComponent("" + includeSerialTickets) + "&";
        if (includeLeoCamps === null)
            throw new Error("The parameter 'includeLeoCamps' cannot be null.");
        else if (includeLeoCamps !== undefined)
            url_ += "includeLeoCamps=" + encodeURIComponent("" + includeLeoCamps) + "&";
        if (includeChildAccounts === null)
            throw new Error("The parameter 'includeChildAccounts' cannot be null.");
        else if (includeChildAccounts !== undefined)
            url_ += "includeChildAccounts=" + encodeURIComponent("" + includeChildAccounts) + "&";
        if (includeAccountProgress === null)
            throw new Error("The parameter 'includeAccountProgress' cannot be null.");
        else if (includeAccountProgress !== undefined)
            url_ += "includeAccountProgress=" + encodeURIComponent("" + includeAccountProgress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserGatheringUserGatheringGet(_response);
        });
    }

    protected processApiUserGatheringUserGatheringGet(response: Response): Promise<UserGatheringDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserGatheringDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserGatheringDto>(null as any);
    }
}

/** An application notice that can be displayed in the entrance booking. */
export class ApplicationNoticeDto implements IApplicationNoticeDto {
    /** The id of the notice. */
    guid!: string;
    locationIds!: string[];
    startDate!: Date | null;
    endDate!: Date | null;
    name!: string;
    text!: string;
    type!: ApplicationNoticeType | null;
    disabled!: boolean;
    icon!: string;

    constructor(data?: IApplicationNoticeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            else {
                this.locationIds = <any>null;
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>null;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.text = _data["text"] !== undefined ? _data["text"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : <any>null;
            this.icon = _data["icon"] !== undefined ? _data["icon"] : <any>null;
        }
    }

    static fromJS(data: any): ApplicationNoticeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationNoticeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        data["startDate"] = this.startDate ? formatDate(this.startDate) : <any>null;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["disabled"] = this.disabled !== undefined ? this.disabled : <any>null;
        data["icon"] = this.icon !== undefined ? this.icon : <any>null;
        return data;
    }
}

/** An application notice that can be displayed in the entrance booking. */
export interface IApplicationNoticeDto {
    /** The id of the notice. */
    guid: string;
    locationIds: string[];
    startDate: Date | null;
    endDate: Date | null;
    name: string;
    text: string;
    type: ApplicationNoticeType | null;
    disabled: boolean;
    icon: string;
}

/** Response from the Leo.Application.ChildClasses.Commands.CreateChildClassBookingPayment.CreateChildClassBookingPaymentCommand with a Bambora payment session. */
export class ChildClassBookingPaymentModel implements IChildClassBookingPaymentModel {
    /** The order reference for the booking. */
    orderReference!: string;
    /** The unique payment session id token. */
    paymentToken!: string | null;
    /** The current payment status for the booking.
If this is set to Leo.Domain.Entities.ChildClasses.ChildClassBookingPaymentStatus.Paid the Leo.Application.ChildClasses.Commands.CreateChildClassBookingPayment.ChildClassBookingPaymentModel.PaymentToken property will be left empty. */
    paymentStatus!: ChildClassBookingPaymentStatus;

    constructor(data?: IChildClassBookingPaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderReference = _data["orderReference"] !== undefined ? _data["orderReference"] : <any>null;
            this.paymentToken = _data["paymentToken"] !== undefined ? _data["paymentToken"] : <any>null;
            this.paymentStatus = _data["paymentStatus"] !== undefined ? _data["paymentStatus"] : <any>null;
        }
    }

    static fromJS(data: any): ChildClassBookingPaymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChildClassBookingPaymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderReference"] = this.orderReference !== undefined ? this.orderReference : <any>null;
        data["paymentToken"] = this.paymentToken !== undefined ? this.paymentToken : <any>null;
        data["paymentStatus"] = this.paymentStatus !== undefined ? this.paymentStatus : <any>null;
        return data;
    }
}

/** Response from the Leo.Application.ChildClasses.Commands.CreateChildClassBookingPayment.CreateChildClassBookingPaymentCommand with a Bambora payment session. */
export interface IChildClassBookingPaymentModel {
    /** The order reference for the booking. */
    orderReference: string;
    /** The unique payment session id token. */
    paymentToken: string | null;
    /** The current payment status for the booking.
If this is set to Leo.Domain.Entities.ChildClasses.ChildClassBookingPaymentStatus.Paid the Leo.Application.ChildClasses.Commands.CreateChildClassBookingPayment.ChildClassBookingPaymentModel.PaymentToken property will be left empty. */
    paymentStatus: ChildClassBookingPaymentStatus;
}

/** Create a new payment session for a specific Leo.Domain.Entities.ChildClasses.ChildClassBooking. */
export class CreateChildClassBookingPaymentCommand implements ICreateChildClassBookingPaymentCommand {
    /** The booking id. */
    bookingId!: string;

    constructor(data?: ICreateChildClassBookingPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingId = _data["bookingId"] !== undefined ? _data["bookingId"] : <any>null;
        }
    }

    static fromJS(data: any): CreateChildClassBookingPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChildClassBookingPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId !== undefined ? this.bookingId : <any>null;
        return data;
    }
}

/** Create a new payment session for a specific Leo.Domain.Entities.ChildClasses.ChildClassBooking. */
export interface ICreateChildClassBookingPaymentCommand {
    /** The booking id. */
    bookingId: string;
}

export class ChildClassAgeGroupModel implements IChildClassAgeGroupModel {
    id!: number;
    name!: string;
    minAge!: number;
    maxAge!: number;
    classStartTime!: string;
    classEndTime!: string;
    fullyBooked!: boolean;

    constructor(data?: IChildClassAgeGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.minAge = _data["minAge"] !== undefined ? _data["minAge"] : <any>null;
            this.maxAge = _data["maxAge"] !== undefined ? _data["maxAge"] : <any>null;
            this.classStartTime = _data["classStartTime"] !== undefined ? _data["classStartTime"] : <any>null;
            this.classEndTime = _data["classEndTime"] !== undefined ? _data["classEndTime"] : <any>null;
            this.fullyBooked = _data["fullyBooked"] !== undefined ? _data["fullyBooked"] : <any>null;
        }
    }

    static fromJS(data: any): ChildClassAgeGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChildClassAgeGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["minAge"] = this.minAge !== undefined ? this.minAge : <any>null;
        data["maxAge"] = this.maxAge !== undefined ? this.maxAge : <any>null;
        data["classStartTime"] = this.classStartTime !== undefined ? this.classStartTime : <any>null;
        data["classEndTime"] = this.classEndTime !== undefined ? this.classEndTime : <any>null;
        data["fullyBooked"] = this.fullyBooked !== undefined ? this.fullyBooked : <any>null;
        return data;
    }
}

export interface IChildClassAgeGroupModel {
    id: number;
    name: string;
    minAge: number;
    maxAge: number;
    classStartTime: string;
    classEndTime: string;
    fullyBooked: boolean;
}

/** Information about the currently active price. */
export class ChildClassAvailablePriceModel implements IChildClassAvailablePriceModel {
    /** The currently active price for the booking. */
    priceIncVat!: number;
    /** The date until the Leo.Application.ChildClasses.Queries.Models.ChildClassAvailablePriceModel.PriceIncVat is valid. */
    validToDate!: Date | null;
    /** The regular price that will be used after the Leo.Application.ChildClasses.Queries.Models.ChildClassAvailablePriceModel.ValidToDate has passed. */
    regularPriceIncVat!: number;

    constructor(data?: IChildClassAvailablePriceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priceIncVat = _data["priceIncVat"] !== undefined ? _data["priceIncVat"] : <any>null;
            this.validToDate = _data["validToDate"] ? new Date(_data["validToDate"].toString()) : <any>null;
            this.regularPriceIncVat = _data["regularPriceIncVat"] !== undefined ? _data["regularPriceIncVat"] : <any>null;
        }
    }

    static fromJS(data: any): ChildClassAvailablePriceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChildClassAvailablePriceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceIncVat"] = this.priceIncVat !== undefined ? this.priceIncVat : <any>null;
        data["validToDate"] = this.validToDate ? formatDate(this.validToDate) : <any>null;
        data["regularPriceIncVat"] = this.regularPriceIncVat !== undefined ? this.regularPriceIncVat : <any>null;
        return data;
    }
}

/** Information about the currently active price. */
export interface IChildClassAvailablePriceModel {
    /** The currently active price for the booking. */
    priceIncVat: number;
    /** The date until the Leo.Application.ChildClasses.Queries.Models.ChildClassAvailablePriceModel.PriceIncVat is valid. */
    validToDate: Date | null;
    /** The regular price that will be used after the Leo.Application.ChildClasses.Queries.Models.ChildClassAvailablePriceModel.ValidToDate has passed. */
    regularPriceIncVat: number;
}

/** Summary information for a completed booking. */
export class ChildClassBookingConfirmationSummaryModel implements IChildClassBookingConfirmationSummaryModel {
    guid!: string;
    orderReference!: string;
    confirmationInformation!: string | null;
    /** True if the class is a trial class, false otherwise. */
    readonly isTrialClass!: boolean;
    /** The type of class booked. */
    classType!: ChildClassClassType;
    /** The url to the payment page. */
    linkPayment!: string | null;

    constructor(data?: IChildClassBookingConfirmationSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.orderReference = _data["orderReference"] !== undefined ? _data["orderReference"] : <any>null;
            this.confirmationInformation = _data["confirmationInformation"] !== undefined ? _data["confirmationInformation"] : <any>null;
            (<any>this).isTrialClass = _data["isTrialClass"] !== undefined ? _data["isTrialClass"] : <any>null;
            this.classType = _data["classType"] !== undefined ? _data["classType"] : <any>null;
            this.linkPayment = _data["linkPayment"] !== undefined ? _data["linkPayment"] : <any>null;
        }
    }

    static fromJS(data: any): ChildClassBookingConfirmationSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChildClassBookingConfirmationSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["orderReference"] = this.orderReference !== undefined ? this.orderReference : <any>null;
        data["confirmationInformation"] = this.confirmationInformation !== undefined ? this.confirmationInformation : <any>null;
        data["isTrialClass"] = this.isTrialClass !== undefined ? this.isTrialClass : <any>null;
        data["classType"] = this.classType !== undefined ? this.classType : <any>null;
        data["linkPayment"] = this.linkPayment !== undefined ? this.linkPayment : <any>null;
        return data;
    }
}

/** Summary information for a completed booking. */
export interface IChildClassBookingConfirmationSummaryModel {
    guid: string;
    orderReference: string;
    confirmationInformation: string | null;
    /** True if the class is a trial class, false otherwise. */
    isTrialClass: boolean;
    /** The type of class booked. */
    classType: ChildClassClassType;
    /** The url to the payment page. */
    linkPayment: string | null;
}

/** A receipt line for a Leo.Application.ChildClasses.Queries.Models.ChildClassBookingReceiptModel. */
export class ChildClassBookingReceiptLineModel implements IChildClassBookingReceiptLineModel {
    description!: string | null;
    quantity!: number;
    amount!: number;
    articleNo!: string | null;
    type!: ChildClassTransactionLineType;

    constructor(data?: IChildClassBookingReceiptLineModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.articleNo = _data["articleNo"] !== undefined ? _data["articleNo"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): ChildClassBookingReceiptLineModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChildClassBookingReceiptLineModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["articleNo"] = this.articleNo !== undefined ? this.articleNo : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

/** A receipt line for a Leo.Application.ChildClasses.Queries.Models.ChildClassBookingReceiptModel. */
export interface IChildClassBookingReceiptLineModel {
    description: string | null;
    quantity: number;
    amount: number;
    articleNo: string | null;
    type: ChildClassTransactionLineType;
}

/** A receipt for a Leo.Domain.Entities.ChildClasses.ChildClassBooking. */
export class ChildClassBookingReceiptModel implements IChildClassBookingReceiptModel {
    /** The date of the transaction in the format "yyyy-MM-dd". */
    date!: Date;
    /** The id of the transaction for the receipt, if any. */
    transactionId!: string;
    /** The reference of the transaction for the receipt, if any. */
    transactionReference!: string | null;
    /** The order reference. */
    orderReference!: string;
    /** The id of the booking for the receipt. */
    bookingId!: string;
    /** The seller company name that is connected to the receipt. */
    companyName!: string;
    /** The seller company organization number that is connected to the receipt. */
    companyOrganizationNo!: string;
    /** The vat percentage. 25 = 25%. */
    vatPercent!: number;
    /** The total of the receipt, including VAT. */
    amount!: number;
    /** The amount of VAT for the receipt. */
    vatAmount!: number;
    /** The total amount for all the Leo.Application.ChildClasses.Queries.Models.ChildClassBookingReceiptModel.Lines. */
    readonly linesAmount!: number;
    /** The currency for the transaction. */
    currency!: string;
    /** The transaction type for the receipt.
E.g. Leo.Domain.Entities.ChildClasses.ChildClassTransactionType.Credit or Leo.Domain.Entities.ChildClasses.ChildClassTransactionType.Credit. */
    receiptType!: ChildClassTransactionType;
    /** All lines for the receipt. */
    lines!: ChildClassBookingReceiptLineModel[];

    constructor(data?: IChildClassBookingReceiptModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.lines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : <any>null;
            this.transactionReference = _data["transactionReference"] !== undefined ? _data["transactionReference"] : <any>null;
            this.orderReference = _data["orderReference"] !== undefined ? _data["orderReference"] : <any>null;
            this.bookingId = _data["bookingId"] !== undefined ? _data["bookingId"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.companyOrganizationNo = _data["companyOrganizationNo"] !== undefined ? _data["companyOrganizationNo"] : <any>null;
            this.vatPercent = _data["vatPercent"] !== undefined ? _data["vatPercent"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.vatAmount = _data["vatAmount"] !== undefined ? _data["vatAmount"] : <any>null;
            (<any>this).linesAmount = _data["linesAmount"] !== undefined ? _data["linesAmount"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.receiptType = _data["receiptType"] !== undefined ? _data["receiptType"] : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(ChildClassBookingReceiptLineModel.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
        }
    }

    static fromJS(data: any): ChildClassBookingReceiptModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChildClassBookingReceiptModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>null;
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : <any>null;
        data["transactionReference"] = this.transactionReference !== undefined ? this.transactionReference : <any>null;
        data["orderReference"] = this.orderReference !== undefined ? this.orderReference : <any>null;
        data["bookingId"] = this.bookingId !== undefined ? this.bookingId : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["companyOrganizationNo"] = this.companyOrganizationNo !== undefined ? this.companyOrganizationNo : <any>null;
        data["vatPercent"] = this.vatPercent !== undefined ? this.vatPercent : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["vatAmount"] = this.vatAmount !== undefined ? this.vatAmount : <any>null;
        data["linesAmount"] = this.linesAmount !== undefined ? this.linesAmount : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["receiptType"] = this.receiptType !== undefined ? this.receiptType : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

/** A receipt for a Leo.Domain.Entities.ChildClasses.ChildClassBooking. */
export interface IChildClassBookingReceiptModel {
    /** The date of the transaction in the format "yyyy-MM-dd". */
    date: Date;
    /** The id of the transaction for the receipt, if any. */
    transactionId: string;
    /** The reference of the transaction for the receipt, if any. */
    transactionReference: string | null;
    /** The order reference. */
    orderReference: string;
    /** The id of the booking for the receipt. */
    bookingId: string;
    /** The seller company name that is connected to the receipt. */
    companyName: string;
    /** The seller company organization number that is connected to the receipt. */
    companyOrganizationNo: string;
    /** The vat percentage. 25 = 25%. */
    vatPercent: number;
    /** The total of the receipt, including VAT. */
    amount: number;
    /** The amount of VAT for the receipt. */
    vatAmount: number;
    /** The total amount for all the Leo.Application.ChildClasses.Queries.Models.ChildClassBookingReceiptModel.Lines. */
    linesAmount: number;
    /** The currency for the transaction. */
    currency: string;
    /** The transaction type for the receipt.
E.g. Leo.Domain.Entities.ChildClasses.ChildClassTransactionType.Credit or Leo.Domain.Entities.ChildClasses.ChildClassTransactionType.Credit. */
    receiptType: ChildClassTransactionType;
    /** All lines for the receipt. */
    lines: ChildClassBookingReceiptLineModel[];
}

/** Model for listing available child classes of a playground. */
export class ChildClassesAvailableModel implements IChildClassesAvailableModel {
    id!: number;
    classType!: ChildClassClassType;
    name!: string;
    playgroundId!: string;
    occasions!: number;
    /** Price information about the current and regular price. */
    price!: ChildClassAvailablePriceModel;
    firstOccasionDate!: Date;
    ageGroups!: ChildClassAgeGroupModel[];
    /** True if the class is a trial class, false if it's a regular one. */
    readonly isTrialClass!: boolean;
    /** True if the all the classes age groups are full. */
    fullyBooked!: boolean;

    constructor(data?: IChildClassesAvailableModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.price = new ChildClassAvailablePriceModel();
            this.ageGroups = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.classType = _data["classType"] !== undefined ? _data["classType"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.playgroundId = _data["playgroundId"] !== undefined ? _data["playgroundId"] : <any>null;
            this.occasions = _data["occasions"] !== undefined ? _data["occasions"] : <any>null;
            this.price = _data["price"] ? ChildClassAvailablePriceModel.fromJS(_data["price"]) : new ChildClassAvailablePriceModel();
            this.firstOccasionDate = _data["firstOccasionDate"] ? new Date(_data["firstOccasionDate"].toString()) : <any>null;
            if (Array.isArray(_data["ageGroups"])) {
                this.ageGroups = [] as any;
                for (let item of _data["ageGroups"])
                    this.ageGroups!.push(ChildClassAgeGroupModel.fromJS(item));
            }
            else {
                this.ageGroups = <any>null;
            }
            (<any>this).isTrialClass = _data["isTrialClass"] !== undefined ? _data["isTrialClass"] : <any>null;
            this.fullyBooked = _data["fullyBooked"] !== undefined ? _data["fullyBooked"] : <any>null;
        }
    }

    static fromJS(data: any): ChildClassesAvailableModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChildClassesAvailableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["classType"] = this.classType !== undefined ? this.classType : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["playgroundId"] = this.playgroundId !== undefined ? this.playgroundId : <any>null;
        data["occasions"] = this.occasions !== undefined ? this.occasions : <any>null;
        data["price"] = this.price ? this.price.toJSON() : <any>null;
        data["firstOccasionDate"] = this.firstOccasionDate ? formatDate(this.firstOccasionDate) : <any>null;
        if (Array.isArray(this.ageGroups)) {
            data["ageGroups"] = [];
            for (let item of this.ageGroups)
                data["ageGroups"].push(item.toJSON());
        }
        data["isTrialClass"] = this.isTrialClass !== undefined ? this.isTrialClass : <any>null;
        data["fullyBooked"] = this.fullyBooked !== undefined ? this.fullyBooked : <any>null;
        return data;
    }
}

/** Model for listing available child classes of a playground. */
export interface IChildClassesAvailableModel {
    id: number;
    classType: ChildClassClassType;
    name: string;
    playgroundId: string;
    occasions: number;
    /** Price information about the current and regular price. */
    price: ChildClassAvailablePriceModel;
    firstOccasionDate: Date;
    ageGroups: ChildClassAgeGroupModel[];
    /** True if the class is a trial class, false if it's a regular one. */
    isTrialClass: boolean;
    /** True if the all the classes age groups are full. */
    fullyBooked: boolean;
}

export enum LocationTreeLevels {
    Country = "Country",
    Region = "Region",
    Playground = "Playground",
    Area = "Area",
    Room = "Room",
    Table = "Table",
}

export class ChildDto implements IChildDto {
    guid!: string;
    firstname!: string | null;
    lastname!: string | null;
    userid!: string;
    otherinfo!: string | null;
    currency!: string | null;
    /** The birthdate in the format "YYYY-MM-DD". */
    birthdate!: string | null;
    membercardid!: string | null;
    memberid!: string | null;
    /** Set to a subscription currently active for the child.
If no active subscriptions are found this will be set to null. */
    subscription!: PeriodSubscriptionDto | null;

    constructor(data?: IChildDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.firstname = _data["firstname"] !== undefined ? _data["firstname"] : <any>null;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : <any>null;
            this.userid = _data["userid"] !== undefined ? _data["userid"] : <any>null;
            this.otherinfo = _data["otherinfo"] !== undefined ? _data["otherinfo"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.birthdate = _data["birthdate"] !== undefined ? _data["birthdate"] : <any>null;
            this.membercardid = _data["membercardid"] !== undefined ? _data["membercardid"] : <any>null;
            this.memberid = _data["memberid"] !== undefined ? _data["memberid"] : <any>null;
            this.subscription = _data["subscription"] ? PeriodSubscriptionDto.fromJS(_data["subscription"]) : <any>null;
        }
    }

    static fromJS(data: any): ChildDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChildDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["firstname"] = this.firstname !== undefined ? this.firstname : <any>null;
        data["lastname"] = this.lastname !== undefined ? this.lastname : <any>null;
        data["userid"] = this.userid !== undefined ? this.userid : <any>null;
        data["otherinfo"] = this.otherinfo !== undefined ? this.otherinfo : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["birthdate"] = this.birthdate !== undefined ? this.birthdate : <any>null;
        data["membercardid"] = this.membercardid !== undefined ? this.membercardid : <any>null;
        data["memberid"] = this.memberid !== undefined ? this.memberid : <any>null;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>null;
        return data;
    }
}

export interface IChildDto {
    guid: string;
    firstname: string | null;
    lastname: string | null;
    userid: string;
    otherinfo: string | null;
    currency: string | null;
    /** The birthdate in the format "YYYY-MM-DD". */
    birthdate: string | null;
    membercardid: string | null;
    memberid: string | null;
    /** Set to a subscription currently active for the child.
If no active subscriptions are found this will be set to null. */
    subscription: PeriodSubscriptionDto | null;
}

export class DateCriteriaDto implements IDateCriteriaDto {
    name!: string | null;
    guid!: string;
    comparewith!: DateCriteriaComparable;
    condition!: CriteriaLessEqualMore;
    timevalue!: string | null;
    dayofweek!: string | null;
    datecriteriacollectionid!: string | null;

    constructor(data?: IDateCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.comparewith = _data["comparewith"] !== undefined ? _data["comparewith"] : <any>null;
            this.condition = _data["condition"] !== undefined ? _data["condition"] : <any>null;
            this.timevalue = _data["timevalue"] !== undefined ? _data["timevalue"] : <any>null;
            this.dayofweek = _data["dayofweek"] !== undefined ? _data["dayofweek"] : <any>null;
            this.datecriteriacollectionid = _data["datecriteriacollectionid"] !== undefined ? _data["datecriteriacollectionid"] : <any>null;
        }
    }

    static fromJS(data: any): DateCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["comparewith"] = this.comparewith !== undefined ? this.comparewith : <any>null;
        data["condition"] = this.condition !== undefined ? this.condition : <any>null;
        data["timevalue"] = this.timevalue !== undefined ? this.timevalue : <any>null;
        data["dayofweek"] = this.dayofweek !== undefined ? this.dayofweek : <any>null;
        data["datecriteriacollectionid"] = this.datecriteriacollectionid !== undefined ? this.datecriteriacollectionid : <any>null;
        return data;
    }
}

export interface IDateCriteriaDto {
    name: string | null;
    guid: string;
    comparewith: DateCriteriaComparable;
    condition: CriteriaLessEqualMore;
    timevalue: string | null;
    dayofweek: string | null;
    datecriteriacollectionid: string | null;
}

/** A DTO for exceptions. */
export class ErrorDto implements IErrorDto {
    /** The type of exception (type name). */
    exceptionType!: string | null;
    /** The error code, may be a number, guid or string. */
    code!: string | null;
    /** A set of property errors with the key being the property name.
If the error is for no specific property the key will be System.String.Empty. */
    errors!: { [key: string]: string[]; } | null;
    /** The HTTP response code that should be set for any HTTP response that is generated for the exception. */
    responsecode!: number;
    /** The error message. */
    message!: string | null;
    /** A set of reasons for the error. */
    reasons!: ErrorReasonDto[] | null;
    /** A stack trace for the exception, only set in development environment. */
    stackTrace!: string | null;

    constructor(data?: IErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exceptionType = _data["exceptionType"] !== undefined ? _data["exceptionType"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : <any>null;
                }
            }
            else {
                this.errors = <any>null;
            }
            this.responsecode = _data["responsecode"] !== undefined ? _data["responsecode"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(ErrorReasonDto.fromJS(item));
            }
            else {
                this.reasons = <any>null;
            }
            this.stackTrace = _data["stackTrace"] !== undefined ? _data["stackTrace"] : <any>null;
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exceptionType"] = this.exceptionType !== undefined ? this.exceptionType : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = this.errors[key] !== undefined ? this.errors[key] : <any>null;
            }
        }
        data["responsecode"] = this.responsecode !== undefined ? this.responsecode : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item.toJSON());
        }
        data["stackTrace"] = this.stackTrace !== undefined ? this.stackTrace : <any>null;
        return data;
    }
}

/** A DTO for exceptions. */
export interface IErrorDto {
    /** The type of exception (type name). */
    exceptionType: string | null;
    /** The error code, may be a number, guid or string. */
    code: string | null;
    /** A set of property errors with the key being the property name.
If the error is for no specific property the key will be System.String.Empty. */
    errors: { [key: string]: string[]; } | null;
    /** The HTTP response code that should be set for any HTTP response that is generated for the exception. */
    responsecode: number;
    /** The error message. */
    message: string | null;
    /** A set of reasons for the error. */
    reasons: ErrorReasonDto[] | null;
    /** A stack trace for the exception, only set in development environment. */
    stackTrace: string | null;
}

/** A reason for the exception. */
export class ErrorReasonDto implements IErrorReasonDto {
    /** The reason code. */
    code!: string | null;
    /** The reason message. */
    message!: string | null;

    constructor(data?: IErrorReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
        }
    }

    static fromJS(data: any): ErrorReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data;
    }
}

/** A reason for the exception. */
export interface IErrorReasonDto {
    /** The reason code. */
    code: string | null;
    /** The reason message. */
    message: string | null;
}

export class LocationDto implements ILocationDto {
    locationid!: string | null;
    name!: string | null;
    type!: string | null;
    path!: string[] | null;

    constructor(data?: ILocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationid = _data["locationid"] !== undefined ? _data["locationid"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(item);
            }
            else {
                this.path = <any>null;
            }
        }
    }

    static fromJS(data: any): LocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationid"] = this.locationid !== undefined ? this.locationid : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item);
        }
        return data;
    }
}

export interface ILocationDto {
    locationid: string | null;
    name: string | null;
    type: string | null;
    path: string[] | null;
}

export class LocationListDto implements ILocationListDto {
    countries!: LocationListItem[] | null;
    regions!: LocationListItem[] | null;
    playgrounds!: LocationListItem[] | null;
    areas!: LocationListItem[] | null;
    rooms!: LocationListItem[] | null;
    tables!: LocationListItem[] | null;
    unknownparents!: LocationListItem[] | null;

    constructor(data?: ILocationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(LocationListItem.fromJS(item));
            }
            else {
                this.countries = <any>null;
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(LocationListItem.fromJS(item));
            }
            else {
                this.regions = <any>null;
            }
            if (Array.isArray(_data["playgrounds"])) {
                this.playgrounds = [] as any;
                for (let item of _data["playgrounds"])
                    this.playgrounds!.push(LocationListItem.fromJS(item));
            }
            else {
                this.playgrounds = <any>null;
            }
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(LocationListItem.fromJS(item));
            }
            else {
                this.areas = <any>null;
            }
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(LocationListItem.fromJS(item));
            }
            else {
                this.rooms = <any>null;
            }
            if (Array.isArray(_data["tables"])) {
                this.tables = [] as any;
                for (let item of _data["tables"])
                    this.tables!.push(LocationListItem.fromJS(item));
            }
            else {
                this.tables = <any>null;
            }
            if (Array.isArray(_data["unknownparents"])) {
                this.unknownparents = [] as any;
                for (let item of _data["unknownparents"])
                    this.unknownparents!.push(LocationListItem.fromJS(item));
            }
            else {
                this.unknownparents = <any>null;
            }
        }
    }

    static fromJS(data: any): LocationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item.toJSON());
        }
        if (Array.isArray(this.playgrounds)) {
            data["playgrounds"] = [];
            for (let item of this.playgrounds)
                data["playgrounds"].push(item.toJSON());
        }
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        if (Array.isArray(this.tables)) {
            data["tables"] = [];
            for (let item of this.tables)
                data["tables"].push(item.toJSON());
        }
        if (Array.isArray(this.unknownparents)) {
            data["unknownparents"] = [];
            for (let item of this.unknownparents)
                data["unknownparents"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocationListDto {
    countries: LocationListItem[] | null;
    regions: LocationListItem[] | null;
    playgrounds: LocationListItem[] | null;
    areas: LocationListItem[] | null;
    rooms: LocationListItem[] | null;
    tables: LocationListItem[] | null;
    unknownparents: LocationListItem[] | null;
}

export class LocationTreeDto implements ILocationTreeDto {
    items!: LocationListItem[] | null;

    constructor(data?: ILocationTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocationListItem.fromJS(item));
            }
            else {
                this.items = <any>null;
            }
        }
    }

    static fromJS(data: any): LocationTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocationTreeDto {
    items: LocationListItem[] | null;
}

/** Dto object for the Leo.Domain.Entities.Media.MediaItem object. */
export class MediaItemDto implements IMediaItemDto {
    guid!: string;
    version!: number;
    mediaType!: MediaType | null;
    sizeInBytes!: number;
    width!: number | null;
    height!: number | null;

    constructor(data?: IMediaItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.version = _data["version"] !== undefined ? _data["version"] : <any>null;
            this.mediaType = _data["mediaType"] !== undefined ? _data["mediaType"] : <any>null;
            this.sizeInBytes = _data["sizeInBytes"] !== undefined ? _data["sizeInBytes"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
        }
    }

    static fromJS(data: any): MediaItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["version"] = this.version !== undefined ? this.version : <any>null;
        data["mediaType"] = this.mediaType !== undefined ? this.mediaType : <any>null;
        data["sizeInBytes"] = this.sizeInBytes !== undefined ? this.sizeInBytes : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        return data;
    }
}

/** Dto object for the Leo.Domain.Entities.Media.MediaItem object. */
export interface IMediaItemDto {
    guid: string;
    version: number;
    mediaType: MediaType | null;
    sizeInBytes: number;
    width: number | null;
    height: number | null;
}

/** Request for creating a new user using the minimum amount of data required. */
export class BasicUserCreateRequest implements IBasicUserCreateRequest {
    /** The first name of the user. */
    firstName!: string;
    /** The last name of the user. */
    lastName!: string;
    /** The email of the user. */
    email!: string;
    /** The phone number of the user. */
    phone!: string;
    /** Disallow information for newsletter, offers and discounts. */
    gdprDisallowInformation!: boolean;
    /** If the user allows information for newsletter, offers and discounts from partners */
    gdprAllowPartnerInformation!: boolean;

    constructor(data?: IBasicUserCreateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.gdprDisallowInformation = _data["gdprDisallowInformation"] !== undefined ? _data["gdprDisallowInformation"] : <any>null;
            this.gdprAllowPartnerInformation = _data["gdprAllowPartnerInformation"] !== undefined ? _data["gdprAllowPartnerInformation"] : <any>null;
        }
    }

    static fromJS(data: any): BasicUserCreateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BasicUserCreateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["gdprDisallowInformation"] = this.gdprDisallowInformation !== undefined ? this.gdprDisallowInformation : <any>null;
        data["gdprAllowPartnerInformation"] = this.gdprAllowPartnerInformation !== undefined ? this.gdprAllowPartnerInformation : <any>null;
        return data;
    }
}

/** Request for creating a new user using the minimum amount of data required. */
export interface IBasicUserCreateRequest {
    /** The first name of the user. */
    firstName: string;
    /** The last name of the user. */
    lastName: string;
    /** The email of the user. */
    email: string;
    /** The phone number of the user. */
    phone: string;
    /** Disallow information for newsletter, offers and discounts. */
    gdprDisallowInformation: boolean;
    /** If the user allows information for newsletter, offers and discounts from partners */
    gdprAllowPartnerInformation: boolean;
}

/** The coupon information */
export class NavUserCouponInformationDto implements INavUserCouponInformationDto {
    /** The description of the coupon code. */
    description!: string;
    /** The last date the coupon is valid. */
    lastValidDate!: Date;

    constructor(data?: INavUserCouponInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.lastValidDate = _data["lastValidDate"] ? new Date(_data["lastValidDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): NavUserCouponInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NavUserCouponInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["lastValidDate"] = this.lastValidDate ? formatDate(this.lastValidDate) : <any>null;
        return data;
    }
}

/** The coupon information */
export interface INavUserCouponInformationDto {
    /** The description of the coupon code. */
    description: string;
    /** The last date the coupon is valid. */
    lastValidDate: Date;
}

/** The users coupon */
export class UserCouponDto implements IUserCouponDto {
    /** The coupon barcode. */
    barCode!: string;
    /** The description of the coupon code. */
    description!: string;
    /** The last date the coupon is valid. */
    lastValidDate!: Date;

    constructor(data?: IUserCouponDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barCode = _data["barCode"] !== undefined ? _data["barCode"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.lastValidDate = _data["lastValidDate"] ? new Date(_data["lastValidDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UserCouponDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserCouponDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barCode"] = this.barCode !== undefined ? this.barCode : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["lastValidDate"] = this.lastValidDate ? formatDate(this.lastValidDate) : <any>null;
        return data;
    }
}

/** The users coupon */
export interface IUserCouponDto {
    /** The coupon barcode. */
    barCode: string;
    /** The description of the coupon code. */
    description: string;
    /** The last date the coupon is valid. */
    lastValidDate: Date;
}

export class UserEntranceBookingDto implements IUserEntranceBookingDto {
    /** The date of the booking, e.g. "2021-12-30". */
    bookdate!: Date;
    /** The unique id of the booking. */
    bookingid!: string;
    /** The LOCAL start time, e.g. "12:00", of the booking. */
    starttime!: string;
    /** The current status of the booking. */
    status!: EntranceBookStatus;
    /** The number of, annual + regular, children in the booking, */
    children!: number;
    /** The number of infants in the booking. */
    infants!: number;
    /** The number of adults in the booking. */
    adults!: number;
    /** The number of adults in the booking. */
    oneyearolds!: number;
    /** The order reference of the booking. */
    orderreference!: string;
    /** The name of the playground that the booking is for, e.g. "Luleå". */
    playgroundname!: string;
    /** True if the booking still can be cancelled. */
    canbedeleted!: boolean;
    /** True if the booking is active, e.g. should be displayed as "current". */
    isactive!: boolean;

    constructor(data?: IUserEntranceBookingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookdate = _data["bookdate"] ? new Date(_data["bookdate"].toString()) : <any>null;
            this.bookingid = _data["bookingid"] !== undefined ? _data["bookingid"] : <any>null;
            this.starttime = _data["starttime"] !== undefined ? _data["starttime"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.children = _data["children"] !== undefined ? _data["children"] : <any>null;
            this.infants = _data["infants"] !== undefined ? _data["infants"] : <any>null;
            this.adults = _data["adults"] !== undefined ? _data["adults"] : <any>null;
            this.oneyearolds = _data["oneyearolds"] !== undefined ? _data["oneyearolds"] : <any>null;
            this.orderreference = _data["orderreference"] !== undefined ? _data["orderreference"] : <any>null;
            this.playgroundname = _data["playgroundname"] !== undefined ? _data["playgroundname"] : <any>null;
            this.canbedeleted = _data["canbedeleted"] !== undefined ? _data["canbedeleted"] : <any>null;
            this.isactive = _data["isactive"] !== undefined ? _data["isactive"] : <any>null;
        }
    }

    static fromJS(data: any): UserEntranceBookingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEntranceBookingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookdate"] = this.bookdate ? formatDate(this.bookdate) : <any>null;
        data["bookingid"] = this.bookingid !== undefined ? this.bookingid : <any>null;
        data["starttime"] = this.starttime !== undefined ? this.starttime : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["children"] = this.children !== undefined ? this.children : <any>null;
        data["infants"] = this.infants !== undefined ? this.infants : <any>null;
        data["adults"] = this.adults !== undefined ? this.adults : <any>null;
        data["oneyearolds"] = this.oneyearolds !== undefined ? this.oneyearolds : <any>null;
        data["orderreference"] = this.orderreference !== undefined ? this.orderreference : <any>null;
        data["playgroundname"] = this.playgroundname !== undefined ? this.playgroundname : <any>null;
        data["canbedeleted"] = this.canbedeleted !== undefined ? this.canbedeleted : <any>null;
        data["isactive"] = this.isactive !== undefined ? this.isactive : <any>null;
        return data;
    }
}

export interface IUserEntranceBookingDto {
    /** The date of the booking, e.g. "2021-12-30". */
    bookdate: Date;
    /** The unique id of the booking. */
    bookingid: string;
    /** The LOCAL start time, e.g. "12:00", of the booking. */
    starttime: string;
    /** The current status of the booking. */
    status: EntranceBookStatus;
    /** The number of, annual + regular, children in the booking, */
    children: number;
    /** The number of infants in the booking. */
    infants: number;
    /** The number of adults in the booking. */
    adults: number;
    /** The number of adults in the booking. */
    oneyearolds: number;
    /** The order reference of the booking. */
    orderreference: string;
    /** The name of the playground that the booking is for, e.g. "Luleå". */
    playgroundname: string;
    /** True if the booking still can be cancelled. */
    canbedeleted: boolean;
    /** True if the booking is active, e.g. should be displayed as "current". */
    isactive: boolean;
}

export enum SyncGiftCardByCardNumberCommandValidatorErrorCodes {
    InvalidCardNumber = "InvalidCardNumber",
}

/** Represents a opening and closing time. */
export class OpenHoursDto implements IOpenHoursDto {
    /** The opening time. */
    from!: string;
    /** The closing time. */
    to!: string;

    constructor(data?: IOpenHoursDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] !== undefined ? _data["from"] : <any>null;
            this.to = _data["to"] !== undefined ? _data["to"] : <any>null;
        }
    }

    static fromJS(data: any): OpenHoursDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpenHoursDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from !== undefined ? this.from : <any>null;
        data["to"] = this.to !== undefined ? this.to : <any>null;
        return data;
    }
}

/** Represents a opening and closing time. */
export interface IOpenHoursDto {
    /** The opening time. */
    from: string;
    /** The closing time. */
    to: string;
}

export class OpeningHoursDto implements IOpeningHoursDto {
    /** The date for this set of opening hours */
    date!: Date;
    /** The list of opening hours for this specific day */
    open!: OpenHoursDto[];
    /** Is closed this specific day */
    readonly isClosed!: boolean;
    /** A comment regarding the opening hours for this day */
    comment!: string | null;

    constructor(data?: IOpeningHoursDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.open = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            if (Array.isArray(_data["open"])) {
                this.open = [] as any;
                for (let item of _data["open"])
                    this.open!.push(OpenHoursDto.fromJS(item));
            }
            else {
                this.open = <any>null;
            }
            (<any>this).isClosed = _data["isClosed"] !== undefined ? _data["isClosed"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
        }
    }

    static fromJS(data: any): OpeningHoursDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpeningHoursDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : <any>null;
        if (Array.isArray(this.open)) {
            data["open"] = [];
            for (let item of this.open)
                data["open"].push(item.toJSON());
        }
        data["isClosed"] = this.isClosed !== undefined ? this.isClosed : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        return data;
    }
}

export interface IOpeningHoursDto {
    /** The date for this set of opening hours */
    date: Date;
    /** The list of opening hours for this specific day */
    open: OpenHoursDto[];
    /** Is closed this specific day */
    isClosed: boolean;
    /** A comment regarding the opening hours for this day */
    comment: string | null;
}

export enum SyncSerialTicketByCardNumberCommandValidatorErrorCodes {
    UserNotFound = "UserNotFound",
}

export enum SyncSerialTicketByIdCommandValidatorErrorCodes {
    SerialTicketNotFound = "SerialTicketNotFound",
}

/** A serial ticket */
export class SerialTicketModel implements ISerialTicketModel {
    /** The id of the serial ticket. */
    guid!: string;
    /** The name of the serial ticket article. */
    name!: string;
    /** The card number of the serial ticket */
    cardNumber!: string;
    /** The pin code of the serial ticket */
    pinCode!: string;
    /** The number of entrances left to use on the ticket. */
    numberOfEntrancesLeft!: number;
    /** The total of original entrances on the ticket.
This will not change when the ticket is used. */
    totalEntrances!: number;
    /** The tickets validity period. */
    period!: SerialTicketValidPeriodModel;
    /** The current state of the serial ticket */
    state!: SerialTicketPeriodState;

    constructor(data?: ISerialTicketModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.period = new SerialTicketValidPeriodModel();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.cardNumber = _data["cardNumber"] !== undefined ? _data["cardNumber"] : <any>null;
            this.pinCode = _data["pinCode"] !== undefined ? _data["pinCode"] : <any>null;
            this.numberOfEntrancesLeft = _data["numberOfEntrancesLeft"] !== undefined ? _data["numberOfEntrancesLeft"] : <any>null;
            this.totalEntrances = _data["totalEntrances"] !== undefined ? _data["totalEntrances"] : <any>null;
            this.period = _data["period"] ? SerialTicketValidPeriodModel.fromJS(_data["period"]) : new SerialTicketValidPeriodModel();
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
        }
    }

    static fromJS(data: any): SerialTicketModel {
        data = typeof data === 'object' ? data : {};
        let result = new SerialTicketModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : <any>null;
        data["pinCode"] = this.pinCode !== undefined ? this.pinCode : <any>null;
        data["numberOfEntrancesLeft"] = this.numberOfEntrancesLeft !== undefined ? this.numberOfEntrancesLeft : <any>null;
        data["totalEntrances"] = this.totalEntrances !== undefined ? this.totalEntrances : <any>null;
        data["period"] = this.period ? this.period.toJSON() : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        return data;
    }
}

/** A serial ticket */
export interface ISerialTicketModel {
    /** The id of the serial ticket. */
    guid: string;
    /** The name of the serial ticket article. */
    name: string;
    /** The card number of the serial ticket */
    cardNumber: string;
    /** The pin code of the serial ticket */
    pinCode: string;
    /** The number of entrances left to use on the ticket. */
    numberOfEntrancesLeft: number;
    /** The total of original entrances on the ticket.
This will not change when the ticket is used. */
    totalEntrances: number;
    /** The tickets validity period. */
    period: SerialTicketValidPeriodModel;
    /** The current state of the serial ticket */
    state: SerialTicketPeriodState;
}

/** The different states that a Leo.Application.SerialTickets.Queries.Models.SerialTicketModel can be in. */
export enum SerialTicketPeriodState {
    Active = "Active",
    Upcoming = "Upcoming",
    Expired = "Expired",
}

/** Properties for an articles valid period. */
export class SerialTicketValidPeriodModel implements ISerialTicketValidPeriodModel {
    /** The start of the period. */
    start!: Date;
    /** The end of the period. */
    end!: Date;

    constructor(data?: ISerialTicketValidPeriodModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): SerialTicketValidPeriodModel {
        data = typeof data === 'object' ? data : {};
        let result = new SerialTicketValidPeriodModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>null;
        data["end"] = this.end ? this.end.toISOString() : <any>null;
        return data;
    }
}

/** Properties for an articles valid period. */
export interface ISerialTicketValidPeriodModel {
    /** The start of the period. */
    start: Date;
    /** The end of the period. */
    end: Date;
}

/** Create a gift card order and retrieve a payment session to pay the order. */
export class CreateGiftCardOrderCommand implements ICreateGiftCardOrderCommand {
    /** The id of the article to purchase. */
    articleId!: number;
    /** The email to send to. */
    recipientEmail!: string;
    /** The language to display the UI/payment window in, null to use the culture from the user. */
    language!: string | null;

    constructor(data?: ICreateGiftCardOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.recipientEmail = _data["recipientEmail"] !== undefined ? _data["recipientEmail"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
        }
    }

    static fromJS(data: any): CreateGiftCardOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGiftCardOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["recipientEmail"] = this.recipientEmail !== undefined ? this.recipientEmail : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        return data;
    }
}

/** Create a gift card order and retrieve a payment session to pay the order. */
export interface ICreateGiftCardOrderCommand {
    /** The id of the article to purchase. */
    articleId: number;
    /** The email to send to. */
    recipientEmail: string;
    /** The language to display the UI/payment window in, null to use the culture from the user. */
    language: string | null;
}

/** Payment information for a gift card order. */
export class GiftCardOrderPaymentModel implements IGiftCardOrderPaymentModel {
    /** The order reference. */
    orderReference!: string;
    /** The payment session token. */
    paymentToken!: string;

    constructor(data?: IGiftCardOrderPaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderReference = _data["orderReference"] !== undefined ? _data["orderReference"] : <any>null;
            this.paymentToken = _data["paymentToken"] !== undefined ? _data["paymentToken"] : <any>null;
        }
    }

    static fromJS(data: any): GiftCardOrderPaymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCardOrderPaymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderReference"] = this.orderReference !== undefined ? this.orderReference : <any>null;
        data["paymentToken"] = this.paymentToken !== undefined ? this.paymentToken : <any>null;
        return data;
    }
}

/** Payment information for a gift card order. */
export interface IGiftCardOrderPaymentModel {
    /** The order reference. */
    orderReference: string;
    /** The payment session token. */
    paymentToken: string;
}

/** Get an order summary, before placing the order, for a shop gift card order. */
export class GetGiftCardOrderSummaryQuery implements IGetGiftCardOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId!: number;

    constructor(data?: IGetGiftCardOrderSummaryQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
        }
    }

    static fromJS(data: any): GetGiftCardOrderSummaryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftCardOrderSummaryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        return data;
    }
}

/** Get an order summary, before placing the order, for a shop gift card order. */
export interface IGetGiftCardOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId: number;
}

export class GiftCardArticleSummaryModel implements IGiftCardArticleSummaryModel {
    id!: number;
    name!: string;
    description!: string;
    price!: number;
    giftCardAmount!: number;
    /** The currency for the price. */
    currency!: string;
    sellablePeriodStartDate!: Date | null;
    sellablePeriodEndDate!: Date | null;
    cardActivationDate!: Date | null;
    countryId!: string;
    /** The name of the Leo.Application.Shop.GiftCards.Queries.Models.GiftCardArticleSummaryModel.CountryId. */
    countryName!: string;
    /** True if the article currently is actively sellable. */
    isActive!: boolean;
    /** Dto object for the Leo.Domain.Entities.Media.MediaItem object. */
    media!: MediaItemDto;

    constructor(data?: IGiftCardArticleSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.media = new MediaItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.giftCardAmount = _data["giftCardAmount"] !== undefined ? _data["giftCardAmount"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.sellablePeriodStartDate = _data["sellablePeriodStartDate"] ? new Date(_data["sellablePeriodStartDate"].toString()) : <any>null;
            this.sellablePeriodEndDate = _data["sellablePeriodEndDate"] ? new Date(_data["sellablePeriodEndDate"].toString()) : <any>null;
            this.cardActivationDate = _data["cardActivationDate"] ? new Date(_data["cardActivationDate"].toString()) : <any>null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.media = _data["media"] ? MediaItemDto.fromJS(_data["media"]) : new MediaItemDto();
        }
    }

    static fromJS(data: any): GiftCardArticleSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCardArticleSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["giftCardAmount"] = this.giftCardAmount !== undefined ? this.giftCardAmount : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["sellablePeriodStartDate"] = this.sellablePeriodStartDate ? this.sellablePeriodStartDate.toISOString() : <any>null;
        data["sellablePeriodEndDate"] = this.sellablePeriodEndDate ? this.sellablePeriodEndDate.toISOString() : <any>null;
        data["cardActivationDate"] = this.cardActivationDate ? this.cardActivationDate.toISOString() : <any>null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        data["countryName"] = this.countryName !== undefined ? this.countryName : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["media"] = this.media ? this.media.toJSON() : <any>null;
        return data;
    }
}

export interface IGiftCardArticleSummaryModel {
    id: number;
    name: string;
    description: string;
    price: number;
    giftCardAmount: number;
    /** The currency for the price. */
    currency: string;
    sellablePeriodStartDate: Date | null;
    sellablePeriodEndDate: Date | null;
    cardActivationDate: Date | null;
    countryId: string;
    /** The name of the Leo.Application.Shop.GiftCards.Queries.Models.GiftCardArticleSummaryModel.CountryId. */
    countryName: string;
    /** True if the article currently is actively sellable. */
    isActive: boolean;
    /** Dto object for the Leo.Domain.Entities.Media.MediaItem object. */
    media: MediaItemDto;
}

/** A single order line in the summary model. */
export class GiftCardOrderSummaryLineModel implements IGiftCardOrderSummaryLineModel {
    /** The id of the article for the line. */
    articleId!: number;
    /** The name of the article for the line. */
    articleName!: string;
    /** The quantity ordered. */
    quantity!: number;
    /** The total amount for the line, incl. VAT. */
    amount!: number;

    constructor(data?: IGiftCardOrderSummaryLineModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): GiftCardOrderSummaryLineModel {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCardOrderSummaryLineModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["articleName"] = this.articleName !== undefined ? this.articleName : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }
}

/** A single order line in the summary model. */
export interface IGiftCardOrderSummaryLineModel {
    /** The id of the article for the line. */
    articleId: number;
    /** The name of the article for the line. */
    articleName: string;
    /** The quantity ordered. */
    quantity: number;
    /** The total amount for the line, incl. VAT. */
    amount: number;
}

/** Gift card order summary mode. */
export class GiftCardOrderSummaryModel implements IGiftCardOrderSummaryModel {
    /** The article id in the order. */
    articleId!: number;
    /** The name of the article in the order. */
    articleName!: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName!: string;
    /** The total price for the article. */
    price!: number;
    /** The currency for the price. */
    currency!: string;
    /** The start and end date of the card. */
    rules!: string;
    /** The total price of the order. */
    totalAmount!: number;
    /** The validity period. */
    period!: GiftCardValidPeriodModel;
    /** The order lines. */
    lines!: GiftCardOrderSummaryLineModel[];

    constructor(data?: IGiftCardOrderSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.period = new GiftCardValidPeriodModel();
            this.lines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.rules = _data["rules"] !== undefined ? _data["rules"] : <any>null;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : <any>null;
            this.period = _data["period"] ? GiftCardValidPeriodModel.fromJS(_data["period"]) : new GiftCardValidPeriodModel();
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(GiftCardOrderSummaryLineModel.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
        }
    }

    static fromJS(data: any): GiftCardOrderSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCardOrderSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["articleName"] = this.articleName !== undefined ? this.articleName : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["rules"] = this.rules !== undefined ? this.rules : <any>null;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : <any>null;
        data["period"] = this.period ? this.period.toJSON() : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

/** Gift card order summary mode. */
export interface IGiftCardOrderSummaryModel {
    /** The article id in the order. */
    articleId: number;
    /** The name of the article in the order. */
    articleName: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName: string;
    /** The total price for the article. */
    price: number;
    /** The currency for the price. */
    currency: string;
    /** The start and end date of the card. */
    rules: string;
    /** The total price of the order. */
    totalAmount: number;
    /** The validity period. */
    period: GiftCardValidPeriodModel;
    /** The order lines. */
    lines: GiftCardOrderSummaryLineModel[];
}

/** Properties for an articles valid period. */
export class GiftCardValidPeriodModel implements IGiftCardValidPeriodModel {
    /** The start of the period. */
    start!: Date;
    /** The end of the period. */
    end!: Date;

    constructor(data?: IGiftCardValidPeriodModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GiftCardValidPeriodModel {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCardValidPeriodModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : <any>null;
        data["end"] = this.end ? this.end.toISOString() : <any>null;
        return data;
    }
}

/** Properties for an articles valid period. */
export interface IGiftCardValidPeriodModel {
    /** The start of the period. */
    start: Date;
    /** The end of the period. */
    end: Date;
}

export class SellableGiftCardArticleModel implements ISellableGiftCardArticleModel {
    id!: number;
    name!: string;
    description!: string;
    /** The price of the article, in the location currency. */
    price!: number;
    countryId!: string;
    /** The name of the country. */
    countryName!: string;
    rules!: string;
    /** The media item for the card. */
    media!: MediaItemDto;

    constructor(data?: ISellableGiftCardArticleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.media = new MediaItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : <any>null;
            this.rules = _data["rules"] !== undefined ? _data["rules"] : <any>null;
            this.media = _data["media"] ? MediaItemDto.fromJS(_data["media"]) : new MediaItemDto();
        }
    }

    static fromJS(data: any): SellableGiftCardArticleModel {
        data = typeof data === 'object' ? data : {};
        let result = new SellableGiftCardArticleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        data["countryName"] = this.countryName !== undefined ? this.countryName : <any>null;
        data["rules"] = this.rules !== undefined ? this.rules : <any>null;
        data["media"] = this.media ? this.media.toJSON() : <any>null;
        return data;
    }
}

export interface ISellableGiftCardArticleModel {
    id: number;
    name: string;
    description: string;
    /** The price of the article, in the location currency. */
    price: number;
    countryId: string;
    /** The name of the country. */
    countryName: string;
    rules: string;
    /** The media item for the card. */
    media: MediaItemDto;
}

/** Create a shop order and retrieve a payment session to pay the order. */
export class CreateDirectPassOrderCommand implements ICreateDirectPassOrderCommand {
    /** The id of the article to purchase. */
    articleId!: number;
    /** The child to purchase the article for. */
    childId!: string;
    /** The language to display the UI/payment window in, null to use the culture from the user. */
    language!: string | null;

    constructor(data?: ICreateDirectPassOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.childId = _data["childId"] !== undefined ? _data["childId"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
        }
    }

    static fromJS(data: any): CreateDirectPassOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDirectPassOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["childId"] = this.childId !== undefined ? this.childId : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        return data;
    }
}

/** Create a shop order and retrieve a payment session to pay the order. */
export interface ICreateDirectPassOrderCommand {
    /** The id of the article to purchase. */
    articleId: number;
    /** The child to purchase the article for. */
    childId: string;
    /** The language to display the UI/payment window in, null to use the culture from the user. */
    language: string | null;
}

/** Create a redeem shop order and retrieve a payment session to pay the order. */
export class CreateRedeemPassOrderCommand implements ICreateRedeemPassOrderCommand {
    /** The id of the article to purchase. */
    articleId!: number;
    /** The email of the recipient. */
    recipientEmail!: string;
    /** The language to display the UI/payment window in, null to use the culture from the user. */
    language!: string | null;

    constructor(data?: ICreateRedeemPassOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.recipientEmail = _data["recipientEmail"] !== undefined ? _data["recipientEmail"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
        }
    }

    static fromJS(data: any): CreateRedeemPassOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRedeemPassOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["recipientEmail"] = this.recipientEmail !== undefined ? this.recipientEmail : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        return data;
    }
}

/** Create a redeem shop order and retrieve a payment session to pay the order. */
export interface ICreateRedeemPassOrderCommand {
    /** The id of the article to purchase. */
    articleId: number;
    /** The email of the recipient. */
    recipientEmail: string;
    /** The language to display the UI/payment window in, null to use the culture from the user. */
    language: string | null;
}

/** Payment information for a shop member card order. */
export class PassOrderPaymentModel implements IPassOrderPaymentModel {
    /** The order reference. */
    orderReference!: string;
    /** The payment session token. */
    paymentToken!: string;

    constructor(data?: IPassOrderPaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderReference = _data["orderReference"] !== undefined ? _data["orderReference"] : <any>null;
            this.paymentToken = _data["paymentToken"] !== undefined ? _data["paymentToken"] : <any>null;
        }
    }

    static fromJS(data: any): PassOrderPaymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new PassOrderPaymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderReference"] = this.orderReference !== undefined ? this.orderReference : <any>null;
        data["paymentToken"] = this.paymentToken !== undefined ? this.paymentToken : <any>null;
        return data;
    }
}

/** Payment information for a shop member card order. */
export interface IPassOrderPaymentModel {
    /** The order reference. */
    orderReference: string;
    /** The payment session token. */
    paymentToken: string;
}

/** A summary of what can be redeemed for a redeem session. */
export class PassRedeemInformationModel implements IPassRedeemInformationModel {
    /** The id of the article for the redeem code. */
    articleId!: number;
    /** The article name. */
    articleName!: string;
    /** The article description. */
    articleDescription!: string;
    /** The image for the article. */
    articleMedia!: MediaItemDto;
    /** The company name in the country of the article. */
    companyName!: string;
    /** The company organization number in the country of the article. */
    companyOrganizationNumber!: string;
    /** The article rules. */
    articleRules!: string;

    constructor(data?: IPassRedeemInformationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.articleMedia = new MediaItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : <any>null;
            this.articleDescription = _data["articleDescription"] !== undefined ? _data["articleDescription"] : <any>null;
            this.articleMedia = _data["articleMedia"] ? MediaItemDto.fromJS(_data["articleMedia"]) : new MediaItemDto();
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.companyOrganizationNumber = _data["companyOrganizationNumber"] !== undefined ? _data["companyOrganizationNumber"] : <any>null;
            this.articleRules = _data["articleRules"] !== undefined ? _data["articleRules"] : <any>null;
        }
    }

    static fromJS(data: any): PassRedeemInformationModel {
        data = typeof data === 'object' ? data : {};
        let result = new PassRedeemInformationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["articleName"] = this.articleName !== undefined ? this.articleName : <any>null;
        data["articleDescription"] = this.articleDescription !== undefined ? this.articleDescription : <any>null;
        data["articleMedia"] = this.articleMedia ? this.articleMedia.toJSON() : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["companyOrganizationNumber"] = this.companyOrganizationNumber !== undefined ? this.companyOrganizationNumber : <any>null;
        data["articleRules"] = this.articleRules !== undefined ? this.articleRules : <any>null;
        return data;
    }
}

/** A summary of what can be redeemed for a redeem session. */
export interface IPassRedeemInformationModel {
    /** The id of the article for the redeem code. */
    articleId: number;
    /** The article name. */
    articleName: string;
    /** The article description. */
    articleDescription: string;
    /** The image for the article. */
    articleMedia: MediaItemDto;
    /** The company name in the country of the article. */
    companyName: string;
    /** The company organization number in the country of the article. */
    companyOrganizationNumber: string;
    /** The article rules. */
    articleRules: string;
}

/** Get an order summary, before placing the order, for a shop pass order. */
export class GetDirectPassOrderSummaryQuery implements IGetDirectPassOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId!: number;
    /** The id of the child to retrieve the summary for. */
    childId!: string;

    constructor(data?: IGetDirectPassOrderSummaryQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.childId = _data["childId"] !== undefined ? _data["childId"] : <any>null;
        }
    }

    static fromJS(data: any): GetDirectPassOrderSummaryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetDirectPassOrderSummaryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["childId"] = this.childId !== undefined ? this.childId : <any>null;
        return data;
    }
}

/** Get an order summary, before placing the order, for a shop pass order. */
export interface IGetDirectPassOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId: number;
    /** The id of the child to retrieve the summary for. */
    childId: string;
}

/** Get a redeem summary, before performing the redeem for a pass order. */
export class GetRedeemPassOrderSummaryQuery implements IGetRedeemPassOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId!: number;

    constructor(data?: IGetRedeemPassOrderSummaryQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
        }
    }

    static fromJS(data: any): GetRedeemPassOrderSummaryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetRedeemPassOrderSummaryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        return data;
    }
}

/** Get a redeem summary, before performing the redeem for a pass order. */
export interface IGetRedeemPassOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId: number;
}

/** A summary model containing information about a child that can or can't be selected for a pass. */
export class PassArticleChildSummaryDto implements IPassArticleChildSummaryDto {
    guid!: string;
    firstName!: string;
    lastName!: string | null;
    /** A warning message if the child can't be selected for the article. */
    warning!: string | null;
    birthDate!: Date;
    /** True if the child is selected for the article requested.
False otherwise. */
    readonly selectable!: boolean;

    constructor(data?: IPassArticleChildSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.warning = _data["warning"] !== undefined ? _data["warning"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
            (<any>this).selectable = _data["selectable"] !== undefined ? _data["selectable"] : <any>null;
        }
    }

    static fromJS(data: any): PassArticleChildSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassArticleChildSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["warning"] = this.warning !== undefined ? this.warning : <any>null;
        data["birthDate"] = this.birthDate ? formatDate(this.birthDate) : <any>null;
        data["selectable"] = this.selectable !== undefined ? this.selectable : <any>null;
        return data;
    }
}

/** A summary model containing information about a child that can or can't be selected for a pass. */
export interface IPassArticleChildSummaryDto {
    guid: string;
    firstName: string;
    lastName: string | null;
    /** A warning message if the child can't be selected for the article. */
    warning: string | null;
    birthDate: Date;
    /** True if the child is selected for the article requested.
False otherwise. */
    selectable: boolean;
}

/** A summary model for the Leo.Domain.Entities.Shop.Passes.PassArticleEntity. */
export class PassArticleSummaryDto implements IPassArticleSummaryDto {
    id!: number;
    name!: string;
    type!: PassArticleType;
    description!: string;
    price!: number;
    /** The currency for the price. */
    currency!: string;
    sellablePeriodStartDate!: Date | null;
    sellablePeriodEndDate!: Date | null;
    /** Set if the period can be determined for the card, e.g. if the type is a Leo.Domain.Enums.Shop.Passes.PassArticleType.Period
or if a start date has been decided for the Leo.Domain.Enums.Shop.Passes.PassArticleType.OpenEndDate. */
    periodCardProperties!: PassPeriodDto | null;
    /** Properties set if the Leo.Application.Shop.Passes.Queries.Models.PassArticleSummaryDto.Type is set to Leo.Domain.Enums.Shop.Passes.PassArticleType.OpenEndDate. */
    openEndDateCardProperties!: PassLengthDto | null;
    locationId!: string;
    /** The name of the Leo.Application.Shop.Passes.Queries.Models.PassArticleSummaryDto.LocationId. */
    locationName!: string;
    /** True if the article currently is actively sellable. */
    isActive!: boolean;
    /** Dto object for the Leo.Domain.Entities.Media.MediaItem object. */
    media!: MediaItemDto;
    inactiveReason!: PassArticleInactiveReason | null;

    constructor(data?: IPassArticleSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.media = new MediaItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.sellablePeriodStartDate = _data["sellablePeriodStartDate"] ? new Date(_data["sellablePeriodStartDate"].toString()) : <any>null;
            this.sellablePeriodEndDate = _data["sellablePeriodEndDate"] ? new Date(_data["sellablePeriodEndDate"].toString()) : <any>null;
            this.periodCardProperties = _data["periodCardProperties"] ? PassPeriodDto.fromJS(_data["periodCardProperties"]) : <any>null;
            this.openEndDateCardProperties = _data["openEndDateCardProperties"] ? PassLengthDto.fromJS(_data["openEndDateCardProperties"]) : <any>null;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : <any>null;
            this.locationName = _data["locationName"] !== undefined ? _data["locationName"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.media = _data["media"] ? MediaItemDto.fromJS(_data["media"]) : new MediaItemDto();
            this.inactiveReason = _data["inactiveReason"] !== undefined ? _data["inactiveReason"] : <any>null;
        }
    }

    static fromJS(data: any): PassArticleSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassArticleSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["sellablePeriodStartDate"] = this.sellablePeriodStartDate ? formatDate(this.sellablePeriodStartDate) : <any>null;
        data["sellablePeriodEndDate"] = this.sellablePeriodEndDate ? formatDate(this.sellablePeriodEndDate) : <any>null;
        data["periodCardProperties"] = this.periodCardProperties ? this.periodCardProperties.toJSON() : <any>null;
        data["openEndDateCardProperties"] = this.openEndDateCardProperties ? this.openEndDateCardProperties.toJSON() : <any>null;
        data["locationId"] = this.locationId !== undefined ? this.locationId : <any>null;
        data["locationName"] = this.locationName !== undefined ? this.locationName : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["media"] = this.media ? this.media.toJSON() : <any>null;
        data["inactiveReason"] = this.inactiveReason !== undefined ? this.inactiveReason : <any>null;
        return data;
    }
}

/** A summary model for the Leo.Domain.Entities.Shop.Passes.PassArticleEntity. */
export interface IPassArticleSummaryDto {
    id: number;
    name: string;
    type: PassArticleType;
    description: string;
    price: number;
    /** The currency for the price. */
    currency: string;
    sellablePeriodStartDate: Date | null;
    sellablePeriodEndDate: Date | null;
    /** Set if the period can be determined for the card, e.g. if the type is a Leo.Domain.Enums.Shop.Passes.PassArticleType.Period
or if a start date has been decided for the Leo.Domain.Enums.Shop.Passes.PassArticleType.OpenEndDate. */
    periodCardProperties: PassPeriodDto | null;
    /** Properties set if the Leo.Application.Shop.Passes.Queries.Models.PassArticleSummaryDto.Type is set to Leo.Domain.Enums.Shop.Passes.PassArticleType.OpenEndDate. */
    openEndDateCardProperties: PassLengthDto | null;
    locationId: string;
    /** The name of the Leo.Application.Shop.Passes.Queries.Models.PassArticleSummaryDto.LocationId. */
    locationName: string;
    /** True if the article currently is actively sellable. */
    isActive: boolean;
    /** Dto object for the Leo.Domain.Entities.Media.MediaItem object. */
    media: MediaItemDto;
    inactiveReason: PassArticleInactiveReason | null;
}

/** Order summary mode. */
export class PassDirectOrderSummaryDto implements IPassDirectOrderSummaryDto {
    /** The article id in the order. */
    articleId!: number;
    /** The name of the article in the order. */
    articleName!: string;
    /** The id of the child in the order. */
    childId!: string;
    /** The full name of the child. */
    childName!: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName!: string;
    /** The playground id that the article will be assigned to after purchase. */
    playgroundId!: string | null;
    /** The name of the playground that the article will be assigned to after purchase. */
    playgroundName!: string | null;
    /** The total price, incl. VAT,  of the order. */
    totalAmount!: number;
    /** The currency for the price. */
    currency!: string;
    /** The start and end date of the card. */
    period!: PassPeriodDto;
    /** The order lines. */
    lines!: PassDirectOrderSummaryLineDto[];

    constructor(data?: IPassDirectOrderSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.period = new PassPeriodDto();
            this.lines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : <any>null;
            this.childId = _data["childId"] !== undefined ? _data["childId"] : <any>null;
            this.childName = _data["childName"] !== undefined ? _data["childName"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.playgroundId = _data["playgroundId"] !== undefined ? _data["playgroundId"] : <any>null;
            this.playgroundName = _data["playgroundName"] !== undefined ? _data["playgroundName"] : <any>null;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.period = _data["period"] ? PassPeriodDto.fromJS(_data["period"]) : new PassPeriodDto();
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(PassDirectOrderSummaryLineDto.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
        }
    }

    static fromJS(data: any): PassDirectOrderSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassDirectOrderSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["articleName"] = this.articleName !== undefined ? this.articleName : <any>null;
        data["childId"] = this.childId !== undefined ? this.childId : <any>null;
        data["childName"] = this.childName !== undefined ? this.childName : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["playgroundId"] = this.playgroundId !== undefined ? this.playgroundId : <any>null;
        data["playgroundName"] = this.playgroundName !== undefined ? this.playgroundName : <any>null;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["period"] = this.period ? this.period.toJSON() : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

/** Order summary mode. */
export interface IPassDirectOrderSummaryDto {
    /** The article id in the order. */
    articleId: number;
    /** The name of the article in the order. */
    articleName: string;
    /** The id of the child in the order. */
    childId: string;
    /** The full name of the child. */
    childName: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName: string;
    /** The playground id that the article will be assigned to after purchase. */
    playgroundId: string | null;
    /** The name of the playground that the article will be assigned to after purchase. */
    playgroundName: string | null;
    /** The total price, incl. VAT,  of the order. */
    totalAmount: number;
    /** The currency for the price. */
    currency: string;
    /** The start and end date of the card. */
    period: PassPeriodDto;
    /** The order lines. */
    lines: PassDirectOrderSummaryLineDto[];
}

/** A single order line in the summary model. */
export class PassDirectOrderSummaryLineDto implements IPassDirectOrderSummaryLineDto {
    /** The id of the article for the line. */
    articleId!: number;
    /** The name of the article for the line. */
    articleName!: string;
    /** The quantity ordered. */
    quantity!: number;
    /** The total amount for the line, incl. VAT. */
    amount!: number;
    /** The id of the child that the article will be purchased for. */
    childId!: string;
    /** The name of the child that the article will be purchased for. */
    childName!: string;

    constructor(data?: IPassDirectOrderSummaryLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.childId = _data["childId"] !== undefined ? _data["childId"] : <any>null;
            this.childName = _data["childName"] !== undefined ? _data["childName"] : <any>null;
        }
    }

    static fromJS(data: any): PassDirectOrderSummaryLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassDirectOrderSummaryLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["articleName"] = this.articleName !== undefined ? this.articleName : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["childId"] = this.childId !== undefined ? this.childId : <any>null;
        data["childName"] = this.childName !== undefined ? this.childName : <any>null;
        return data;
    }
}

/** A single order line in the summary model. */
export interface IPassDirectOrderSummaryLineDto {
    /** The id of the article for the line. */
    articleId: number;
    /** The name of the article for the line. */
    articleName: string;
    /** The quantity ordered. */
    quantity: number;
    /** The total amount for the line, incl. VAT. */
    amount: number;
    /** The id of the child that the article will be purchased for. */
    childId: string;
    /** The name of the child that the article will be purchased for. */
    childName: string;
}

/** Properties for a Leo.Domain.Enums.Shop.Passes.PassArticleType.OpenEndDate card article. */
export class PassLengthDto implements IPassLengthDto {
    /** The length of the Leo.Domain.Enums.Shop.Passes.PassArticleType.OpenEndDate. */
    length!: number;
    /** The type of Leo.Application.Shop.Passes.Queries.Models.PassLengthDto.Length. */
    type!: DurationType;

    constructor(data?: IPassLengthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.length = _data["length"] !== undefined ? _data["length"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): PassLengthDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassLengthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["length"] = this.length !== undefined ? this.length : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

/** Properties for a Leo.Domain.Enums.Shop.Passes.PassArticleType.OpenEndDate card article. */
export interface IPassLengthDto {
    /** The length of the Leo.Domain.Enums.Shop.Passes.PassArticleType.OpenEndDate. */
    length: number;
    /** The type of Leo.Application.Shop.Passes.Queries.Models.PassLengthDto.Length. */
    type: DurationType;
}

/** Properties for a Leo.Domain.Enums.Shop.Passes.PassArticleType.Period card article. */
export class PassPeriodDto implements IPassPeriodDto {
    /** The start of the period. */
    start!: Date;
    /** The end of the period. */
    end!: Date;

    constructor(data?: IPassPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : <any>null;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): PassPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? formatDate(this.start) : <any>null;
        data["end"] = this.end ? formatDate(this.end) : <any>null;
        return data;
    }
}

/** Properties for a Leo.Domain.Enums.Shop.Passes.PassArticleType.Period card article. */
export interface IPassPeriodDto {
    /** The start of the period. */
    start: Date;
    /** The end of the period. */
    end: Date;
}

/** Represents the status of a photo upload for a specific Leo.Domain.Entities.Shop.Passes.PassArticleEntity. */
export class PassPhotoUploadStatusDto implements IPassPhotoUploadStatusDto {
    /** Indicates whether photo upload is available. */
    photoUploadAvailable!: boolean;
    /** Number of allowed bookings without image, if null there is no limitation set. */
    numberOfAllowedBookingsWithoutImage!: number | null;

    constructor(data?: IPassPhotoUploadStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.photoUploadAvailable = _data["photoUploadAvailable"] !== undefined ? _data["photoUploadAvailable"] : <any>null;
            this.numberOfAllowedBookingsWithoutImage = _data["numberOfAllowedBookingsWithoutImage"] !== undefined ? _data["numberOfAllowedBookingsWithoutImage"] : <any>null;
        }
    }

    static fromJS(data: any): PassPhotoUploadStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassPhotoUploadStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["photoUploadAvailable"] = this.photoUploadAvailable !== undefined ? this.photoUploadAvailable : <any>null;
        data["numberOfAllowedBookingsWithoutImage"] = this.numberOfAllowedBookingsWithoutImage !== undefined ? this.numberOfAllowedBookingsWithoutImage : <any>null;
        return data;
    }
}

/** Represents the status of a photo upload for a specific Leo.Domain.Entities.Shop.Passes.PassArticleEntity. */
export interface IPassPhotoUploadStatusDto {
    /** Indicates whether photo upload is available. */
    photoUploadAvailable: boolean;
    /** Number of allowed bookings without image, if null there is no limitation set. */
    numberOfAllowedBookingsWithoutImage: number | null;
}

/** Order summary mode. */
export class PassRedeemOrderSummaryDto implements IPassRedeemOrderSummaryDto {
    /** The article id in the order. */
    articleId!: number;
    /** The name of the article in the order. */
    articleName!: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName!: string;
    /** The total price, incl. VAT,  of the order. */
    totalAmount!: number;
    /** The currency for the price. */
    currency!: string;
    /** The start and end date of the card, if any. */
    period!: PassPeriodDto | null;
    /** The order lines. */
    lines!: PassRedeemOrderSummaryLineDto[];

    constructor(data?: IPassRedeemOrderSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.lines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.period = _data["period"] ? PassPeriodDto.fromJS(_data["period"]) : <any>null;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(PassRedeemOrderSummaryLineDto.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
        }
    }

    static fromJS(data: any): PassRedeemOrderSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassRedeemOrderSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["articleName"] = this.articleName !== undefined ? this.articleName : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["period"] = this.period ? this.period.toJSON() : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

/** Order summary mode. */
export interface IPassRedeemOrderSummaryDto {
    /** The article id in the order. */
    articleId: number;
    /** The name of the article in the order. */
    articleName: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName: string;
    /** The total price, incl. VAT,  of the order. */
    totalAmount: number;
    /** The currency for the price. */
    currency: string;
    /** The start and end date of the card, if any. */
    period: PassPeriodDto | null;
    /** The order lines. */
    lines: PassRedeemOrderSummaryLineDto[];
}

/** A single order line in the summary model. */
export class PassRedeemOrderSummaryLineDto implements IPassRedeemOrderSummaryLineDto {
    /** The id of the article for the line. */
    articleId!: number;
    /** The name of the article for the line. */
    articleName!: string;
    /** The quantity ordered. */
    quantity!: number;
    /** The total amount for the line, incl. VAT. */
    amount!: number;

    constructor(data?: IPassRedeemOrderSummaryLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): PassRedeemOrderSummaryLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassRedeemOrderSummaryLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["articleName"] = this.articleName !== undefined ? this.articleName : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }
}

/** A single order line in the summary model. */
export interface IPassRedeemOrderSummaryLineDto {
    /** The id of the article for the line. */
    articleId: number;
    /** The name of the article for the line. */
    articleName: string;
    /** The quantity ordered. */
    quantity: number;
    /** The total amount for the line, incl. VAT. */
    amount: number;
}

/** Summary for a possible pass redeem. */
export class PassRedeemSummaryDto implements IPassRedeemSummaryDto {
    /** The id of the article for the redeem. */
    articleId!: number;
    /** The name of the article for the redeem. */
    articleName!: string;
    /** The description of the article for the redeem. */
    articleDescription!: string;
    /** The name of the playground that the pass will be connected to after redeeming it. */
    playgroundName!: string | null;
    /** The email of the user redeeming the pass. */
    userEmail!: string;
    /** The id of the child that the subscription should be created for. */
    childId!: string;
    /** The first name of the child that the subscription should be created for. */
    childFirstName!: string;
    /** The last name of the child that the subscription should be created for.
May be null if not set. */
    childLastName!: string | null;
    /** The media of the article for the redeem. */
    articleMedia!: MediaItemDto;
    /** The period of validity for the pass. */
    period!: PassPeriodDto;
    /** The company name in the country of the article. */
    companyName!: string;
    /** The company organization number in the country of the article. */
    companyOrganizationNumber!: string;

    constructor(data?: IPassRedeemSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.articleMedia = new MediaItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : <any>null;
            this.articleDescription = _data["articleDescription"] !== undefined ? _data["articleDescription"] : <any>null;
            this.playgroundName = _data["playgroundName"] !== undefined ? _data["playgroundName"] : <any>null;
            this.userEmail = _data["userEmail"] !== undefined ? _data["userEmail"] : <any>null;
            this.childId = _data["childId"] !== undefined ? _data["childId"] : <any>null;
            this.childFirstName = _data["childFirstName"] !== undefined ? _data["childFirstName"] : <any>null;
            this.childLastName = _data["childLastName"] !== undefined ? _data["childLastName"] : <any>null;
            this.articleMedia = _data["articleMedia"] ? MediaItemDto.fromJS(_data["articleMedia"]) : new MediaItemDto();
            this.period = _data["period"] ? PassPeriodDto.fromJS(_data["period"]) : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.companyOrganizationNumber = _data["companyOrganizationNumber"] !== undefined ? _data["companyOrganizationNumber"] : <any>null;
        }
    }

    static fromJS(data: any): PassRedeemSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassRedeemSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["articleName"] = this.articleName !== undefined ? this.articleName : <any>null;
        data["articleDescription"] = this.articleDescription !== undefined ? this.articleDescription : <any>null;
        data["playgroundName"] = this.playgroundName !== undefined ? this.playgroundName : <any>null;
        data["userEmail"] = this.userEmail !== undefined ? this.userEmail : <any>null;
        data["childId"] = this.childId !== undefined ? this.childId : <any>null;
        data["childFirstName"] = this.childFirstName !== undefined ? this.childFirstName : <any>null;
        data["childLastName"] = this.childLastName !== undefined ? this.childLastName : <any>null;
        data["articleMedia"] = this.articleMedia ? this.articleMedia.toJSON() : <any>null;
        data["period"] = this.period ? this.period.toJSON() : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["companyOrganizationNumber"] = this.companyOrganizationNumber !== undefined ? this.companyOrganizationNumber : <any>null;
        return data;
    }
}

/** Summary for a possible pass redeem. */
export interface IPassRedeemSummaryDto {
    /** The id of the article for the redeem. */
    articleId: number;
    /** The name of the article for the redeem. */
    articleName: string;
    /** The description of the article for the redeem. */
    articleDescription: string;
    /** The name of the playground that the pass will be connected to after redeeming it. */
    playgroundName: string | null;
    /** The email of the user redeeming the pass. */
    userEmail: string;
    /** The id of the child that the subscription should be created for. */
    childId: string;
    /** The first name of the child that the subscription should be created for. */
    childFirstName: string;
    /** The last name of the child that the subscription should be created for.
May be null if not set. */
    childLastName: string | null;
    /** The media of the article for the redeem. */
    articleMedia: MediaItemDto;
    /** The period of validity for the pass. */
    period: PassPeriodDto;
    /** The company name in the country of the article. */
    companyName: string;
    /** The company organization number in the country of the article. */
    companyOrganizationNumber: string;
}

/** A sellable shop card article. */
export class SellablePassArticleModel implements ISellablePassArticleModel {
    id!: number;
    name!: string;
    type!: PassArticleType;
    description!: string;
    /** The price of the article, in the location currency. */
    price!: number;
    locationId!: string;
    /** Properties set if the Leo.Application.Shop.Passes.Queries.Models.SellablePassArticleModel.Type is set to Leo.Domain.Enums.Shop.Passes.PassArticleType.Period. */
    periodCardProperties!: PassPeriodDto | null;
    /** Properties set if the Leo.Application.Shop.Passes.Queries.Models.SellablePassArticleModel.Type is set to Leo.Domain.Enums.Shop.Passes.PassArticleType.OpenEndDate. */
    openEndDateCardProperties!: PassLengthDto | null;
    /** The name of the location. */
    locationName!: string;
    rules!: string;
    /** The media item for the card. */
    media!: MediaItemDto;

    constructor(data?: ISellablePassArticleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.media = new MediaItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : <any>null;
            this.periodCardProperties = _data["periodCardProperties"] ? PassPeriodDto.fromJS(_data["periodCardProperties"]) : <any>null;
            this.openEndDateCardProperties = _data["openEndDateCardProperties"] ? PassLengthDto.fromJS(_data["openEndDateCardProperties"]) : <any>null;
            this.locationName = _data["locationName"] !== undefined ? _data["locationName"] : <any>null;
            this.rules = _data["rules"] !== undefined ? _data["rules"] : <any>null;
            this.media = _data["media"] ? MediaItemDto.fromJS(_data["media"]) : new MediaItemDto();
        }
    }

    static fromJS(data: any): SellablePassArticleModel {
        data = typeof data === 'object' ? data : {};
        let result = new SellablePassArticleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["locationId"] = this.locationId !== undefined ? this.locationId : <any>null;
        data["periodCardProperties"] = this.periodCardProperties ? this.periodCardProperties.toJSON() : <any>null;
        data["openEndDateCardProperties"] = this.openEndDateCardProperties ? this.openEndDateCardProperties.toJSON() : <any>null;
        data["locationName"] = this.locationName !== undefined ? this.locationName : <any>null;
        data["rules"] = this.rules !== undefined ? this.rules : <any>null;
        data["media"] = this.media ? this.media.toJSON() : <any>null;
        return data;
    }
}

/** A sellable shop card article. */
export interface ISellablePassArticleModel {
    id: number;
    name: string;
    type: PassArticleType;
    description: string;
    /** The price of the article, in the location currency. */
    price: number;
    locationId: string;
    /** Properties set if the Leo.Application.Shop.Passes.Queries.Models.SellablePassArticleModel.Type is set to Leo.Domain.Enums.Shop.Passes.PassArticleType.Period. */
    periodCardProperties: PassPeriodDto | null;
    /** Properties set if the Leo.Application.Shop.Passes.Queries.Models.SellablePassArticleModel.Type is set to Leo.Domain.Enums.Shop.Passes.PassArticleType.OpenEndDate. */
    openEndDateCardProperties: PassLengthDto | null;
    /** The name of the location. */
    locationName: string;
    rules: string;
    /** The media item for the card. */
    media: MediaItemDto;
}

/** Create a new connect to account session. */
export class CreateConnectToAccountSessionCommand implements ICreateConnectToAccountSessionCommand {
    /** The card number of the serial ticket to connect to account. */
    cardNumber!: string;
    /** The card pin code. */
    pinCode!: string;

    constructor(data?: ICreateConnectToAccountSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["cardNumber"] !== undefined ? _data["cardNumber"] : <any>null;
            this.pinCode = _data["pinCode"] !== undefined ? _data["pinCode"] : <any>null;
        }
    }

    static fromJS(data: any): CreateConnectToAccountSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConnectToAccountSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : <any>null;
        data["pinCode"] = this.pinCode !== undefined ? this.pinCode : <any>null;
        return data;
    }
}

/** Create a new connect to account session. */
export interface ICreateConnectToAccountSessionCommand {
    /** The card number of the serial ticket to connect to account. */
    cardNumber: string;
    /** The card pin code. */
    pinCode: string;
}

/** Create a shop order and retrieve a payment session to pay the order. */
export class CreateSerialTicketDirectOrderCommand implements ICreateSerialTicketDirectOrderCommand {
    /** The id of the article to purchase. */
    articleId!: number;
    /** The language to display the UI/payment window in, null to use the culture from the user. */
    language!: string | null;

    constructor(data?: ICreateSerialTicketDirectOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
        }
    }

    static fromJS(data: any): CreateSerialTicketDirectOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSerialTicketDirectOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        return data;
    }
}

/** Create a shop order and retrieve a payment session to pay the order. */
export interface ICreateSerialTicketDirectOrderCommand {
    /** The id of the article to purchase. */
    articleId: number;
    /** The language to display the UI/payment window in, null to use the culture from the user. */
    language: string | null;
}

/** Create a shop redeem order and retrieve a payment sessioin to pay the order. */
export class CreateSerialTicketRedeemOrderCommand implements ICreateSerialTicketRedeemOrderCommand {
    /** The id of the article to purchase. */
    articleId!: number;
    /** The email address to send the receipt and redeem message to. */
    recipientEmail!: string;
    /** The language to display the UI/payment window in, null to use country default. */
    language!: string | null;

    constructor(data?: ICreateSerialTicketRedeemOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.recipientEmail = _data["recipientEmail"] !== undefined ? _data["recipientEmail"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
        }
    }

    static fromJS(data: any): CreateSerialTicketRedeemOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSerialTicketRedeemOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["recipientEmail"] = this.recipientEmail !== undefined ? this.recipientEmail : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        return data;
    }
}

/** Create a shop redeem order and retrieve a payment sessioin to pay the order. */
export interface ICreateSerialTicketRedeemOrderCommand {
    /** The id of the article to purchase. */
    articleId: number;
    /** The email address to send the receipt and redeem message to. */
    recipientEmail: string;
    /** The language to display the UI/payment window in, null to use country default. */
    language: string | null;
}

/** Payment information for a shop serial ticket order. */
export class SerialTicketOrderPaymentModel implements ISerialTicketOrderPaymentModel {
    /** The order reference. */
    orderReference!: string;
    /** The payment session token. */
    paymentToken!: string;

    constructor(data?: ISerialTicketOrderPaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderReference = _data["orderReference"] !== undefined ? _data["orderReference"] : <any>null;
            this.paymentToken = _data["paymentToken"] !== undefined ? _data["paymentToken"] : <any>null;
        }
    }

    static fromJS(data: any): SerialTicketOrderPaymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new SerialTicketOrderPaymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderReference"] = this.orderReference !== undefined ? this.orderReference : <any>null;
        data["paymentToken"] = this.paymentToken !== undefined ? this.paymentToken : <any>null;
        return data;
    }
}

/** Payment information for a shop serial ticket order. */
export interface ISerialTicketOrderPaymentModel {
    /** The order reference. */
    orderReference: string;
    /** The payment session token. */
    paymentToken: string;
}

/** Get an order summary, before placing the order, for a shop serial ticket direct order. */
export class GetSerialTicketDirectOrderSummaryQuery implements IGetSerialTicketDirectOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId!: number;

    constructor(data?: IGetSerialTicketDirectOrderSummaryQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
        }
    }

    static fromJS(data: any): GetSerialTicketDirectOrderSummaryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSerialTicketDirectOrderSummaryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        return data;
    }
}

/** Get an order summary, before placing the order, for a shop serial ticket direct order. */
export interface IGetSerialTicketDirectOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId: number;
}

/** Get an order summary, before placing the order, for a shop serial ticket redeem order. */
export class GetSerialTicketRedeemOrderSummaryQuery implements IGetSerialTicketRedeemOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId!: number;

    constructor(data?: IGetSerialTicketRedeemOrderSummaryQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
        }
    }

    static fromJS(data: any): GetSerialTicketRedeemOrderSummaryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSerialTicketRedeemOrderSummaryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        return data;
    }
}

/** Get an order summary, before placing the order, for a shop serial ticket redeem order. */
export interface IGetSerialTicketRedeemOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId: number;
}

/** A sellable shop serial ticket article. */
export class SellableSerialTicketArticleModel implements ISellableSerialTicketArticleModel {
    id!: number;
    name!: string;
    description!: string;
    price!: number;
    /** The currency for the price. */
    currency!: string;
    countryId!: string;
    /** The name of the country. */
    countryName!: string;
    ticketActivationDate!: Date | null;
    validityDurationType!: DurationType2;
    validityDuration!: number;
    rules!: string;
    /** The media item for the serial ticket. */
    media!: MediaItemDto;
    inactiveReason!: SerialTicketArticleInactiveReason | null;

    constructor(data?: ISellableSerialTicketArticleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.media = new MediaItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : <any>null;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : <any>null;
            this.ticketActivationDate = _data["ticketActivationDate"] ? new Date(_data["ticketActivationDate"].toString()) : <any>null;
            this.validityDurationType = _data["validityDurationType"] !== undefined ? _data["validityDurationType"] : <any>null;
            this.validityDuration = _data["validityDuration"] !== undefined ? _data["validityDuration"] : <any>null;
            this.rules = _data["rules"] !== undefined ? _data["rules"] : <any>null;
            this.media = _data["media"] ? MediaItemDto.fromJS(_data["media"]) : new MediaItemDto();
            this.inactiveReason = _data["inactiveReason"] !== undefined ? _data["inactiveReason"] : <any>null;
        }
    }

    static fromJS(data: any): SellableSerialTicketArticleModel {
        data = typeof data === 'object' ? data : {};
        let result = new SellableSerialTicketArticleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["countryId"] = this.countryId !== undefined ? this.countryId : <any>null;
        data["countryName"] = this.countryName !== undefined ? this.countryName : <any>null;
        data["ticketActivationDate"] = this.ticketActivationDate ? this.ticketActivationDate.toISOString() : <any>null;
        data["validityDurationType"] = this.validityDurationType !== undefined ? this.validityDurationType : <any>null;
        data["validityDuration"] = this.validityDuration !== undefined ? this.validityDuration : <any>null;
        data["rules"] = this.rules !== undefined ? this.rules : <any>null;
        data["media"] = this.media ? this.media.toJSON() : <any>null;
        data["inactiveReason"] = this.inactiveReason !== undefined ? this.inactiveReason : <any>null;
        return data;
    }
}

/** A sellable shop serial ticket article. */
export interface ISellableSerialTicketArticleModel {
    id: number;
    name: string;
    description: string;
    price: number;
    /** The currency for the price. */
    currency: string;
    countryId: string;
    /** The name of the country. */
    countryName: string;
    ticketActivationDate: Date | null;
    validityDurationType: DurationType2;
    validityDuration: number;
    rules: string;
    /** The media item for the serial ticket. */
    media: MediaItemDto;
    inactiveReason: SerialTicketArticleInactiveReason | null;
}

/** Connect serial ticket to account information. */
export class SerialTicketConnectToAccountInformationModel implements ISerialTicketConnectToAccountInformationModel {
    /** The name of the ticket article. */
    articleName!: string;
    /** The name of the users preferred playground. */
    playgroundName!: string | null;
    /** The date the ticket is valid from. */
    validFrom!: Date;
    /** The date the ticket is valid to. */
    validTo!: Date;
    /** The name of the company that sold the ticket. */
    companyName!: string;
    /** The number of entrances included in the ticket. */
    numberOfEntrances!: number;
    /** The email address of the current user. */
    accountEmail!: string | null;
    /** The article rules. */
    rules!: string;

    constructor(data?: ISerialTicketConnectToAccountInformationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : <any>null;
            this.playgroundName = _data["playgroundName"] !== undefined ? _data["playgroundName"] : <any>null;
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>null;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.numberOfEntrances = _data["numberOfEntrances"] !== undefined ? _data["numberOfEntrances"] : <any>null;
            this.accountEmail = _data["accountEmail"] !== undefined ? _data["accountEmail"] : <any>null;
            this.rules = _data["rules"] !== undefined ? _data["rules"] : <any>null;
        }
    }

    static fromJS(data: any): SerialTicketConnectToAccountInformationModel {
        data = typeof data === 'object' ? data : {};
        let result = new SerialTicketConnectToAccountInformationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleName"] = this.articleName !== undefined ? this.articleName : <any>null;
        data["playgroundName"] = this.playgroundName !== undefined ? this.playgroundName : <any>null;
        data["validFrom"] = this.validFrom ? formatDate(this.validFrom) : <any>null;
        data["validTo"] = this.validTo ? formatDate(this.validTo) : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["numberOfEntrances"] = this.numberOfEntrances !== undefined ? this.numberOfEntrances : <any>null;
        data["accountEmail"] = this.accountEmail !== undefined ? this.accountEmail : <any>null;
        data["rules"] = this.rules !== undefined ? this.rules : <any>null;
        return data;
    }
}

/** Connect serial ticket to account information. */
export interface ISerialTicketConnectToAccountInformationModel {
    /** The name of the ticket article. */
    articleName: string;
    /** The name of the users preferred playground. */
    playgroundName: string | null;
    /** The date the ticket is valid from. */
    validFrom: Date;
    /** The date the ticket is valid to. */
    validTo: Date;
    /** The name of the company that sold the ticket. */
    companyName: string;
    /** The number of entrances included in the ticket. */
    numberOfEntrances: number;
    /** The email address of the current user. */
    accountEmail: string | null;
    /** The article rules. */
    rules: string;
}

/** Direct order summary model. */
export class SerialTicketDirectOrderSummaryModel implements ISerialTicketDirectOrderSummaryModel {
    /** The article id in the order. */
    articleId!: number;
    /** The name of the article in the order. */
    articleName!: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName!: string;
    /** The playground id that the article will be assigned to after the purchase. */
    playgroundId!: string | null;
    /** The name of the playground that the article will be assigned to after the purchase. */
    playgroundName!: string | null;
    /** The total price of the order. */
    totalAmount!: number;
    /** The currency for the price. */
    currency!: string;
    /** The rules of the article. */
    rules!: string;
    /** The number of entrances the serial ticket will provide. */
    numberOfEntrances!: number;
    /** The start and end date of the serial ticket. */
    period!: SerialTicketValidPeriodModel;
    /** The order lines. */
    lines!: SerialTicketOrderSummaryLineModel[];

    constructor(data?: ISerialTicketDirectOrderSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.period = new SerialTicketValidPeriodModel();
            this.lines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.playgroundId = _data["playgroundId"] !== undefined ? _data["playgroundId"] : <any>null;
            this.playgroundName = _data["playgroundName"] !== undefined ? _data["playgroundName"] : <any>null;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.rules = _data["rules"] !== undefined ? _data["rules"] : <any>null;
            this.numberOfEntrances = _data["numberOfEntrances"] !== undefined ? _data["numberOfEntrances"] : <any>null;
            this.period = _data["period"] ? SerialTicketValidPeriodModel.fromJS(_data["period"]) : new SerialTicketValidPeriodModel();
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(SerialTicketOrderSummaryLineModel.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
        }
    }

    static fromJS(data: any): SerialTicketDirectOrderSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new SerialTicketDirectOrderSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["articleName"] = this.articleName !== undefined ? this.articleName : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["playgroundId"] = this.playgroundId !== undefined ? this.playgroundId : <any>null;
        data["playgroundName"] = this.playgroundName !== undefined ? this.playgroundName : <any>null;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["rules"] = this.rules !== undefined ? this.rules : <any>null;
        data["numberOfEntrances"] = this.numberOfEntrances !== undefined ? this.numberOfEntrances : <any>null;
        data["period"] = this.period ? this.period.toJSON() : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

/** Direct order summary model. */
export interface ISerialTicketDirectOrderSummaryModel {
    /** The article id in the order. */
    articleId: number;
    /** The name of the article in the order. */
    articleName: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName: string;
    /** The playground id that the article will be assigned to after the purchase. */
    playgroundId: string | null;
    /** The name of the playground that the article will be assigned to after the purchase. */
    playgroundName: string | null;
    /** The total price of the order. */
    totalAmount: number;
    /** The currency for the price. */
    currency: string;
    /** The rules of the article. */
    rules: string;
    /** The number of entrances the serial ticket will provide. */
    numberOfEntrances: number;
    /** The start and end date of the serial ticket. */
    period: SerialTicketValidPeriodModel;
    /** The order lines. */
    lines: SerialTicketOrderSummaryLineModel[];
}

/** A single order line in the summary model. */
export class SerialTicketOrderSummaryLineModel implements ISerialTicketOrderSummaryLineModel {
    /** The id of the article for the line. */
    articleId!: number;
    /** The name of the article for the line. */
    articleName!: string;
    /** The quantity ordered. */
    quantity!: number;
    /** The total amount for the line. */
    amount!: number;

    constructor(data?: ISerialTicketOrderSummaryLineModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
        }
    }

    static fromJS(data: any): SerialTicketOrderSummaryLineModel {
        data = typeof data === 'object' ? data : {};
        let result = new SerialTicketOrderSummaryLineModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["articleName"] = this.articleName !== undefined ? this.articleName : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        return data;
    }
}

/** A single order line in the summary model. */
export interface ISerialTicketOrderSummaryLineModel {
    /** The id of the article for the line. */
    articleId: number;
    /** The name of the article for the line. */
    articleName: string;
    /** The quantity ordered. */
    quantity: number;
    /** The total amount for the line. */
    amount: number;
}

/** Redeem order summary model. */
export class SerialTicketRedeemOrderSummaryModel implements ISerialTicketRedeemOrderSummaryModel {
    /** The article id in the order. */
    articleId!: number;
    /** The name of the article in the order. */
    articleName!: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName!: string;
    /** The total price of the order. */
    totalAmount!: number;
    /** The currency for the price. */
    currency!: string;
    /** The rules of the article. */
    rules!: string;
    /** The number of entrances the serial ticket will provide. */
    numberOfEntrances!: number;
    /** The start and end date of the serial ticket. */
    period!: SerialTicketValidPeriodModel;
    /** The order lines. */
    lines!: SerialTicketOrderSummaryLineModel[];

    constructor(data?: ISerialTicketRedeemOrderSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.period = new SerialTicketValidPeriodModel();
            this.lines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : <any>null;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : <any>null;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : <any>null;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.rules = _data["rules"] !== undefined ? _data["rules"] : <any>null;
            this.numberOfEntrances = _data["numberOfEntrances"] !== undefined ? _data["numberOfEntrances"] : <any>null;
            this.period = _data["period"] ? SerialTicketValidPeriodModel.fromJS(_data["period"]) : new SerialTicketValidPeriodModel();
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(SerialTicketOrderSummaryLineModel.fromJS(item));
            }
            else {
                this.lines = <any>null;
            }
        }
    }

    static fromJS(data: any): SerialTicketRedeemOrderSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new SerialTicketRedeemOrderSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : <any>null;
        data["articleName"] = this.articleName !== undefined ? this.articleName : <any>null;
        data["companyName"] = this.companyName !== undefined ? this.companyName : <any>null;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["rules"] = this.rules !== undefined ? this.rules : <any>null;
        data["numberOfEntrances"] = this.numberOfEntrances !== undefined ? this.numberOfEntrances : <any>null;
        data["period"] = this.period ? this.period.toJSON() : <any>null;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item.toJSON());
        }
        return data;
    }
}

/** Redeem order summary model. */
export interface ISerialTicketRedeemOrderSummaryModel {
    /** The article id in the order. */
    articleId: number;
    /** The name of the article in the order. */
    articleName: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName: string;
    /** The total price of the order. */
    totalAmount: number;
    /** The currency for the price. */
    currency: string;
    /** The rules of the article. */
    rules: string;
    /** The number of entrances the serial ticket will provide. */
    numberOfEntrances: number;
    /** The start and end date of the serial ticket. */
    period: SerialTicketValidPeriodModel;
    /** The order lines. */
    lines: SerialTicketOrderSummaryLineModel[];
}

/** A subscription for a child. */
export class PeriodSubscriptionDto implements IPeriodSubscriptionDto {
    /** The id of the subscription. */
    guid!: string;
    /** The name of the subscription, e.g. "Annual". */
    name!: string;
    /** The validity period for the subscription. */
    period!: PassPeriodDto;
    /** Information about the child that the subscription is for. */
    child!: PeriodSubscriptionPeriodSubscriptionChildDto;
    /** The current state of the subscription. */
    state!: PeriodSubscriptionState;
    /** The code for the QR code generator. */
    code!: string;
    /** True if a photo can be uploaded for the pass. */
    canUploadPhoto!: boolean;

    constructor(data?: IPeriodSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.period = new PassPeriodDto();
            this.child = new PeriodSubscriptionPeriodSubscriptionChildDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.period = _data["period"] ? PassPeriodDto.fromJS(_data["period"]) : new PassPeriodDto();
            this.child = _data["child"] ? PeriodSubscriptionPeriodSubscriptionChildDto.fromJS(_data["child"]) : new PeriodSubscriptionPeriodSubscriptionChildDto();
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.canUploadPhoto = _data["canUploadPhoto"] !== undefined ? _data["canUploadPhoto"] : <any>null;
        }
    }

    static fromJS(data: any): PeriodSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["period"] = this.period ? this.period.toJSON() : <any>null;
        data["child"] = this.child ? this.child.toJSON() : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["canUploadPhoto"] = this.canUploadPhoto !== undefined ? this.canUploadPhoto : <any>null;
        return data;
    }
}

/** A subscription for a child. */
export interface IPeriodSubscriptionDto {
    /** The id of the subscription. */
    guid: string;
    /** The name of the subscription, e.g. "Annual". */
    name: string;
    /** The validity period for the subscription. */
    period: PassPeriodDto;
    /** Information about the child that the subscription is for. */
    child: PeriodSubscriptionPeriodSubscriptionChildDto;
    /** The current state of the subscription. */
    state: PeriodSubscriptionState;
    /** The code for the QR code generator. */
    code: string;
    /** True if a photo can be uploaded for the pass. */
    canUploadPhoto: boolean;
}

/** Child information for a Leo.Application.Subscriptions.Queries.Models.PeriodSubscriptionDto. */
export class PeriodSubscriptionPeriodSubscriptionChildDto implements IPeriodSubscriptionPeriodSubscriptionChildDto {
    /** The id of the child. */
    guid!: string;
    /** The first name of the child. */
    firstName!: string;
    /** The last name of the child, may be null. */
    lastName!: string | null;

    constructor(data?: IPeriodSubscriptionPeriodSubscriptionChildDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
        }
    }

    static fromJS(data: any): PeriodSubscriptionPeriodSubscriptionChildDto {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodSubscriptionPeriodSubscriptionChildDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        return data;
    }
}

/** Child information for a Leo.Application.Subscriptions.Queries.Models.PeriodSubscriptionDto. */
export interface IPeriodSubscriptionPeriodSubscriptionChildDto {
    /** The id of the child. */
    guid: string;
    /** The first name of the child. */
    firstName: string;
    /** The last name of the child, may be null. */
    lastName: string | null;
}

/** The different states that a Leo.Application.Subscriptions.Queries.Models.PeriodSubscriptionDto can be in. */
export enum PeriodSubscriptionState {
    Active = "Active",
    Upcoming = "Upcoming",
    Expired = "Expired",
}

/** Summary of available child subscriptions. */
export class PeriodSubscriptionSummaryDto implements IPeriodSubscriptionSummaryDto {
    /** The id of the parent for the subscriptions. */
    parentId!: string;
    /** All subscriptions that are currently active (may include multiple per child), may depend on the request parameters. */
    allActive!: PeriodSubscriptionDto[];
    /** All subscriptions that are currently expired (may include multiple per child), may depend on the request parameters. */
    allExpired!: PeriodSubscriptionDto[];
    /** All subscriptions that are currently not active but will become active in the future (may include multiple per child), may depend on the request parameters. */
    allUpcoming!: PeriodSubscriptionDto[];
    /** All subscriptions, one (1) per child, that can be used for purchases. */
    currentlyUsable!: PeriodSubscriptionDto[];

    constructor(data?: IPeriodSubscriptionSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.allActive = [];
            this.allExpired = [];
            this.allUpcoming = [];
            this.currentlyUsable = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentId = _data["parentId"] !== undefined ? _data["parentId"] : <any>null;
            if (Array.isArray(_data["allActive"])) {
                this.allActive = [] as any;
                for (let item of _data["allActive"])
                    this.allActive!.push(PeriodSubscriptionDto.fromJS(item));
            }
            else {
                this.allActive = <any>null;
            }
            if (Array.isArray(_data["allExpired"])) {
                this.allExpired = [] as any;
                for (let item of _data["allExpired"])
                    this.allExpired!.push(PeriodSubscriptionDto.fromJS(item));
            }
            else {
                this.allExpired = <any>null;
            }
            if (Array.isArray(_data["allUpcoming"])) {
                this.allUpcoming = [] as any;
                for (let item of _data["allUpcoming"])
                    this.allUpcoming!.push(PeriodSubscriptionDto.fromJS(item));
            }
            else {
                this.allUpcoming = <any>null;
            }
            if (Array.isArray(_data["currentlyUsable"])) {
                this.currentlyUsable = [] as any;
                for (let item of _data["currentlyUsable"])
                    this.currentlyUsable!.push(PeriodSubscriptionDto.fromJS(item));
            }
            else {
                this.currentlyUsable = <any>null;
            }
        }
    }

    static fromJS(data: any): PeriodSubscriptionSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodSubscriptionSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentId"] = this.parentId !== undefined ? this.parentId : <any>null;
        if (Array.isArray(this.allActive)) {
            data["allActive"] = [];
            for (let item of this.allActive)
                data["allActive"].push(item.toJSON());
        }
        if (Array.isArray(this.allExpired)) {
            data["allExpired"] = [];
            for (let item of this.allExpired)
                data["allExpired"].push(item.toJSON());
        }
        if (Array.isArray(this.allUpcoming)) {
            data["allUpcoming"] = [];
            for (let item of this.allUpcoming)
                data["allUpcoming"].push(item.toJSON());
        }
        if (Array.isArray(this.currentlyUsable)) {
            data["currentlyUsable"] = [];
            for (let item of this.currentlyUsable)
                data["currentlyUsable"].push(item.toJSON());
        }
        return data;
    }
}

/** Summary of available child subscriptions. */
export interface IPeriodSubscriptionSummaryDto {
    /** The id of the parent for the subscriptions. */
    parentId: string;
    /** All subscriptions that are currently active (may include multiple per child), may depend on the request parameters. */
    allActive: PeriodSubscriptionDto[];
    /** All subscriptions that are currently expired (may include multiple per child), may depend on the request parameters. */
    allExpired: PeriodSubscriptionDto[];
    /** All subscriptions that are currently not active but will become active in the future (may include multiple per child), may depend on the request parameters. */
    allUpcoming: PeriodSubscriptionDto[];
    /** All subscriptions, one (1) per child, that can be used for purchases. */
    currentlyUsable: PeriodSubscriptionDto[];
}

/** Create a new child class booking. */
export class CreateChildClassBookingCommand implements ICreateChildClassBookingCommand {
    childClassAgeGroupId!: number;
    email!: string;
    parentFirstName!: string;
    parentLastName!: string;
    /** The phone number, without the country code. */
    phone!: string;
    /** The phone country code. */
    phoneCountryCode!: number;
    /** GDPR If the users disallow notifications on emails and sms for newsletters, offers.
IMPORTANT: Will be ignored if the currently authenticated user is an administrator, if the user exists the setting will be kept
unchanged and if the user is not registered since earlier the value "true" will be used. */
    gdprDisallowInformation!: boolean;
    /** GDPR If the users allow notifications on emails and sms for newsletters from partners, offers.
IMPORTANT: Will be ignored if the currently authenticated user is an administrator, if the user exists the setting will be kept */
    gdprAllowPartnerInformation!: boolean;
    childFirstName!: string;
    childLastName!: string;
    childBirthdate!: Date;
    allergies!: string | null;
    otherInformation!: string | null;
    tshirtSize!: string | null;

    constructor(data?: ICreateChildClassBookingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.childClassAgeGroupId = _data["childClassAgeGroupId"] !== undefined ? _data["childClassAgeGroupId"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.parentFirstName = _data["parentFirstName"] !== undefined ? _data["parentFirstName"] : <any>null;
            this.parentLastName = _data["parentLastName"] !== undefined ? _data["parentLastName"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.phoneCountryCode = _data["phoneCountryCode"] !== undefined ? _data["phoneCountryCode"] : <any>null;
            this.gdprDisallowInformation = _data["gdprDisallowInformation"] !== undefined ? _data["gdprDisallowInformation"] : <any>null;
            this.gdprAllowPartnerInformation = _data["gdprAllowPartnerInformation"] !== undefined ? _data["gdprAllowPartnerInformation"] : <any>null;
            this.childFirstName = _data["childFirstName"] !== undefined ? _data["childFirstName"] : <any>null;
            this.childLastName = _data["childLastName"] !== undefined ? _data["childLastName"] : <any>null;
            this.childBirthdate = _data["childBirthdate"] ? new Date(_data["childBirthdate"].toString()) : <any>null;
            this.allergies = _data["allergies"] !== undefined ? _data["allergies"] : <any>null;
            this.otherInformation = _data["otherInformation"] !== undefined ? _data["otherInformation"] : <any>null;
            this.tshirtSize = _data["tshirtSize"] !== undefined ? _data["tshirtSize"] : <any>null;
        }
    }

    static fromJS(data: any): CreateChildClassBookingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChildClassBookingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["childClassAgeGroupId"] = this.childClassAgeGroupId !== undefined ? this.childClassAgeGroupId : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["parentFirstName"] = this.parentFirstName !== undefined ? this.parentFirstName : <any>null;
        data["parentLastName"] = this.parentLastName !== undefined ? this.parentLastName : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["phoneCountryCode"] = this.phoneCountryCode !== undefined ? this.phoneCountryCode : <any>null;
        data["gdprDisallowInformation"] = this.gdprDisallowInformation !== undefined ? this.gdprDisallowInformation : <any>null;
        data["gdprAllowPartnerInformation"] = this.gdprAllowPartnerInformation !== undefined ? this.gdprAllowPartnerInformation : <any>null;
        data["childFirstName"] = this.childFirstName !== undefined ? this.childFirstName : <any>null;
        data["childLastName"] = this.childLastName !== undefined ? this.childLastName : <any>null;
        data["childBirthdate"] = this.childBirthdate ? this.childBirthdate.toISOString() : <any>null;
        data["allergies"] = this.allergies !== undefined ? this.allergies : <any>null;
        data["otherInformation"] = this.otherInformation !== undefined ? this.otherInformation : <any>null;
        data["tshirtSize"] = this.tshirtSize !== undefined ? this.tshirtSize : <any>null;
        return data;
    }
}

/** Create a new child class booking. */
export interface ICreateChildClassBookingCommand {
    childClassAgeGroupId: number;
    email: string;
    parentFirstName: string;
    parentLastName: string;
    /** The phone number, without the country code. */
    phone: string;
    /** The phone country code. */
    phoneCountryCode: number;
    /** GDPR If the users disallow notifications on emails and sms for newsletters, offers.
IMPORTANT: Will be ignored if the currently authenticated user is an administrator, if the user exists the setting will be kept
unchanged and if the user is not registered since earlier the value "true" will be used. */
    gdprDisallowInformation: boolean;
    /** GDPR If the users allow notifications on emails and sms for newsletters from partners, offers.
IMPORTANT: Will be ignored if the currently authenticated user is an administrator, if the user exists the setting will be kept */
    gdprAllowPartnerInformation: boolean;
    childFirstName: string;
    childLastName: string;
    childBirthdate: Date;
    allergies: string | null;
    otherInformation: string | null;
    tshirtSize: string | null;
}

/** Response after creating a new booking. */
export class CreateChildClassBookingResultDto implements ICreateChildClassBookingResultDto {
    guid!: string;
    orderReference!: string;

    constructor(data?: ICreateChildClassBookingResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.orderReference = _data["orderReference"] !== undefined ? _data["orderReference"] : <any>null;
        }
    }

    static fromJS(data: any): CreateChildClassBookingResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChildClassBookingResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["orderReference"] = this.orderReference !== undefined ? this.orderReference : <any>null;
        return data;
    }
}

/** Response after creating a new booking. */
export interface ICreateChildClassBookingResultDto {
    guid: string;
    orderReference: string;
}

/** Possible crop options when resizing an image. */
export enum ImageCropOptions {
    Cover = "Cover",
    Contain = "Contain",
    Resize = "Resize",
    Fill = "Fill",
}

/** Party location configuration values. */
export class PartyLocationConfigurationDto implements IPartyLocationConfigurationDto {
    partyEnableChoosePlayTime!: boolean;
    partyLengthMinutes!: number | null;

    constructor(data?: IPartyLocationConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partyEnableChoosePlayTime = _data["partyEnableChoosePlayTime"] !== undefined ? _data["partyEnableChoosePlayTime"] : <any>null;
            this.partyLengthMinutes = _data["partyLengthMinutes"] !== undefined ? _data["partyLengthMinutes"] : <any>null;
        }
    }

    static fromJS(data: any): PartyLocationConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyLocationConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partyEnableChoosePlayTime"] = this.partyEnableChoosePlayTime !== undefined ? this.partyEnableChoosePlayTime : <any>null;
        data["partyLengthMinutes"] = this.partyLengthMinutes !== undefined ? this.partyLengthMinutes : <any>null;
        return data;
    }
}

/** Party location configuration values. */
export interface IPartyLocationConfigurationDto {
    partyEnableChoosePlayTime: boolean;
    partyLengthMinutes: number | null;
}

/** DTO for a user entrance discount. */
export class UserEntranceDiscountDto implements IUserEntranceDiscountDto {
    /** Id of the discount. */
    guid!: string;
    /** The type of discount. */
    type!: UserEntranceDiscountType;
    /** The discount amount as a percentage (1% - 100%), e.g. 25 for 25%. */
    percentageAmount!: number;
    /** The discount cannot be used before this date. */
    validFrom!: Date;
    /** The discount cannot be used past this date. */
    validUntil!: Date;

    constructor(data?: IUserEntranceDiscountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.percentageAmount = _data["percentageAmount"] !== undefined ? _data["percentageAmount"] : <any>null;
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : <any>null;
            this.validUntil = _data["validUntil"] ? new Date(_data["validUntil"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UserEntranceDiscountDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserEntranceDiscountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["percentageAmount"] = this.percentageAmount !== undefined ? this.percentageAmount : <any>null;
        data["validFrom"] = this.validFrom ? this.validFrom.toISOString() : <any>null;
        data["validUntil"] = this.validUntil ? this.validUntil.toISOString() : <any>null;
        return data;
    }
}

/** DTO for a user entrance discount. */
export interface IUserEntranceDiscountDto {
    /** Id of the discount. */
    guid: string;
    /** The type of discount. */
    type: UserEntranceDiscountType;
    /** The discount amount as a percentage (1% - 100%), e.g. 25 for 25%. */
    percentageAmount: number;
    /** The discount cannot be used before this date. */
    validFrom: Date;
    /** The discount cannot be used past this date. */
    validUntil: Date;
}

export enum ChangeEntranceBookingV2CommandValidatorErrorCodes {
    NotChangeable = "NotChangeable",
}

/** A command request for cancelling a party booking. */
export class CancelPartyBookingCommand implements ICancelPartyBookingCommand {
    /** The id of the booking to cancel */
    guid!: string;
    /** The message to send to the booker after cancellation. */
    bookerMessage!: string | null;
    /** The message to send to the guests after cancellation. */
    guestMessage!: string | null;
    /** The reason for the cancellation. */
    reason!: string | null;

    constructor(data?: ICancelPartyBookingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.bookerMessage = _data["bookerMessage"] !== undefined ? _data["bookerMessage"] : <any>null;
            this.guestMessage = _data["guestMessage"] !== undefined ? _data["guestMessage"] : <any>null;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : <any>null;
        }
    }

    static fromJS(data: any): CancelPartyBookingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPartyBookingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["bookerMessage"] = this.bookerMessage !== undefined ? this.bookerMessage : <any>null;
        data["guestMessage"] = this.guestMessage !== undefined ? this.guestMessage : <any>null;
        data["reason"] = this.reason !== undefined ? this.reason : <any>null;
        return data;
    }
}

/** A command request for cancelling a party booking. */
export interface ICancelPartyBookingCommand {
    /** The id of the booking to cancel */
    guid: string;
    /** The message to send to the booker after cancellation. */
    bookerMessage: string | null;
    /** The message to send to the guests after cancellation. */
    guestMessage: string | null;
    /** The reason for the cancellation. */
    reason: string | null;
}

/** The type of a time interval */
export enum IntervalType {
    Play = "Play",
    Party = "Party",
}

/** One alternative for play and party time distribution */
export class PartyBookingPlayTime implements IPartyBookingPlayTime {
    /** A list of play and party times */
    timeIntervals!: TimeInterval[];
    /** The arrival time for the party if this play time is chosen */
    readonly arrivalTime!: string;
    /** True if this distribution of play and party times are within the opening hours of the playground */
    available!: boolean;

    constructor(data?: IPartyBookingPlayTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["timeIntervals"])) {
                this.timeIntervals = [] as any;
                for (let item of _data["timeIntervals"])
                    this.timeIntervals!.push(TimeInterval.fromJS(item));
            }
            else {
                this.timeIntervals = <any>null;
            }
            (<any>this).arrivalTime = _data["arrivalTime"] !== undefined ? _data["arrivalTime"] : <any>null;
            this.available = _data["available"] !== undefined ? _data["available"] : <any>null;
        }
    }

    static fromJS(data: any): PartyBookingPlayTime {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingPlayTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.timeIntervals)) {
            data["timeIntervals"] = [];
            for (let item of this.timeIntervals)
                data["timeIntervals"].push(item.toJSON());
        }
        data["arrivalTime"] = this.arrivalTime !== undefined ? this.arrivalTime : <any>null;
        data["available"] = this.available !== undefined ? this.available : <any>null;
        return data;
    }
}

/** One alternative for play and party time distribution */
export interface IPartyBookingPlayTime {
    /** A list of play and party times */
    timeIntervals: TimeInterval[];
    /** The arrival time for the party if this play time is chosen */
    arrivalTime: string;
    /** True if this distribution of play and party times are within the opening hours of the playground */
    available: boolean;
}

/** One interval of time that is either play time or party time */
export class TimeInterval implements ITimeInterval {
    /** The start time of the interval */
    start!: string;
    /** The end time of the interval */
    end!: string;
    /** The type of the interval */
    type!: IntervalType;
    readonly displayStart!: string;
    readonly displayEnd!: string;

    constructor(data?: ITimeInterval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] !== undefined ? _data["start"] : <any>null;
            this.end = _data["end"] !== undefined ? _data["end"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            (<any>this).displayStart = _data["displayStart"] !== undefined ? _data["displayStart"] : <any>null;
            (<any>this).displayEnd = _data["displayEnd"] !== undefined ? _data["displayEnd"] : <any>null;
        }
    }

    static fromJS(data: any): TimeInterval {
        data = typeof data === 'object' ? data : {};
        let result = new TimeInterval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start !== undefined ? this.start : <any>null;
        data["end"] = this.end !== undefined ? this.end : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["displayStart"] = this.displayStart !== undefined ? this.displayStart : <any>null;
        data["displayEnd"] = this.displayEnd !== undefined ? this.displayEnd : <any>null;
        return data;
    }
}

/** One interval of time that is either play time or party time */
export interface ITimeInterval {
    /** The start time of the interval */
    start: string;
    /** The end time of the interval */
    end: string;
    /** The type of the interval */
    type: IntervalType;
    displayStart: string;
    displayEnd: string;
}

/** The steps that the user may have to complete to complete the account steps. */
export enum AccountProgressStep {
    SignUp = "SignUp",
    ConfirmEmail = "ConfirmEmail",
    AddChildren = "AddChildren",
}

/** Account progress information for an user account. */
export class UserGatheringAccountProgressDto implements IUserGatheringAccountProgressDto {
    /** The total percentage of the account steps that has already been completed. */
    percentage!: number;
    /** The next step the user should perform to increase the account progress. */
    readonly nextStep!: AccountProgressStep | null;
    /** The steps that still needs to be completed to complete the account progress. */
    remainingSteps!: AccountProgressStep[];

    constructor(data?: IUserGatheringAccountProgressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.remainingSteps = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.percentage = _data["percentage"] !== undefined ? _data["percentage"] : <any>null;
            (<any>this).nextStep = _data["nextStep"] !== undefined ? _data["nextStep"] : <any>null;
            if (Array.isArray(_data["remainingSteps"])) {
                this.remainingSteps = [] as any;
                for (let item of _data["remainingSteps"])
                    this.remainingSteps!.push(item);
            }
            else {
                this.remainingSteps = <any>null;
            }
        }
    }

    static fromJS(data: any): UserGatheringAccountProgressDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGatheringAccountProgressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["percentage"] = this.percentage !== undefined ? this.percentage : <any>null;
        data["nextStep"] = this.nextStep !== undefined ? this.nextStep : <any>null;
        if (Array.isArray(this.remainingSteps)) {
            data["remainingSteps"] = [];
            for (let item of this.remainingSteps)
                data["remainingSteps"].push(item);
        }
        return data;
    }
}

/** Account progress information for an user account. */
export interface IUserGatheringAccountProgressDto {
    /** The total percentage of the account steps that has already been completed. */
    percentage: number;
    /** The next step the user should perform to increase the account progress. */
    nextStep: AccountProgressStep | null;
    /** The steps that still needs to be completed to complete the account progress. */
    remainingSteps: AccountProgressStep[];
}

/** DTO object for the user gathering. */
export class UserGatheringDto implements IUserGatheringDto {
    /** Amount of active offers */
    activeOffers!: number | null;
    /** Amount of active party bookings */
    activePartyBookings!: number | null;
    /** Amount of active entrance bookings */
    activeEntranceBookings!: number | null;
    /** Amount of active sport-kidz bookings */
    activeSportKidzBookings!: number | null;
    /** Amount of active camp bookings */
    activeLeoCampBookings!: number | null;
    /** The number of active or upcoming subscriptions, may include multiple subscriptions per child. */
    activeSubscriptions!: number | null;
    /** The number of active or upcoming serial tickets. */
    activeSerialTickets!: number | null;
    /** The number of child accounts for the parent account. */
    childAccounts!: number | null;
    /** The current account progress for completing the account. */
    accountProgress!: UserGatheringAccountProgressDto | null;

    constructor(data?: IUserGatheringDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.activeOffers = _data["activeOffers"] !== undefined ? _data["activeOffers"] : <any>null;
            this.activePartyBookings = _data["activePartyBookings"] !== undefined ? _data["activePartyBookings"] : <any>null;
            this.activeEntranceBookings = _data["activeEntranceBookings"] !== undefined ? _data["activeEntranceBookings"] : <any>null;
            this.activeSportKidzBookings = _data["activeSportKidzBookings"] !== undefined ? _data["activeSportKidzBookings"] : <any>null;
            this.activeLeoCampBookings = _data["activeLeoCampBookings"] !== undefined ? _data["activeLeoCampBookings"] : <any>null;
            this.activeSubscriptions = _data["activeSubscriptions"] !== undefined ? _data["activeSubscriptions"] : <any>null;
            this.activeSerialTickets = _data["activeSerialTickets"] !== undefined ? _data["activeSerialTickets"] : <any>null;
            this.childAccounts = _data["childAccounts"] !== undefined ? _data["childAccounts"] : <any>null;
            this.accountProgress = _data["accountProgress"] ? UserGatheringAccountProgressDto.fromJS(_data["accountProgress"]) : <any>null;
        }
    }

    static fromJS(data: any): UserGatheringDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserGatheringDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["activeOffers"] = this.activeOffers !== undefined ? this.activeOffers : <any>null;
        data["activePartyBookings"] = this.activePartyBookings !== undefined ? this.activePartyBookings : <any>null;
        data["activeEntranceBookings"] = this.activeEntranceBookings !== undefined ? this.activeEntranceBookings : <any>null;
        data["activeSportKidzBookings"] = this.activeSportKidzBookings !== undefined ? this.activeSportKidzBookings : <any>null;
        data["activeLeoCampBookings"] = this.activeLeoCampBookings !== undefined ? this.activeLeoCampBookings : <any>null;
        data["activeSubscriptions"] = this.activeSubscriptions !== undefined ? this.activeSubscriptions : <any>null;
        data["activeSerialTickets"] = this.activeSerialTickets !== undefined ? this.activeSerialTickets : <any>null;
        data["childAccounts"] = this.childAccounts !== undefined ? this.childAccounts : <any>null;
        data["accountProgress"] = this.accountProgress ? this.accountProgress.toJSON() : <any>null;
        return data;
    }
}

/** DTO object for the user gathering. */
export interface IUserGatheringDto {
    /** Amount of active offers */
    activeOffers: number | null;
    /** Amount of active party bookings */
    activePartyBookings: number | null;
    /** Amount of active entrance bookings */
    activeEntranceBookings: number | null;
    /** Amount of active sport-kidz bookings */
    activeSportKidzBookings: number | null;
    /** Amount of active camp bookings */
    activeLeoCampBookings: number | null;
    /** The number of active or upcoming subscriptions, may include multiple subscriptions per child. */
    activeSubscriptions: number | null;
    /** The number of active or upcoming serial tickets. */
    activeSerialTickets: number | null;
    /** The number of child accounts for the parent account. */
    childAccounts: number | null;
    /** The current account progress for completing the account. */
    accountProgress: UserGatheringAccountProgressDto | null;
}

/** Update the email preferences for the user. */
export class UpdateUserEmailPreferencesCommand implements IUpdateUserEmailPreferencesCommand {
    /** The id of the user to update preferences for. */
    userId!: string;
    /** True to disallow information emails, false otherwise. */
    gdprDisallowInformation!: boolean;
    /** True to disallow information SMS, false otherwise. */
    gdprDisallowSms!: boolean;
    /** If the user allows information for newsletter, offers and discounts from partners */
    gdprAllowPartnerInformation!: boolean;
    /** If the user allows information SMS from partners */
    gdprAllowPartnerSms!: boolean;

    constructor(data?: IUpdateUserEmailPreferencesCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.gdprDisallowInformation = _data["gdprDisallowInformation"] !== undefined ? _data["gdprDisallowInformation"] : <any>null;
            this.gdprDisallowSms = _data["gdprDisallowSms"] !== undefined ? _data["gdprDisallowSms"] : <any>null;
            this.gdprAllowPartnerInformation = _data["gdprAllowPartnerInformation"] !== undefined ? _data["gdprAllowPartnerInformation"] : <any>null;
            this.gdprAllowPartnerSms = _data["gdprAllowPartnerSms"] !== undefined ? _data["gdprAllowPartnerSms"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateUserEmailPreferencesCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserEmailPreferencesCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["gdprDisallowInformation"] = this.gdprDisallowInformation !== undefined ? this.gdprDisallowInformation : <any>null;
        data["gdprDisallowSms"] = this.gdprDisallowSms !== undefined ? this.gdprDisallowSms : <any>null;
        data["gdprAllowPartnerInformation"] = this.gdprAllowPartnerInformation !== undefined ? this.gdprAllowPartnerInformation : <any>null;
        data["gdprAllowPartnerSms"] = this.gdprAllowPartnerSms !== undefined ? this.gdprAllowPartnerSms : <any>null;
        return data;
    }
}

/** Update the email preferences for the user. */
export interface IUpdateUserEmailPreferencesCommand {
    /** The id of the user to update preferences for. */
    userId: string;
    /** True to disallow information emails, false otherwise. */
    gdprDisallowInformation: boolean;
    /** True to disallow information SMS, false otherwise. */
    gdprDisallowSms: boolean;
    /** If the user allows information for newsletter, offers and discounts from partners */
    gdprAllowPartnerInformation: boolean;
    /** If the user allows information SMS from partners */
    gdprAllowPartnerSms: boolean;
}

/** Current email preferences for a user. */
export class UserEmailPreferencesModel implements IUserEmailPreferencesModel {
    /** True to disallow information emails, false otherwise. */
    disallowInformation!: boolean;
    /** True to disallow information sms, false otherwise. */
    disallowSms!: boolean;
    /** True to allow information from partners, false otherwise. */
    allowPartnerInformation!: boolean;
    /** True to allow information sms, false otherwise. */
    allowPartnerSms!: boolean;

    constructor(data?: IUserEmailPreferencesModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.disallowInformation = _data["disallowInformation"] !== undefined ? _data["disallowInformation"] : <any>null;
            this.disallowSms = _data["disallowSms"] !== undefined ? _data["disallowSms"] : <any>null;
            this.allowPartnerInformation = _data["allowPartnerInformation"] !== undefined ? _data["allowPartnerInformation"] : <any>null;
            this.allowPartnerSms = _data["allowPartnerSms"] !== undefined ? _data["allowPartnerSms"] : <any>null;
        }
    }

    static fromJS(data: any): UserEmailPreferencesModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserEmailPreferencesModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["disallowInformation"] = this.disallowInformation !== undefined ? this.disallowInformation : <any>null;
        data["disallowSms"] = this.disallowSms !== undefined ? this.disallowSms : <any>null;
        data["allowPartnerInformation"] = this.allowPartnerInformation !== undefined ? this.allowPartnerInformation : <any>null;
        data["allowPartnerSms"] = this.allowPartnerSms !== undefined ? this.allowPartnerSms : <any>null;
        return data;
    }
}

/** Current email preferences for a user. */
export interface IUserEmailPreferencesModel {
    /** True to disallow information emails, false otherwise. */
    disallowInformation: boolean;
    /** True to disallow information sms, false otherwise. */
    disallowSms: boolean;
    /** True to allow information from partners, false otherwise. */
    allowPartnerInformation: boolean;
    /** True to allow information sms, false otherwise. */
    allowPartnerSms: boolean;
}

/** Onboarding status for the currently authenticated user. */
export class UserOnboardingStatusModel implements IUserOnboardingStatusModel {
    /** The next step for the user. */
    nextStep!: UserOnboardingStep;

    constructor(data?: IUserOnboardingStatusModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nextStep = _data["nextStep"] !== undefined ? _data["nextStep"] : <any>null;
        }
    }

    static fromJS(data: any): UserOnboardingStatusModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserOnboardingStatusModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nextStep"] = this.nextStep !== undefined ? this.nextStep : <any>null;
        return data;
    }
}

/** Onboarding status for the currently authenticated user. */
export interface IUserOnboardingStatusModel {
    /** The next step for the user. */
    nextStep: UserOnboardingStep;
}

/** The onboarding step that the user should continue to during authentication. */
export enum UserOnboardingStep {
    AddChildren = "AddChildren",
    AddPhone = "AddPhone",
    Continue = "Continue",
}

/** A purchase event that can be tracked in Google Analytics. */
export class ShopPurchaseEvent implements IShopPurchaseEvent {
    /** The event name. */
    event!: string;
    /** The event affiliation. */
    readonly transactionAffiliation!: string;
    /** The order reference. */
    transactionId!: string;
    /** The order total, including tax. */
    transactionTotal!: number;
    /** The currency of the transaction. */
    transactionCurrency!: string;
    /** The products for the order. */
    transactionProducts!: ShopPurchaseEventProduct[];

    constructor(data?: IShopPurchaseEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.transactionProducts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"] !== undefined ? _data["event"] : <any>null;
            (<any>this).transactionAffiliation = _data["transactionAffiliation"] !== undefined ? _data["transactionAffiliation"] : <any>null;
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : <any>null;
            this.transactionTotal = _data["transactionTotal"] !== undefined ? _data["transactionTotal"] : <any>null;
            this.transactionCurrency = _data["transactionCurrency"] !== undefined ? _data["transactionCurrency"] : <any>null;
            if (Array.isArray(_data["transactionProducts"])) {
                this.transactionProducts = [] as any;
                for (let item of _data["transactionProducts"])
                    this.transactionProducts!.push(ShopPurchaseEventProduct.fromJS(item));
            }
            else {
                this.transactionProducts = <any>null;
            }
        }
    }

    static fromJS(data: any): ShopPurchaseEvent {
        data = typeof data === 'object' ? data : {};
        let result = new ShopPurchaseEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event !== undefined ? this.event : <any>null;
        data["transactionAffiliation"] = this.transactionAffiliation !== undefined ? this.transactionAffiliation : <any>null;
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : <any>null;
        data["transactionTotal"] = this.transactionTotal !== undefined ? this.transactionTotal : <any>null;
        data["transactionCurrency"] = this.transactionCurrency !== undefined ? this.transactionCurrency : <any>null;
        if (Array.isArray(this.transactionProducts)) {
            data["transactionProducts"] = [];
            for (let item of this.transactionProducts)
                data["transactionProducts"].push(item.toJSON());
        }
        return data;
    }
}

/** A purchase event that can be tracked in Google Analytics. */
export interface IShopPurchaseEvent {
    /** The event name. */
    event: string;
    /** The event affiliation. */
    transactionAffiliation: string;
    /** The order reference. */
    transactionId: string;
    /** The order total, including tax. */
    transactionTotal: number;
    /** The currency of the transaction. */
    transactionCurrency: string;
    /** The products for the order. */
    transactionProducts: ShopPurchaseEventProduct[];
}

/** A product row for Leo.BackendApi.Areas.Api.Models.Analytics.ShopPurchaseEvent. */
export class ShopPurchaseEventProduct implements IShopPurchaseEventProduct {
    /** The name of the product. */
    name!: string;
    /** The article number/sku for the product. */
    sku!: string;
    /** The category for the product. */
    category!: string;
    /** The total price for the row. */
    price!: number;
    /** The quantity for the product. */
    quantity!: number;

    constructor(data?: IShopPurchaseEventProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.sku = _data["sku"] !== undefined ? _data["sku"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : <any>null;
        }
    }

    static fromJS(data: any): ShopPurchaseEventProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ShopPurchaseEventProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["sku"] = this.sku !== undefined ? this.sku : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["quantity"] = this.quantity !== undefined ? this.quantity : <any>null;
        return data;
    }
}

/** A product row for Leo.BackendApi.Areas.Api.Models.Analytics.ShopPurchaseEvent. */
export interface IShopPurchaseEventProduct {
    /** The name of the product. */
    name: string;
    /** The article number/sku for the product. */
    sku: string;
    /** The category for the product. */
    category: string;
    /** The total price for the row. */
    price: number;
    /** The quantity for the product. */
    quantity: number;
}

export class ChangePasswordModelRequest implements IChangePasswordModelRequest {
    currentpassword!: string | null;
    newpassword!: string | null;

    constructor(data?: IChangePasswordModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentpassword = _data["currentpassword"] !== undefined ? _data["currentpassword"] : <any>null;
            this.newpassword = _data["newpassword"] !== undefined ? _data["newpassword"] : <any>null;
        }
    }

    static fromJS(data: any): ChangePasswordModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentpassword"] = this.currentpassword !== undefined ? this.currentpassword : <any>null;
        data["newpassword"] = this.newpassword !== undefined ? this.newpassword : <any>null;
        return data;
    }
}

export interface IChangePasswordModelRequest {
    currentpassword: string | null;
    newpassword: string | null;
}

export class ChangePasswordModelResponse implements IChangePasswordModelResponse {
    message!: string | null;
    success!: boolean;

    constructor(data?: IChangePasswordModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
        }
    }

    static fromJS(data: any): ChangePasswordModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["success"] = this.success !== undefined ? this.success : <any>null;
        return data;
    }
}

export interface IChangePasswordModelResponse {
    message: string | null;
    success: boolean;
}

/** Model for adding a new child to the system. */
export class CreateChildModel implements ICreateChildModel {
    firstName!: string;
    lastName!: string | null;
    birthDate!: Date;

    constructor(data?: ICreateChildModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): CreateChildModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChildModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : <any>null;
        return data;
    }
}

/** Model for adding a new child to the system. */
export interface ICreateChildModel {
    firstName: string;
    lastName: string | null;
    birthDate: Date;
}

export class ApplicationUserDto implements IApplicationUserDto {
    guid!: string | null;
    username!: string | null;
    email!: string | null;
    emailconfirmed!: boolean;
    firstname!: string | null;
    lastname!: string | null;
    /** The country code for the phone.
E.g. 46 for Sweden.
Will be 0 if no phone number could be parsed for the user. */
    countrycode!: number;
    /** The phone or the user, without the country code.
E.g. "720000000" */
    phone!: string | null;
    /** True if the Leo.BackendApi.Areas.Api.Models.Dto.ApplicationUserDto.Phone has been confirmed to belong to the user. */
    phoneconfirmed!: boolean;
    comment!: string | null;
    culture!: string | null;
    streetAddress!: string | null;
    postalCode!: string | null;
    city!: string | null;
    memberid!: string | null;
    membercardid!: string | null;
    coAddress!: string | null;
    gdprallowinformation!: boolean;
    gdprallowsms!: boolean;
    gdprallowpartnerinformation!: boolean;
    gdprallowpartnersms!: boolean;
    npsallowcommunication!: boolean;
    preferredplaycenterid!: string | null;
    roles!: string[] | null;

    constructor(data?: IApplicationUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.emailconfirmed = _data["emailconfirmed"] !== undefined ? _data["emailconfirmed"] : <any>null;
            this.firstname = _data["firstname"] !== undefined ? _data["firstname"] : <any>null;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : <any>null;
            this.countrycode = _data["countrycode"] !== undefined ? _data["countrycode"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.phoneconfirmed = _data["phoneconfirmed"] !== undefined ? _data["phoneconfirmed"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.culture = _data["culture"] !== undefined ? _data["culture"] : <any>null;
            this.streetAddress = _data["StreetAddress"] !== undefined ? _data["StreetAddress"] : <any>null;
            this.postalCode = _data["PostalCode"] !== undefined ? _data["PostalCode"] : <any>null;
            this.city = _data["City"] !== undefined ? _data["City"] : <any>null;
            this.memberid = _data["memberid"] !== undefined ? _data["memberid"] : <any>null;
            this.membercardid = _data["membercardid"] !== undefined ? _data["membercardid"] : <any>null;
            this.coAddress = _data["CoAddress"] !== undefined ? _data["CoAddress"] : <any>null;
            this.gdprallowinformation = _data["gdprallowinformation"] !== undefined ? _data["gdprallowinformation"] : <any>null;
            this.gdprallowsms = _data["gdprallowsms"] !== undefined ? _data["gdprallowsms"] : <any>null;
            this.gdprallowpartnerinformation = _data["gdprallowpartnerinformation"] !== undefined ? _data["gdprallowpartnerinformation"] : <any>null;
            this.gdprallowpartnersms = _data["gdprallowpartnersms"] !== undefined ? _data["gdprallowpartnersms"] : <any>null;
            this.npsallowcommunication = _data["npsallowcommunication"] !== undefined ? _data["npsallowcommunication"] : <any>null;
            this.preferredplaycenterid = _data["preferredplaycenterid"] !== undefined ? _data["preferredplaycenterid"] : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = <any>null;
            }
        }
    }

    static fromJS(data: any): ApplicationUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["emailconfirmed"] = this.emailconfirmed !== undefined ? this.emailconfirmed : <any>null;
        data["firstname"] = this.firstname !== undefined ? this.firstname : <any>null;
        data["lastname"] = this.lastname !== undefined ? this.lastname : <any>null;
        data["countrycode"] = this.countrycode !== undefined ? this.countrycode : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["phoneconfirmed"] = this.phoneconfirmed !== undefined ? this.phoneconfirmed : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["culture"] = this.culture !== undefined ? this.culture : <any>null;
        data["StreetAddress"] = this.streetAddress !== undefined ? this.streetAddress : <any>null;
        data["PostalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        data["City"] = this.city !== undefined ? this.city : <any>null;
        data["memberid"] = this.memberid !== undefined ? this.memberid : <any>null;
        data["membercardid"] = this.membercardid !== undefined ? this.membercardid : <any>null;
        data["CoAddress"] = this.coAddress !== undefined ? this.coAddress : <any>null;
        data["gdprallowinformation"] = this.gdprallowinformation !== undefined ? this.gdprallowinformation : <any>null;
        data["gdprallowsms"] = this.gdprallowsms !== undefined ? this.gdprallowsms : <any>null;
        data["gdprallowpartnerinformation"] = this.gdprallowpartnerinformation !== undefined ? this.gdprallowpartnerinformation : <any>null;
        data["gdprallowpartnersms"] = this.gdprallowpartnersms !== undefined ? this.gdprallowpartnersms : <any>null;
        data["npsallowcommunication"] = this.npsallowcommunication !== undefined ? this.npsallowcommunication : <any>null;
        data["preferredplaycenterid"] = this.preferredplaycenterid !== undefined ? this.preferredplaycenterid : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IApplicationUserDto {
    guid: string | null;
    username: string | null;
    email: string | null;
    emailconfirmed: boolean;
    firstname: string | null;
    lastname: string | null;
    /** The country code for the phone.
E.g. 46 for Sweden.
Will be 0 if no phone number could be parsed for the user. */
    countrycode: number;
    /** The phone or the user, without the country code.
E.g. "720000000" */
    phone: string | null;
    /** True if the Leo.BackendApi.Areas.Api.Models.Dto.ApplicationUserDto.Phone has been confirmed to belong to the user. */
    phoneconfirmed: boolean;
    comment: string | null;
    culture: string | null;
    streetAddress: string | null;
    postalCode: string | null;
    city: string | null;
    memberid: string | null;
    membercardid: string | null;
    coAddress: string | null;
    gdprallowinformation: boolean;
    gdprallowsms: boolean;
    gdprallowpartnerinformation: boolean;
    gdprallowpartnersms: boolean;
    npsallowcommunication: boolean;
    preferredplaycenterid: string | null;
    roles: string[] | null;
}

export class AreaDto implements IAreaDto {
    name!: string | null;
    guid!: string | null;
    areatype!: string | null;
    playground!: PlaygroundDto | null;
    playgroundid!: string | null;
    rooms!: RoomDto[] | null;

    constructor(data?: IAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.areatype = _data["areatype"] !== undefined ? _data["areatype"] : <any>null;
            this.playground = _data["playground"] ? PlaygroundDto.fromJS(_data["playground"]) : <any>null;
            this.playgroundid = _data["playgroundid"] !== undefined ? _data["playgroundid"] : <any>null;
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(RoomDto.fromJS(item));
            }
            else {
                this.rooms = <any>null;
            }
        }
    }

    static fromJS(data: any): AreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["areatype"] = this.areatype !== undefined ? this.areatype : <any>null;
        data["playground"] = this.playground ? this.playground.toJSON() : <any>null;
        data["playgroundid"] = this.playgroundid !== undefined ? this.playgroundid : <any>null;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAreaDto {
    name: string | null;
    guid: string | null;
    areatype: string | null;
    playground: PlaygroundDto | null;
    playgroundid: string | null;
    rooms: RoomDto[] | null;
}

export class BookingArticleDto implements IBookingArticleDto {
    originalarticleid!: string | null;
    name!: string | null;
    packagearticleguid!: string;
    guid!: string;
    artno!: string | null;
    itemtype!: string | null;
    amount!: number;
    price!: number;
    fixedamount!: number | null;

    constructor(data?: IBookingArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalarticleid = _data["originalarticleid"] !== undefined ? _data["originalarticleid"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.packagearticleguid = _data["packagearticleguid"] !== undefined ? _data["packagearticleguid"] : <any>null;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.artno = _data["artno"] !== undefined ? _data["artno"] : <any>null;
            this.itemtype = _data["itemtype"] !== undefined ? _data["itemtype"] : <any>null;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.fixedamount = _data["fixedamount"] !== undefined ? _data["fixedamount"] : <any>null;
        }
    }

    static fromJS(data: any): BookingArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalarticleid"] = this.originalarticleid !== undefined ? this.originalarticleid : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["packagearticleguid"] = this.packagearticleguid !== undefined ? this.packagearticleguid : <any>null;
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["artno"] = this.artno !== undefined ? this.artno : <any>null;
        data["itemtype"] = this.itemtype !== undefined ? this.itemtype : <any>null;
        data["amount"] = this.amount !== undefined ? this.amount : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["fixedamount"] = this.fixedamount !== undefined ? this.fixedamount : <any>null;
        return data;
    }
}

export interface IBookingArticleDto {
    originalarticleid: string | null;
    name: string | null;
    packagearticleguid: string;
    guid: string;
    artno: string | null;
    itemtype: string | null;
    amount: number;
    price: number;
    fixedamount: number | null;
}

export class BookingArticlesPriceDto implements IBookingArticlesPriceDto {
    pricevalue!: number | null;
    currency!: string | null;

    constructor(data?: IBookingArticlesPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pricevalue = _data["pricevalue"] !== undefined ? _data["pricevalue"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
        }
    }

    static fromJS(data: any): BookingArticlesPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingArticlesPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pricevalue"] = this.pricevalue !== undefined ? this.pricevalue : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        return data;
    }
}

export interface IBookingArticlesPriceDto {
    pricevalue: number | null;
    currency: string | null;
}

export class BookingArticlesRequestDto implements IBookingArticlesRequestDto {
    selectedarticles!: string[] | null;
    bookingguid!: string;

    constructor(data?: IBookingArticlesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectedarticles"])) {
                this.selectedarticles = [] as any;
                for (let item of _data["selectedarticles"])
                    this.selectedarticles!.push(item);
            }
            else {
                this.selectedarticles = <any>null;
            }
            this.bookingguid = _data["bookingguid"] !== undefined ? _data["bookingguid"] : <any>null;
        }
    }

    static fromJS(data: any): BookingArticlesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingArticlesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedarticles)) {
            data["selectedarticles"] = [];
            for (let item of this.selectedarticles)
                data["selectedarticles"].push(item);
        }
        data["bookingguid"] = this.bookingguid !== undefined ? this.bookingguid : <any>null;
        return data;
    }
}

export interface IBookingArticlesRequestDto {
    selectedarticles: string[] | null;
    bookingguid: string;
}

export class BookingArticlesResponseDto implements IBookingArticlesResponseDto {
    price!: BookingArticlesPriceDto | null;
    bookingarticles!: BookingArticleDto[] | null;
    bookingguid!: string;

    constructor(data?: IBookingArticlesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"] ? BookingArticlesPriceDto.fromJS(_data["price"]) : <any>null;
            if (Array.isArray(_data["bookingarticles"])) {
                this.bookingarticles = [] as any;
                for (let item of _data["bookingarticles"])
                    this.bookingarticles!.push(BookingArticleDto.fromJS(item));
            }
            else {
                this.bookingarticles = <any>null;
            }
            this.bookingguid = _data["bookingguid"] !== undefined ? _data["bookingguid"] : <any>null;
        }
    }

    static fromJS(data: any): BookingArticlesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingArticlesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price ? this.price.toJSON() : <any>null;
        if (Array.isArray(this.bookingarticles)) {
            data["bookingarticles"] = [];
            for (let item of this.bookingarticles)
                data["bookingarticles"].push(item.toJSON());
        }
        data["bookingguid"] = this.bookingguid !== undefined ? this.bookingguid : <any>null;
        return data;
    }
}

export interface IBookingArticlesResponseDto {
    price: BookingArticlesPriceDto | null;
    bookingarticles: BookingArticleDto[] | null;
    bookingguid: string;
}

/** A DTO for Leo.Domain.Entities.Invitation.InvitationBackground. */
export class InvitationBackgroundDto implements IInvitationBackgroundDto {
    /** The Guid of the invitation background. */
    guid!: string;
    /** The name of the invitation background. */
    name!: string | null;
    /** The image of the invitation background. */
    image!: ImageDto | null;

    constructor(data?: IInvitationBackgroundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>null;
        }
    }

    static fromJS(data: any): InvitationBackgroundDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvitationBackgroundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["image"] = this.image ? this.image.toJSON() : <any>null;
        return data;
    }
}

/** A DTO for Leo.Domain.Entities.Invitation.InvitationBackground. */
export interface IInvitationBackgroundDto {
    /** The Guid of the invitation background. */
    guid: string;
    /** The name of the invitation background. */
    name: string | null;
    /** The image of the invitation background. */
    image: ImageDto | null;
}

export class InviteAnswerDto implements IInviteAnswerDto {
    invitationkey!: string | null;
    invitationid!: string;
    status!: string | null;
    message!: string | null;
    allergymessage!: string | null;

    constructor(data?: IInviteAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitationkey = _data["invitationkey"] !== undefined ? _data["invitationkey"] : <any>null;
            this.invitationid = _data["invitationid"] !== undefined ? _data["invitationid"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.allergymessage = _data["allergymessage"] !== undefined ? _data["allergymessage"] : <any>null;
        }
    }

    static fromJS(data: any): InviteAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new InviteAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitationkey"] = this.invitationkey !== undefined ? this.invitationkey : <any>null;
        data["invitationid"] = this.invitationid !== undefined ? this.invitationid : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["allergymessage"] = this.allergymessage !== undefined ? this.allergymessage : <any>null;
        return data;
    }
}

export interface IInviteAnswerDto {
    invitationkey: string | null;
    invitationid: string;
    status: string | null;
    message: string | null;
    allergymessage: string | null;
}

export class InviteCreateNewDto implements IInviteCreateNewDto {
    bookingid!: string;

    constructor(data?: IInviteCreateNewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingid = _data["bookingid"] !== undefined ? _data["bookingid"] : <any>null;
        }
    }

    static fromJS(data: any): InviteCreateNewDto {
        data = typeof data === 'object' ? data : {};
        let result = new InviteCreateNewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingid"] = this.bookingid !== undefined ? this.bookingid : <any>null;
        return data;
    }
}

export interface IInviteCreateNewDto {
    bookingid: string;
}

export class InviteDto implements IInviteDto {
    guid!: string;
    bookingid!: string;
    status!: string | null;
    playgroundname!: string | null;
    room!: RoomDto | null;
    partydate!: string | null;
    starttime!: string | null;
    streetadress!: string | null;
    playcentertype!: PlaycenterType;
    companyname!: string | null;
    invitiationkey!: string | null;
    guestmessage!: string | null;
    /** Allergy information supplied by the guest when answering an invitation. */
    guestallergymessage!: string | null;
    invitemessage!: string | null;
    guestinfo!: InviteGuestDto | null;
    host!: InviteInviterDto | null;
    userexists!: boolean;
    /** Invitation background image, selected by the booker.
Null if the booker did not select a background. */
    backgroundimage!: ImageDto | null;
    stopdate!: string | null;
    invitationmessage!: string | null;

    constructor(data?: IInviteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.bookingid = _data["bookingid"] !== undefined ? _data["bookingid"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.playgroundname = _data["playgroundname"] !== undefined ? _data["playgroundname"] : <any>null;
            this.room = _data["room"] ? RoomDto.fromJS(_data["room"]) : <any>null;
            this.partydate = _data["partydate"] !== undefined ? _data["partydate"] : <any>null;
            this.starttime = _data["starttime"] !== undefined ? _data["starttime"] : <any>null;
            this.streetadress = _data["streetadress"] !== undefined ? _data["streetadress"] : <any>null;
            this.playcentertype = _data["playcentertype"] !== undefined ? _data["playcentertype"] : <any>null;
            this.companyname = _data["companyname"] !== undefined ? _data["companyname"] : <any>null;
            this.invitiationkey = _data["invitiationkey"] !== undefined ? _data["invitiationkey"] : <any>null;
            this.guestmessage = _data["guestmessage"] !== undefined ? _data["guestmessage"] : <any>null;
            this.guestallergymessage = _data["guestallergymessage"] !== undefined ? _data["guestallergymessage"] : <any>null;
            this.invitemessage = _data["invitemessage"] !== undefined ? _data["invitemessage"] : <any>null;
            this.guestinfo = _data["guestinfo"] ? InviteGuestDto.fromJS(_data["guestinfo"]) : <any>null;
            this.host = _data["host"] ? InviteInviterDto.fromJS(_data["host"]) : <any>null;
            this.userexists = _data["userexists"] !== undefined ? _data["userexists"] : <any>null;
            this.backgroundimage = _data["backgroundimage"] ? ImageDto.fromJS(_data["backgroundimage"]) : <any>null;
            this.stopdate = _data["stopdate"] !== undefined ? _data["stopdate"] : <any>null;
            this.invitationmessage = _data["invitationmessage"] !== undefined ? _data["invitationmessage"] : <any>null;
        }
    }

    static fromJS(data: any): InviteDto {
        data = typeof data === 'object' ? data : {};
        let result = new InviteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["bookingid"] = this.bookingid !== undefined ? this.bookingid : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["playgroundname"] = this.playgroundname !== undefined ? this.playgroundname : <any>null;
        data["room"] = this.room ? this.room.toJSON() : <any>null;
        data["partydate"] = this.partydate !== undefined ? this.partydate : <any>null;
        data["starttime"] = this.starttime !== undefined ? this.starttime : <any>null;
        data["streetadress"] = this.streetadress !== undefined ? this.streetadress : <any>null;
        data["playcentertype"] = this.playcentertype !== undefined ? this.playcentertype : <any>null;
        data["companyname"] = this.companyname !== undefined ? this.companyname : <any>null;
        data["invitiationkey"] = this.invitiationkey !== undefined ? this.invitiationkey : <any>null;
        data["guestmessage"] = this.guestmessage !== undefined ? this.guestmessage : <any>null;
        data["guestallergymessage"] = this.guestallergymessage !== undefined ? this.guestallergymessage : <any>null;
        data["invitemessage"] = this.invitemessage !== undefined ? this.invitemessage : <any>null;
        data["guestinfo"] = this.guestinfo ? this.guestinfo.toJSON() : <any>null;
        data["host"] = this.host ? this.host.toJSON() : <any>null;
        data["userexists"] = this.userexists !== undefined ? this.userexists : <any>null;
        data["backgroundimage"] = this.backgroundimage ? this.backgroundimage.toJSON() : <any>null;
        data["stopdate"] = this.stopdate !== undefined ? this.stopdate : <any>null;
        data["invitationmessage"] = this.invitationmessage !== undefined ? this.invitationmessage : <any>null;
        return data;
    }
}

export interface IInviteDto {
    guid: string;
    bookingid: string;
    status: string | null;
    playgroundname: string | null;
    room: RoomDto | null;
    partydate: string | null;
    starttime: string | null;
    streetadress: string | null;
    playcentertype: PlaycenterType;
    companyname: string | null;
    invitiationkey: string | null;
    guestmessage: string | null;
    /** Allergy information supplied by the guest when answering an invitation. */
    guestallergymessage: string | null;
    invitemessage: string | null;
    guestinfo: InviteGuestDto | null;
    host: InviteInviterDto | null;
    userexists: boolean;
    /** Invitation background image, selected by the booker.
Null if the booker did not select a background. */
    backgroundimage: ImageDto | null;
    stopdate: string | null;
    invitationmessage: string | null;
}

export class InviteGuestDto implements IInviteGuestDto {
    name!: string | null;
    parentname!: string | null;
    birthdayage!: number | null;
    age!: number;
    birthdaydate!: string | null;
    phonecountrycode!: number;
    phone!: string | null;
    email!: string | null;
    gender!: string | null;
    birthday!: boolean;
    /** True if the guest is one of the birthday children (may be multiple). */
    ismainguest!: boolean;
    childId!: string;

    constructor(data?: IInviteGuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.parentname = _data["parentname"] !== undefined ? _data["parentname"] : <any>null;
            this.birthdayage = _data["birthdayage"] !== undefined ? _data["birthdayage"] : <any>null;
            this.age = _data["age"] !== undefined ? _data["age"] : <any>null;
            this.birthdaydate = _data["birthdaydate"] !== undefined ? _data["birthdaydate"] : <any>null;
            this.phonecountrycode = _data["phonecountrycode"] !== undefined ? _data["phonecountrycode"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.birthday = _data["birthday"] !== undefined ? _data["birthday"] : <any>null;
            this.ismainguest = _data["ismainguest"] !== undefined ? _data["ismainguest"] : <any>null;
            this.childId = _data["childId"] !== undefined ? _data["childId"] : <any>null;
        }
    }

    static fromJS(data: any): InviteGuestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InviteGuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["parentname"] = this.parentname !== undefined ? this.parentname : <any>null;
        data["birthdayage"] = this.birthdayage !== undefined ? this.birthdayage : <any>null;
        data["age"] = this.age !== undefined ? this.age : <any>null;
        data["birthdaydate"] = this.birthdaydate !== undefined ? this.birthdaydate : <any>null;
        data["phonecountrycode"] = this.phonecountrycode !== undefined ? this.phonecountrycode : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["birthday"] = this.birthday !== undefined ? this.birthday : <any>null;
        data["ismainguest"] = this.ismainguest !== undefined ? this.ismainguest : <any>null;
        data["childId"] = this.childId !== undefined ? this.childId : <any>null;
        return data;
    }
}

export interface IInviteGuestDto {
    name: string | null;
    parentname: string | null;
    birthdayage: number | null;
    age: number;
    birthdaydate: string | null;
    phonecountrycode: number;
    phone: string | null;
    email: string | null;
    gender: string | null;
    birthday: boolean;
    /** True if the guest is one of the birthday children (may be multiple). */
    ismainguest: boolean;
    childId: string;
}

export class InviteInviterChildDto implements IInviteInviterChildDto {
    name!: string | null;
    age!: number | null;
    birthdayage!: number | null;

    constructor(data?: IInviteInviterChildDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.age = _data["age"] !== undefined ? _data["age"] : <any>null;
            this.birthdayage = _data["birthdayage"] !== undefined ? _data["birthdayage"] : <any>null;
        }
    }

    static fromJS(data: any): InviteInviterChildDto {
        data = typeof data === 'object' ? data : {};
        let result = new InviteInviterChildDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["age"] = this.age !== undefined ? this.age : <any>null;
        data["birthdayage"] = this.birthdayage !== undefined ? this.birthdayage : <any>null;
        return data;
    }
}

export interface IInviteInviterChildDto {
    name: string | null;
    age: number | null;
    birthdayage: number | null;
}

export class InviteInviterDto implements IInviteInviterDto {
    parentfirstname!: string | null;
    parentlastname!: string | null;
    children!: InviteInviterChildDto[] | null;

    constructor(data?: IInviteInviterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentfirstname = _data["parentfirstname"] !== undefined ? _data["parentfirstname"] : <any>null;
            this.parentlastname = _data["parentlastname"] !== undefined ? _data["parentlastname"] : <any>null;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(InviteInviterChildDto.fromJS(item));
            }
            else {
                this.children = <any>null;
            }
        }
    }

    static fromJS(data: any): InviteInviterDto {
        data = typeof data === 'object' ? data : {};
        let result = new InviteInviterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentfirstname"] = this.parentfirstname !== undefined ? this.parentfirstname : <any>null;
        data["parentlastname"] = this.parentlastname !== undefined ? this.parentlastname : <any>null;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IInviteInviterDto {
    parentfirstname: string | null;
    parentlastname: string | null;
    children: InviteInviterChildDto[] | null;
}

export class FreeDatesCollectionCampaignDto implements IFreeDatesCollectionCampaignDto {
    title!: string | null;

    constructor(data?: IFreeDatesCollectionCampaignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
        }
    }

    static fromJS(data: any): FreeDatesCollectionCampaignDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreeDatesCollectionCampaignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : <any>null;
        return data;
    }
}

export interface IFreeDatesCollectionCampaignDto {
    title: string | null;
}

export class FreeDatesCollectionDto implements IFreeDatesCollectionDto {
    duration!: number;
    dates!: FreeDatesCollectionFreeDateDto[] | null;

    constructor(data?: IFreeDatesCollectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duration = _data["duration"] !== undefined ? _data["duration"] : <any>null;
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(FreeDatesCollectionFreeDateDto.fromJS(item));
            }
            else {
                this.dates = <any>null;
            }
        }
    }

    static fromJS(data: any): FreeDatesCollectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreeDatesCollectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration !== undefined ? this.duration : <any>null;
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFreeDatesCollectionDto {
    duration: number;
    dates: FreeDatesCollectionFreeDateDto[] | null;
}

export class FreeDatesCollectionFreeDateDto implements IFreeDatesCollectionFreeDateDto {
    date!: string | null;
    rooms!: FreeDatesCollectionFreeRoomDto[] | null;
    campaigns!: FreeDatesCollectionCampaignDto[] | null;

    constructor(data?: IFreeDatesCollectionFreeDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] !== undefined ? _data["date"] : <any>null;
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(FreeDatesCollectionFreeRoomDto.fromJS(item));
            }
            else {
                this.rooms = <any>null;
            }
            if (Array.isArray(_data["campaigns"])) {
                this.campaigns = [] as any;
                for (let item of _data["campaigns"])
                    this.campaigns!.push(FreeDatesCollectionCampaignDto.fromJS(item));
            }
            else {
                this.campaigns = <any>null;
            }
        }
    }

    static fromJS(data: any): FreeDatesCollectionFreeDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreeDatesCollectionFreeDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date !== undefined ? this.date : <any>null;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item.toJSON());
        }
        if (Array.isArray(this.campaigns)) {
            data["campaigns"] = [];
            for (let item of this.campaigns)
                data["campaigns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFreeDatesCollectionFreeDateDto {
    date: string | null;
    rooms: FreeDatesCollectionFreeRoomDto[] | null;
    campaigns: FreeDatesCollectionCampaignDto[] | null;
}

export class FreeDatesCollectionFreeRoomDto implements IFreeDatesCollectionFreeRoomDto {
    name!: string | null;
    guid!: string;
    timeslots!: TimeSlotDto[] | null;

    constructor(data?: IFreeDatesCollectionFreeRoomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            if (Array.isArray(_data["timeslots"])) {
                this.timeslots = [] as any;
                for (let item of _data["timeslots"])
                    this.timeslots!.push(TimeSlotDto.fromJS(item));
            }
            else {
                this.timeslots = <any>null;
            }
        }
    }

    static fromJS(data: any): FreeDatesCollectionFreeRoomDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreeDatesCollectionFreeRoomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        if (Array.isArray(this.timeslots)) {
            data["timeslots"] = [];
            for (let item of this.timeslots)
                data["timeslots"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFreeDatesCollectionFreeRoomDto {
    name: string | null;
    guid: string;
    timeslots: TimeSlotDto[] | null;
}

/** Unconfirmed article changes on a booking. These will replace the current package and articles when the changes are confirmed. */
export class PartyBookingChangeArticleChangesDto implements IPartyBookingChangeArticleChangesDto {
    /** List of new booking articles. */
    bookingarticles!: BookingArticleDto[] | null;
    /** Guid of the new party package. */
    packageguid!: string;
    /** Name of the new party package. */
    packagename!: string | null;

    constructor(data?: IPartyBookingChangeArticleChangesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bookingarticles"])) {
                this.bookingarticles = [] as any;
                for (let item of _data["bookingarticles"])
                    this.bookingarticles!.push(BookingArticleDto.fromJS(item));
            }
            else {
                this.bookingarticles = <any>null;
            }
            this.packageguid = _data["packageguid"] !== undefined ? _data["packageguid"] : <any>null;
            this.packagename = _data["packagename"] !== undefined ? _data["packagename"] : <any>null;
        }
    }

    static fromJS(data: any): PartyBookingChangeArticleChangesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingChangeArticleChangesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bookingarticles)) {
            data["bookingarticles"] = [];
            for (let item of this.bookingarticles)
                data["bookingarticles"].push(item.toJSON());
        }
        data["packageguid"] = this.packageguid !== undefined ? this.packageguid : <any>null;
        data["packagename"] = this.packagename !== undefined ? this.packagename : <any>null;
        return data;
    }
}

/** Unconfirmed article changes on a booking. These will replace the current package and articles when the changes are confirmed. */
export interface IPartyBookingChangeArticleChangesDto {
    /** List of new booking articles. */
    bookingarticles: BookingArticleDto[] | null;
    /** Guid of the new party package. */
    packageguid: string;
    /** Name of the new party package. */
    packagename: string | null;
}

export class PartyBookingChangeBackgroundDto implements IPartyBookingChangeBackgroundDto {
    guid!: string;
    imageid!: string;
    stopdate!: string | null;
    invitationmessage!: string | null;
    staffmessage!: string | null;
    allergymessage!: string | null;
    invitemessage!: string | null;

    constructor(data?: IPartyBookingChangeBackgroundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.imageid = _data["imageid"] !== undefined ? _data["imageid"] : <any>null;
            this.stopdate = _data["stopdate"] !== undefined ? _data["stopdate"] : <any>null;
            this.invitationmessage = _data["invitationmessage"] !== undefined ? _data["invitationmessage"] : <any>null;
            this.staffmessage = _data["staffmessage"] !== undefined ? _data["staffmessage"] : <any>null;
            this.allergymessage = _data["allergymessage"] !== undefined ? _data["allergymessage"] : <any>null;
            this.invitemessage = _data["invitemessage"] !== undefined ? _data["invitemessage"] : <any>null;
        }
    }

    static fromJS(data: any): PartyBookingChangeBackgroundDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingChangeBackgroundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["imageid"] = this.imageid !== undefined ? this.imageid : <any>null;
        data["stopdate"] = this.stopdate !== undefined ? this.stopdate : <any>null;
        data["invitationmessage"] = this.invitationmessage !== undefined ? this.invitationmessage : <any>null;
        data["staffmessage"] = this.staffmessage !== undefined ? this.staffmessage : <any>null;
        data["allergymessage"] = this.allergymessage !== undefined ? this.allergymessage : <any>null;
        data["invitemessage"] = this.invitemessage !== undefined ? this.invitemessage : <any>null;
        return data;
    }
}

export interface IPartyBookingChangeBackgroundDto {
    guid: string;
    imageid: string;
    stopdate: string | null;
    invitationmessage: string | null;
    staffmessage: string | null;
    allergymessage: string | null;
    invitemessage: string | null;
}

export class PartyBookingChangeDto implements IPartyBookingChangeDto {
    /** Unconfirmed article changes on a booking. These will replace the current package and articles when the
changes are confirmed. */
    articles!: PartyBookingChangeArticleChangesDto | null;
    guestcount!: number;
    price!: PriceDto | null;

    constructor(data?: IPartyBookingChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articles = _data["articles"] ? PartyBookingChangeArticleChangesDto.fromJS(_data["articles"]) : <any>null;
            this.guestcount = _data["guestcount"] !== undefined ? _data["guestcount"] : <any>null;
            this.price = _data["price"] ? PriceDto.fromJS(_data["price"]) : <any>null;
        }
    }

    static fromJS(data: any): PartyBookingChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articles"] = this.articles ? this.articles.toJSON() : <any>null;
        data["guestcount"] = this.guestcount !== undefined ? this.guestcount : <any>null;
        data["price"] = this.price ? this.price.toJSON() : <any>null;
        return data;
    }
}

export interface IPartyBookingChangeDto {
    /** Unconfirmed article changes on a booking. These will replace the current package and articles when the
changes are confirmed. */
    articles: PartyBookingChangeArticleChangesDto | null;
    guestcount: number;
    price: PriceDto | null;
}

export class PartyBookingChangeRequestDto implements IPartyBookingChangeRequestDto {
    guid!: string;
    changemessage!: string | null;
    reservationid!: string;
    staffmessage!: string | null;
    allergymessage!: string | null;
    invitemessage!: string | null;

    constructor(data?: IPartyBookingChangeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.changemessage = _data["changemessage"] !== undefined ? _data["changemessage"] : <any>null;
            this.reservationid = _data["reservationid"] !== undefined ? _data["reservationid"] : <any>null;
            this.staffmessage = _data["staffmessage"] !== undefined ? _data["staffmessage"] : <any>null;
            this.allergymessage = _data["allergymessage"] !== undefined ? _data["allergymessage"] : <any>null;
            this.invitemessage = _data["invitemessage"] !== undefined ? _data["invitemessage"] : <any>null;
        }
    }

    static fromJS(data: any): PartyBookingChangeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingChangeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["changemessage"] = this.changemessage !== undefined ? this.changemessage : <any>null;
        data["reservationid"] = this.reservationid !== undefined ? this.reservationid : <any>null;
        data["staffmessage"] = this.staffmessage !== undefined ? this.staffmessage : <any>null;
        data["allergymessage"] = this.allergymessage !== undefined ? this.allergymessage : <any>null;
        data["invitemessage"] = this.invitemessage !== undefined ? this.invitemessage : <any>null;
        return data;
    }
}

export interface IPartyBookingChangeRequestDto {
    guid: string;
    changemessage: string | null;
    reservationid: string;
    staffmessage: string | null;
    allergymessage: string | null;
    invitemessage: string | null;
}

export class PartyBookingConfirmRequestDto implements IPartyBookingConfirmRequestDto {
    bookingid!: string;

    constructor(data?: IPartyBookingConfirmRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingid = _data["bookingid"] !== undefined ? _data["bookingid"] : <any>null;
        }
    }

    static fromJS(data: any): PartyBookingConfirmRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingConfirmRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingid"] = this.bookingid !== undefined ? this.bookingid : <any>null;
        return data;
    }
}

export interface IPartyBookingConfirmRequestDto {
    bookingid: string;
}

export class PartyBookingListDto implements IPartyBookingListDto {
    /** A list of parties that was retrieved. */
    parties!: PartyBookingListPartyItemDto[] | null;

    constructor(data?: IPartyBookingListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["parties"])) {
                this.parties = [] as any;
                for (let item of _data["parties"])
                    this.parties!.push(PartyBookingListPartyItemDto.fromJS(item));
            }
            else {
                this.parties = <any>null;
            }
        }
    }

    static fromJS(data: any): PartyBookingListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.parties)) {
            data["parties"] = [];
            for (let item of this.parties)
                data["parties"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPartyBookingListDto {
    /** A list of parties that was retrieved. */
    parties: PartyBookingListPartyItemDto[] | null;
}

export class PartyBookingListGuestStatusDto implements IPartyBookingListGuestStatusDto {
    /** The total number of guests, excluding the main guests. */
    total!: number;
    /** The total number of, non main guests, that have yet to answer the invite. */
    noanswer!: number;
    /** The total number of, non main guests, that have accepted the invite. */
    accepted!: number;
    /** The total number of, non main guests, that have rejected the invite. */
    cancelled!: number;
    /** The total number of main guests (birthday kids). */
    birthdaykids!: number;

    constructor(data?: IPartyBookingListGuestStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"] !== undefined ? _data["total"] : <any>null;
            this.noanswer = _data["noanswer"] !== undefined ? _data["noanswer"] : <any>null;
            this.accepted = _data["accepted"] !== undefined ? _data["accepted"] : <any>null;
            this.cancelled = _data["cancelled"] !== undefined ? _data["cancelled"] : <any>null;
            this.birthdaykids = _data["birthdaykids"] !== undefined ? _data["birthdaykids"] : <any>null;
        }
    }

    static fromJS(data: any): PartyBookingListGuestStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingListGuestStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total !== undefined ? this.total : <any>null;
        data["noanswer"] = this.noanswer !== undefined ? this.noanswer : <any>null;
        data["accepted"] = this.accepted !== undefined ? this.accepted : <any>null;
        data["cancelled"] = this.cancelled !== undefined ? this.cancelled : <any>null;
        data["birthdaykids"] = this.birthdaykids !== undefined ? this.birthdaykids : <any>null;
        return data;
    }
}

export interface IPartyBookingListGuestStatusDto {
    /** The total number of guests, excluding the main guests. */
    total: number;
    /** The total number of, non main guests, that have yet to answer the invite. */
    noanswer: number;
    /** The total number of, non main guests, that have accepted the invite. */
    accepted: number;
    /** The total number of, non main guests, that have rejected the invite. */
    cancelled: number;
    /** The total number of main guests (birthday kids). */
    birthdaykids: number;
}

export class PartyBookingListPartyItemDto implements IPartyBookingListPartyItemDto {
    /** The date of the booking, e.g "2021-12-30". */
    partydate!: string | null;
    /** The id of the booking. */
    bookingid!: string;
    /** The start time of the party, in local time, e.g. "20:15". */
    starttime!: string | null;
    /** The current Leo.Domain.Entities.Party.BookStatus as a string value. */
    status!: string | null;
    playgroundname!: string | null;
    invited!: PartyBookingListGuestStatusDto | null;
    /** True if the booking is active, e.g. should be displayed as "current". */
    isactive!: boolean;

    constructor(data?: IPartyBookingListPartyItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partydate = _data["partydate"] !== undefined ? _data["partydate"] : <any>null;
            this.bookingid = _data["bookingid"] !== undefined ? _data["bookingid"] : <any>null;
            this.starttime = _data["starttime"] !== undefined ? _data["starttime"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.playgroundname = _data["playgroundname"] !== undefined ? _data["playgroundname"] : <any>null;
            this.invited = _data["invited"] ? PartyBookingListGuestStatusDto.fromJS(_data["invited"]) : <any>null;
            this.isactive = _data["isactive"] !== undefined ? _data["isactive"] : <any>null;
        }
    }

    static fromJS(data: any): PartyBookingListPartyItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingListPartyItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partydate"] = this.partydate !== undefined ? this.partydate : <any>null;
        data["bookingid"] = this.bookingid !== undefined ? this.bookingid : <any>null;
        data["starttime"] = this.starttime !== undefined ? this.starttime : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["playgroundname"] = this.playgroundname !== undefined ? this.playgroundname : <any>null;
        data["invited"] = this.invited ? this.invited.toJSON() : <any>null;
        data["isactive"] = this.isactive !== undefined ? this.isactive : <any>null;
        return data;
    }
}

export interface IPartyBookingListPartyItemDto {
    /** The date of the booking, e.g "2021-12-30". */
    partydate: string | null;
    /** The id of the booking. */
    bookingid: string;
    /** The start time of the party, in local time, e.g. "20:15". */
    starttime: string | null;
    /** The current Leo.Domain.Entities.Party.BookStatus as a string value. */
    status: string | null;
    playgroundname: string | null;
    invited: PartyBookingListGuestStatusDto | null;
    /** True if the booking is active, e.g. should be displayed as "current". */
    isactive: boolean;
}

/** Content for the "party booking for playground xxx will open in xxx" screen in the party booking. */
export class PartyBookingOpeningInfoContentDto implements IPartyBookingOpeningInfoContentDto {
    /** Displayed in the title of the page. */
    pageTitle!: string;
    /** Displayed below the countdown. */
    pageSubtitle!: string;
    /** Dto object for the Leo.Domain.Entities.Media.MediaItem object. */
    cardImage!: MediaItemDto;
    /** The card title. */
    cardTitle!: string;
    /** The card text. */
    cardText!: string;
    /** The text for the small alert at the bottom of the page. */
    alertText!: string | null;
    /** Title for the calendar event. */
    calendarEventTitle!: string;
    /** Text for the calendar event. */
    calendarEventText!: string;
    /** Text for the add to calendar button. */
    addToCalenderButtonText!: string;

    constructor(data?: IPartyBookingOpeningInfoContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.cardImage = new MediaItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageTitle = _data["pageTitle"] !== undefined ? _data["pageTitle"] : <any>null;
            this.pageSubtitle = _data["pageSubtitle"] !== undefined ? _data["pageSubtitle"] : <any>null;
            this.cardImage = _data["cardImage"] ? MediaItemDto.fromJS(_data["cardImage"]) : new MediaItemDto();
            this.cardTitle = _data["cardTitle"] !== undefined ? _data["cardTitle"] : <any>null;
            this.cardText = _data["cardText"] !== undefined ? _data["cardText"] : <any>null;
            this.alertText = _data["alertText"] !== undefined ? _data["alertText"] : <any>null;
            this.calendarEventTitle = _data["calendarEventTitle"] !== undefined ? _data["calendarEventTitle"] : <any>null;
            this.calendarEventText = _data["calendarEventText"] !== undefined ? _data["calendarEventText"] : <any>null;
            this.addToCalenderButtonText = _data["addToCalenderButtonText"] !== undefined ? _data["addToCalenderButtonText"] : <any>null;
        }
    }

    static fromJS(data: any): PartyBookingOpeningInfoContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingOpeningInfoContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageTitle"] = this.pageTitle !== undefined ? this.pageTitle : <any>null;
        data["pageSubtitle"] = this.pageSubtitle !== undefined ? this.pageSubtitle : <any>null;
        data["cardImage"] = this.cardImage ? this.cardImage.toJSON() : <any>null;
        data["cardTitle"] = this.cardTitle !== undefined ? this.cardTitle : <any>null;
        data["cardText"] = this.cardText !== undefined ? this.cardText : <any>null;
        data["alertText"] = this.alertText !== undefined ? this.alertText : <any>null;
        data["calendarEventTitle"] = this.calendarEventTitle !== undefined ? this.calendarEventTitle : <any>null;
        data["calendarEventText"] = this.calendarEventText !== undefined ? this.calendarEventText : <any>null;
        data["addToCalenderButtonText"] = this.addToCalenderButtonText !== undefined ? this.addToCalenderButtonText : <any>null;
        return data;
    }
}

/** Content for the "party booking for playground xxx will open in xxx" screen in the party booking. */
export interface IPartyBookingOpeningInfoContentDto {
    /** Displayed in the title of the page. */
    pageTitle: string;
    /** Displayed below the countdown. */
    pageSubtitle: string;
    /** Dto object for the Leo.Domain.Entities.Media.MediaItem object. */
    cardImage: MediaItemDto;
    /** The card title. */
    cardTitle: string;
    /** The card text. */
    cardText: string;
    /** The text for the small alert at the bottom of the page. */
    alertText: string | null;
    /** Title for the calendar event. */
    calendarEventTitle: string;
    /** Text for the calendar event. */
    calendarEventText: string;
    /** Text for the add to calendar button. */
    addToCalenderButtonText: string;
}

/** Information for when the party booking opens up for new bookings. */
export class PartyBookingOpeningInfoDto implements IPartyBookingOpeningInfoDto {
    /** The date when the party booking opens up for new bookings. */
    date!: Date;
    /** Content to display for the user, null if the playground is open. */
    content!: PartyBookingOpeningInfoContentDto | null;

    constructor(data?: IPartyBookingOpeningInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : <any>null;
            this.content = _data["content"] ? PartyBookingOpeningInfoContentDto.fromJS(_data["content"]) : <any>null;
        }
    }

    static fromJS(data: any): PartyBookingOpeningInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingOpeningInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["content"] = this.content ? this.content.toJSON() : <any>null;
        return data;
    }
}

/** Information for when the party booking opens up for new bookings. */
export interface IPartyBookingOpeningInfoDto {
    /** The date when the party booking opens up for new bookings. */
    date: Date;
    /** Content to display for the user, null if the playground is open. */
    content: PartyBookingOpeningInfoContentDto | null;
}

export class PartyBookingPriceDto implements IPartyBookingPriceDto {
    pricevalue!: number | null;
    currency!: string | null;

    constructor(data?: IPartyBookingPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pricevalue = _data["pricevalue"] !== undefined ? _data["pricevalue"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
        }
    }

    static fromJS(data: any): PartyBookingPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pricevalue"] = this.pricevalue !== undefined ? this.pricevalue : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        return data;
    }
}

export interface IPartyBookingPriceDto {
    pricevalue: number | null;
    currency: string | null;
}

export class PartyBookingResponseDto implements IPartyBookingResponseDto {
    guid!: string;
    maxguests!: number;
    minguests!: number;
    price!: PartyBookingPriceDto | null;
    orderreference!: string | null;
    status!: string | null;
    canchangedate!: boolean;
    canchangearticles!: boolean;
    canchangeguests!: boolean;
    canconfirm!: boolean;
    playgroundid!: string;
    startdate!: string | null;
    stopdate!: string | null;
    partylength!: number | null;
    /** The currently selected invitation background guid. Null if none is selected. */
    invitationbackgroundguid!: string | null;
    invitationmessage!: string | null;
    reservation!: PartyReservationResponseDto | null;
    changereservation!: PartyReservationResponseDto | null;
    bookingchanges!: PartyBookingChangeDto | null;
    packagename!: string | null;
    packageguid!: string | null;
    guests!: GuestResponseDto[] | null;
    invites!: InviteDto[] | null;
    bookingarticles!: BookingArticleDto[] | null;
    /** The price per extra birthday child. The first birthday child is always included in the price. */
    priceextrabirthdaychild!: PartyBookingPriceDto | null;
    artnoextrabirthdaychild!: string | null;
    /** The date the booking was created. */
    createddate!: string | null;
    staffmessage!: string | null;
    allergymessage!: string | null;
    invitemessage!: string | null;

    constructor(data?: IPartyBookingResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.maxguests = _data["maxguests"] !== undefined ? _data["maxguests"] : <any>null;
            this.minguests = _data["minguests"] !== undefined ? _data["minguests"] : <any>null;
            this.price = _data["price"] ? PartyBookingPriceDto.fromJS(_data["price"]) : <any>null;
            this.orderreference = _data["orderreference"] !== undefined ? _data["orderreference"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.canchangedate = _data["canchangedate"] !== undefined ? _data["canchangedate"] : <any>null;
            this.canchangearticles = _data["canchangearticles"] !== undefined ? _data["canchangearticles"] : <any>null;
            this.canchangeguests = _data["canchangeguests"] !== undefined ? _data["canchangeguests"] : <any>null;
            this.canconfirm = _data["canconfirm"] !== undefined ? _data["canconfirm"] : <any>null;
            this.playgroundid = _data["playgroundid"] !== undefined ? _data["playgroundid"] : <any>null;
            this.startdate = _data["startdate"] !== undefined ? _data["startdate"] : <any>null;
            this.stopdate = _data["stopdate"] !== undefined ? _data["stopdate"] : <any>null;
            this.partylength = _data["partylength"] !== undefined ? _data["partylength"] : <any>null;
            this.invitationbackgroundguid = _data["invitationbackgroundguid"] !== undefined ? _data["invitationbackgroundguid"] : <any>null;
            this.invitationmessage = _data["invitationmessage"] !== undefined ? _data["invitationmessage"] : <any>null;
            this.reservation = _data["reservation"] ? PartyReservationResponseDto.fromJS(_data["reservation"]) : <any>null;
            this.changereservation = _data["changereservation"] ? PartyReservationResponseDto.fromJS(_data["changereservation"]) : <any>null;
            this.bookingchanges = _data["bookingchanges"] ? PartyBookingChangeDto.fromJS(_data["bookingchanges"]) : <any>null;
            this.packagename = _data["packagename"] !== undefined ? _data["packagename"] : <any>null;
            this.packageguid = _data["packageguid"] !== undefined ? _data["packageguid"] : <any>null;
            if (Array.isArray(_data["guests"])) {
                this.guests = [] as any;
                for (let item of _data["guests"])
                    this.guests!.push(GuestResponseDto.fromJS(item));
            }
            else {
                this.guests = <any>null;
            }
            if (Array.isArray(_data["invites"])) {
                this.invites = [] as any;
                for (let item of _data["invites"])
                    this.invites!.push(InviteDto.fromJS(item));
            }
            else {
                this.invites = <any>null;
            }
            if (Array.isArray(_data["bookingarticles"])) {
                this.bookingarticles = [] as any;
                for (let item of _data["bookingarticles"])
                    this.bookingarticles!.push(BookingArticleDto.fromJS(item));
            }
            else {
                this.bookingarticles = <any>null;
            }
            this.priceextrabirthdaychild = _data["priceextrabirthdaychild"] ? PartyBookingPriceDto.fromJS(_data["priceextrabirthdaychild"]) : <any>null;
            this.artnoextrabirthdaychild = _data["artnoextrabirthdaychild"] !== undefined ? _data["artnoextrabirthdaychild"] : <any>null;
            this.createddate = _data["createddate"] !== undefined ? _data["createddate"] : <any>null;
            this.staffmessage = _data["staffmessage"] !== undefined ? _data["staffmessage"] : <any>null;
            this.allergymessage = _data["allergymessage"] !== undefined ? _data["allergymessage"] : <any>null;
            this.invitemessage = _data["invitemessage"] !== undefined ? _data["invitemessage"] : <any>null;
        }
    }

    static fromJS(data: any): PartyBookingResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["maxguests"] = this.maxguests !== undefined ? this.maxguests : <any>null;
        data["minguests"] = this.minguests !== undefined ? this.minguests : <any>null;
        data["price"] = this.price ? this.price.toJSON() : <any>null;
        data["orderreference"] = this.orderreference !== undefined ? this.orderreference : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["canchangedate"] = this.canchangedate !== undefined ? this.canchangedate : <any>null;
        data["canchangearticles"] = this.canchangearticles !== undefined ? this.canchangearticles : <any>null;
        data["canchangeguests"] = this.canchangeguests !== undefined ? this.canchangeguests : <any>null;
        data["canconfirm"] = this.canconfirm !== undefined ? this.canconfirm : <any>null;
        data["playgroundid"] = this.playgroundid !== undefined ? this.playgroundid : <any>null;
        data["startdate"] = this.startdate !== undefined ? this.startdate : <any>null;
        data["stopdate"] = this.stopdate !== undefined ? this.stopdate : <any>null;
        data["partylength"] = this.partylength !== undefined ? this.partylength : <any>null;
        data["invitationbackgroundguid"] = this.invitationbackgroundguid !== undefined ? this.invitationbackgroundguid : <any>null;
        data["invitationmessage"] = this.invitationmessage !== undefined ? this.invitationmessage : <any>null;
        data["reservation"] = this.reservation ? this.reservation.toJSON() : <any>null;
        data["changereservation"] = this.changereservation ? this.changereservation.toJSON() : <any>null;
        data["bookingchanges"] = this.bookingchanges ? this.bookingchanges.toJSON() : <any>null;
        data["packagename"] = this.packagename !== undefined ? this.packagename : <any>null;
        data["packageguid"] = this.packageguid !== undefined ? this.packageguid : <any>null;
        if (Array.isArray(this.guests)) {
            data["guests"] = [];
            for (let item of this.guests)
                data["guests"].push(item.toJSON());
        }
        if (Array.isArray(this.invites)) {
            data["invites"] = [];
            for (let item of this.invites)
                data["invites"].push(item.toJSON());
        }
        if (Array.isArray(this.bookingarticles)) {
            data["bookingarticles"] = [];
            for (let item of this.bookingarticles)
                data["bookingarticles"].push(item.toJSON());
        }
        data["priceextrabirthdaychild"] = this.priceextrabirthdaychild ? this.priceextrabirthdaychild.toJSON() : <any>null;
        data["artnoextrabirthdaychild"] = this.artnoextrabirthdaychild !== undefined ? this.artnoextrabirthdaychild : <any>null;
        data["createddate"] = this.createddate !== undefined ? this.createddate : <any>null;
        data["staffmessage"] = this.staffmessage !== undefined ? this.staffmessage : <any>null;
        data["allergymessage"] = this.allergymessage !== undefined ? this.allergymessage : <any>null;
        data["invitemessage"] = this.invitemessage !== undefined ? this.invitemessage : <any>null;
        return data;
    }
}

export interface IPartyBookingResponseDto {
    guid: string;
    maxguests: number;
    minguests: number;
    price: PartyBookingPriceDto | null;
    orderreference: string | null;
    status: string | null;
    canchangedate: boolean;
    canchangearticles: boolean;
    canchangeguests: boolean;
    canconfirm: boolean;
    playgroundid: string;
    startdate: string | null;
    stopdate: string | null;
    partylength: number | null;
    /** The currently selected invitation background guid. Null if none is selected. */
    invitationbackgroundguid: string | null;
    invitationmessage: string | null;
    reservation: PartyReservationResponseDto | null;
    changereservation: PartyReservationResponseDto | null;
    bookingchanges: PartyBookingChangeDto | null;
    packagename: string | null;
    packageguid: string | null;
    guests: GuestResponseDto[] | null;
    invites: InviteDto[] | null;
    bookingarticles: BookingArticleDto[] | null;
    /** The price per extra birthday child. The first birthday child is always included in the price. */
    priceextrabirthdaychild: PartyBookingPriceDto | null;
    artnoextrabirthdaychild: string | null;
    /** The date the booking was created. */
    createddate: string | null;
    staffmessage: string | null;
    allergymessage: string | null;
    invitemessage: string | null;
}

export class PartyPackageArticleCollectionDto implements IPartyPackageArticleCollectionDto {
    name!: string | null;
    notice!: string | null;
    iscampaign!: boolean;
    guid!: string;
    status!: PublishStatus;
    sortorder!: number;
    defaultpriceperguest!: number;
    locations!: LocationListItem[] | null;
    /** Warning: Criterias should not be visible in public */
    daytypecriterias!: string[] | null;
    /** Warning: Criterias should not be visible in public */
    datecriterias!: DateCriteriaDto[] | null;
    packageid!: string;
    defaultarticles!: PartyPackageArticleDto[] | null;
    addonarticles!: PartyPackageArticleDto[] | null;

    constructor(data?: IPartyPackageArticleCollectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.notice = _data["notice"] !== undefined ? _data["notice"] : <any>null;
            this.iscampaign = _data["iscampaign"] !== undefined ? _data["iscampaign"] : <any>null;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.sortorder = _data["sortorder"] !== undefined ? _data["sortorder"] : <any>null;
            this.defaultpriceperguest = _data["defaultpriceperguest"] !== undefined ? _data["defaultpriceperguest"] : <any>null;
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(LocationListItem.fromJS(item));
            }
            else {
                this.locations = <any>null;
            }
            if (Array.isArray(_data["daytypecriterias"])) {
                this.daytypecriterias = [] as any;
                for (let item of _data["daytypecriterias"])
                    this.daytypecriterias!.push(item);
            }
            else {
                this.daytypecriterias = <any>null;
            }
            if (Array.isArray(_data["datecriterias"])) {
                this.datecriterias = [] as any;
                for (let item of _data["datecriterias"])
                    this.datecriterias!.push(DateCriteriaDto.fromJS(item));
            }
            else {
                this.datecriterias = <any>null;
            }
            this.packageid = _data["packageid"] !== undefined ? _data["packageid"] : <any>null;
            if (Array.isArray(_data["defaultarticles"])) {
                this.defaultarticles = [] as any;
                for (let item of _data["defaultarticles"])
                    this.defaultarticles!.push(PartyPackageArticleDto.fromJS(item));
            }
            else {
                this.defaultarticles = <any>null;
            }
            if (Array.isArray(_data["addonarticles"])) {
                this.addonarticles = [] as any;
                for (let item of _data["addonarticles"])
                    this.addonarticles!.push(PartyPackageArticleDto.fromJS(item));
            }
            else {
                this.addonarticles = <any>null;
            }
        }
    }

    static fromJS(data: any): PartyPackageArticleCollectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyPackageArticleCollectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["notice"] = this.notice !== undefined ? this.notice : <any>null;
        data["iscampaign"] = this.iscampaign !== undefined ? this.iscampaign : <any>null;
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["sortorder"] = this.sortorder !== undefined ? this.sortorder : <any>null;
        data["defaultpriceperguest"] = this.defaultpriceperguest !== undefined ? this.defaultpriceperguest : <any>null;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.daytypecriterias)) {
            data["daytypecriterias"] = [];
            for (let item of this.daytypecriterias)
                data["daytypecriterias"].push(item);
        }
        if (Array.isArray(this.datecriterias)) {
            data["datecriterias"] = [];
            for (let item of this.datecriterias)
                data["datecriterias"].push(item.toJSON());
        }
        data["packageid"] = this.packageid !== undefined ? this.packageid : <any>null;
        if (Array.isArray(this.defaultarticles)) {
            data["defaultarticles"] = [];
            for (let item of this.defaultarticles)
                data["defaultarticles"].push(item.toJSON());
        }
        if (Array.isArray(this.addonarticles)) {
            data["addonarticles"] = [];
            for (let item of this.addonarticles)
                data["addonarticles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPartyPackageArticleCollectionDto {
    name: string | null;
    notice: string | null;
    iscampaign: boolean;
    guid: string;
    status: PublishStatus;
    sortorder: number;
    defaultpriceperguest: number;
    locations: LocationListItem[] | null;
    /** Warning: Criterias should not be visible in public */
    daytypecriterias: string[] | null;
    /** Warning: Criterias should not be visible in public */
    datecriterias: DateCriteriaDto[] | null;
    packageid: string;
    defaultarticles: PartyPackageArticleDto[] | null;
    addonarticles: PartyPackageArticleDto[] | null;
}

export class PartyPackageArticleDto implements IPartyPackageArticleDto {
    name!: string | null;
    translatednames!: { [key: string]: string; } | null;
    guid!: string;
    webarticleid!: string;
    artno!: string | null;
    navartno!: string | null;
    articlegroup!: string | null;
    price!: number;
    vat!: number | null;
    originalprice!: number | null;
    itemtype!: PackageItemType;
    image!: ImageDto | null;
    fixedamount!: number | null;
    sortorder!: number;
    isdefaultvisible!: boolean;
    exchangeable!: PartyPackageArticleDto[] | null;

    constructor(data?: IPartyPackageArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (_data["translatednames"]) {
                this.translatednames = {} as any;
                for (let key in _data["translatednames"]) {
                    if (_data["translatednames"].hasOwnProperty(key))
                        (<any>this.translatednames)![key] = _data["translatednames"][key] !== undefined ? _data["translatednames"][key] : <any>null;
                }
            }
            else {
                this.translatednames = <any>null;
            }
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.webarticleid = _data["webarticleid"] !== undefined ? _data["webarticleid"] : <any>null;
            this.artno = _data["artno"] !== undefined ? _data["artno"] : <any>null;
            this.navartno = _data["navartno"] !== undefined ? _data["navartno"] : <any>null;
            this.articlegroup = _data["articlegroup"] !== undefined ? _data["articlegroup"] : <any>null;
            this.price = _data["price"] !== undefined ? _data["price"] : <any>null;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : <any>null;
            this.originalprice = _data["originalprice"] !== undefined ? _data["originalprice"] : <any>null;
            this.itemtype = _data["itemtype"] !== undefined ? _data["itemtype"] : <any>null;
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>null;
            this.fixedamount = _data["fixedamount"] !== undefined ? _data["fixedamount"] : <any>null;
            this.sortorder = _data["sortorder"] !== undefined ? _data["sortorder"] : <any>null;
            this.isdefaultvisible = _data["isdefaultvisible"] !== undefined ? _data["isdefaultvisible"] : <any>null;
            if (Array.isArray(_data["exchangeable"])) {
                this.exchangeable = [] as any;
                for (let item of _data["exchangeable"])
                    this.exchangeable!.push(PartyPackageArticleDto.fromJS(item));
            }
            else {
                this.exchangeable = <any>null;
            }
        }
    }

    static fromJS(data: any): PartyPackageArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyPackageArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (this.translatednames) {
            data["translatednames"] = {};
            for (let key in this.translatednames) {
                if (this.translatednames.hasOwnProperty(key))
                    (<any>data["translatednames"])[key] = this.translatednames[key] !== undefined ? this.translatednames[key] : <any>null;
            }
        }
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["webarticleid"] = this.webarticleid !== undefined ? this.webarticleid : <any>null;
        data["artno"] = this.artno !== undefined ? this.artno : <any>null;
        data["navartno"] = this.navartno !== undefined ? this.navartno : <any>null;
        data["articlegroup"] = this.articlegroup !== undefined ? this.articlegroup : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["vat"] = this.vat !== undefined ? this.vat : <any>null;
        data["originalprice"] = this.originalprice !== undefined ? this.originalprice : <any>null;
        data["itemtype"] = this.itemtype !== undefined ? this.itemtype : <any>null;
        data["image"] = this.image ? this.image.toJSON() : <any>null;
        data["fixedamount"] = this.fixedamount !== undefined ? this.fixedamount : <any>null;
        data["sortorder"] = this.sortorder !== undefined ? this.sortorder : <any>null;
        data["isdefaultvisible"] = this.isdefaultvisible !== undefined ? this.isdefaultvisible : <any>null;
        if (Array.isArray(this.exchangeable)) {
            data["exchangeable"] = [];
            for (let item of this.exchangeable)
                data["exchangeable"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPartyPackageArticleDto {
    name: string | null;
    translatednames: { [key: string]: string; } | null;
    guid: string;
    webarticleid: string;
    artno: string | null;
    navartno: string | null;
    articlegroup: string | null;
    price: number;
    vat: number | null;
    originalprice: number | null;
    itemtype: PackageItemType;
    image: ImageDto | null;
    fixedamount: number | null;
    sortorder: number;
    isdefaultvisible: boolean;
    exchangeable: PartyPackageArticleDto[] | null;
}

export class PartyPackageDto implements IPartyPackageDto {
    guid!: string | null;
    name!: string | null;
    shortname!: string | null;
    price!: PriceDto | null;
    shortdescription!: string | null;
    description!: string | null;
    status!: PublishStatus;
    preselected!: boolean;
    displayprice!: PriceDto | null;
    country!: CountryDto | null;
    articles!: PartyPackageArticleCollectionDto | null;
    image!: ImageDto | null;

    constructor(data?: IPartyPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.shortname = _data["shortname"] !== undefined ? _data["shortname"] : <any>null;
            this.price = _data["price"] ? PriceDto.fromJS(_data["price"]) : <any>null;
            this.shortdescription = _data["shortdescription"] !== undefined ? _data["shortdescription"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.preselected = _data["preselected"] !== undefined ? _data["preselected"] : <any>null;
            this.displayprice = _data["displayprice"] ? PriceDto.fromJS(_data["displayprice"]) : <any>null;
            this.country = _data["country"] ? CountryDto.fromJS(_data["country"]) : <any>null;
            this.articles = _data["articles"] ? PartyPackageArticleCollectionDto.fromJS(_data["articles"]) : <any>null;
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>null;
        }
    }

    static fromJS(data: any): PartyPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["shortname"] = this.shortname !== undefined ? this.shortname : <any>null;
        data["price"] = this.price ? this.price.toJSON() : <any>null;
        data["shortdescription"] = this.shortdescription !== undefined ? this.shortdescription : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["preselected"] = this.preselected !== undefined ? this.preselected : <any>null;
        data["displayprice"] = this.displayprice ? this.displayprice.toJSON() : <any>null;
        data["country"] = this.country ? this.country.toJSON() : <any>null;
        data["articles"] = this.articles ? this.articles.toJSON() : <any>null;
        data["image"] = this.image ? this.image.toJSON() : <any>null;
        return data;
    }
}

export interface IPartyPackageDto {
    guid: string | null;
    name: string | null;
    shortname: string | null;
    price: PriceDto | null;
    shortdescription: string | null;
    description: string | null;
    status: PublishStatus;
    preselected: boolean;
    displayprice: PriceDto | null;
    country: CountryDto | null;
    articles: PartyPackageArticleCollectionDto | null;
    image: ImageDto | null;
}

export class PartyReservationChangeRequestDto implements IPartyReservationChangeRequestDto {
    reservationid!: string;
    timeslotid!: string;
    /** Time when the party guests should arrive. Clock string (HH:MM) in local time. */
    arrivaltime!: string | null;
    /** The length of the party in minutes (play time + party room) */
    partylengthminutes!: number | null;
    readyforconfirm!: boolean;
    partydate!: string | null;
    roomid!: string;

    constructor(data?: IPartyReservationChangeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationid = _data["reservationid"] !== undefined ? _data["reservationid"] : <any>null;
            this.timeslotid = _data["timeslotid"] !== undefined ? _data["timeslotid"] : <any>null;
            this.arrivaltime = _data["arrivaltime"] !== undefined ? _data["arrivaltime"] : <any>null;
            this.partylengthminutes = _data["partylengthminutes"] !== undefined ? _data["partylengthminutes"] : <any>null;
            this.readyforconfirm = _data["readyforconfirm"] !== undefined ? _data["readyforconfirm"] : <any>null;
            this.partydate = _data["partydate"] !== undefined ? _data["partydate"] : <any>null;
            this.roomid = _data["roomid"] !== undefined ? _data["roomid"] : <any>null;
        }
    }

    static fromJS(data: any): PartyReservationChangeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyReservationChangeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationid"] = this.reservationid !== undefined ? this.reservationid : <any>null;
        data["timeslotid"] = this.timeslotid !== undefined ? this.timeslotid : <any>null;
        data["arrivaltime"] = this.arrivaltime !== undefined ? this.arrivaltime : <any>null;
        data["partylengthminutes"] = this.partylengthminutes !== undefined ? this.partylengthminutes : <any>null;
        data["readyforconfirm"] = this.readyforconfirm !== undefined ? this.readyforconfirm : <any>null;
        data["partydate"] = this.partydate !== undefined ? this.partydate : <any>null;
        data["roomid"] = this.roomid !== undefined ? this.roomid : <any>null;
        return data;
    }
}

export interface IPartyReservationChangeRequestDto {
    reservationid: string;
    timeslotid: string;
    /** Time when the party guests should arrive. Clock string (HH:MM) in local time. */
    arrivaltime: string | null;
    /** The length of the party in minutes (play time + party room) */
    partylengthminutes: number | null;
    readyforconfirm: boolean;
    partydate: string | null;
    roomid: string;
}

export class PartyReservationMakeRequestDto implements IPartyReservationMakeRequestDto {
    timeslotid!: string;
    arrivaltime!: string | null;
    partylengthminutes!: number | null;
    partydate!: string | null;
    roomid!: string;

    constructor(data?: IPartyReservationMakeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeslotid = _data["timeslotid"] !== undefined ? _data["timeslotid"] : <any>null;
            this.arrivaltime = _data["arrivaltime"] !== undefined ? _data["arrivaltime"] : <any>null;
            this.partylengthminutes = _data["partylengthminutes"] !== undefined ? _data["partylengthminutes"] : <any>null;
            this.partydate = _data["partydate"] !== undefined ? _data["partydate"] : <any>null;
            this.roomid = _data["roomid"] !== undefined ? _data["roomid"] : <any>null;
        }
    }

    static fromJS(data: any): PartyReservationMakeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyReservationMakeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeslotid"] = this.timeslotid !== undefined ? this.timeslotid : <any>null;
        data["arrivaltime"] = this.arrivaltime !== undefined ? this.arrivaltime : <any>null;
        data["partylengthminutes"] = this.partylengthminutes !== undefined ? this.partylengthminutes : <any>null;
        data["partydate"] = this.partydate !== undefined ? this.partydate : <any>null;
        data["roomid"] = this.roomid !== undefined ? this.roomid : <any>null;
        return data;
    }
}

export interface IPartyReservationMakeRequestDto {
    timeslotid: string;
    arrivaltime: string | null;
    partylengthminutes: number | null;
    partydate: string | null;
    roomid: string;
}

export class PartyReservationResponseDto implements IPartyReservationResponseDto {
    reservationid!: string;
    guid!: string;
    bookingid!: string;
    starttime!: string | null;
    displaystarttime!: string | null;
    slotcomment!: string | null;
    endtime!: string | null;
    status!: string | null;
    timeslot!: TimeSlotDto | null;
    partydate!: string | null;
    roomid!: string;

    constructor(data?: IPartyReservationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationid = _data["reservationid"] !== undefined ? _data["reservationid"] : <any>null;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.bookingid = _data["bookingid"] !== undefined ? _data["bookingid"] : <any>null;
            this.starttime = _data["starttime"] !== undefined ? _data["starttime"] : <any>null;
            this.displaystarttime = _data["displaystarttime"] !== undefined ? _data["displaystarttime"] : <any>null;
            this.slotcomment = _data["slotcomment"] !== undefined ? _data["slotcomment"] : <any>null;
            this.endtime = _data["endtime"] !== undefined ? _data["endtime"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.timeslot = _data["timeslot"] ? TimeSlotDto.fromJS(_data["timeslot"]) : <any>null;
            this.partydate = _data["partydate"] !== undefined ? _data["partydate"] : <any>null;
            this.roomid = _data["roomid"] !== undefined ? _data["roomid"] : <any>null;
        }
    }

    static fromJS(data: any): PartyReservationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyReservationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationid"] = this.reservationid !== undefined ? this.reservationid : <any>null;
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["bookingid"] = this.bookingid !== undefined ? this.bookingid : <any>null;
        data["starttime"] = this.starttime !== undefined ? this.starttime : <any>null;
        data["displaystarttime"] = this.displaystarttime !== undefined ? this.displaystarttime : <any>null;
        data["slotcomment"] = this.slotcomment !== undefined ? this.slotcomment : <any>null;
        data["endtime"] = this.endtime !== undefined ? this.endtime : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["timeslot"] = this.timeslot ? this.timeslot.toJSON() : <any>null;
        data["partydate"] = this.partydate !== undefined ? this.partydate : <any>null;
        data["roomid"] = this.roomid !== undefined ? this.roomid : <any>null;
        return data;
    }
}

export interface IPartyReservationResponseDto {
    reservationid: string;
    guid: string;
    bookingid: string;
    starttime: string | null;
    displaystarttime: string | null;
    slotcomment: string | null;
    endtime: string | null;
    status: string | null;
    timeslot: TimeSlotDto | null;
    partydate: string | null;
    roomid: string;
}

export class BoolResultDto implements IBoolResultDto {
    success!: boolean;
    message!: string | null;
    relatedobject!: string;
    errors!: string[] | null;
    notices!: NoticeDto[] | null;

    constructor(data?: IBoolResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.relatedobject = _data["relatedobject"] !== undefined ? _data["relatedobject"] : <any>null;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = <any>null;
            }
            if (Array.isArray(_data["notices"])) {
                this.notices = [] as any;
                for (let item of _data["notices"])
                    this.notices!.push(NoticeDto.fromJS(item));
            }
            else {
                this.notices = <any>null;
            }
        }
    }

    static fromJS(data: any): BoolResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoolResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["relatedobject"] = this.relatedobject !== undefined ? this.relatedobject : <any>null;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.notices)) {
            data["notices"] = [];
            for (let item of this.notices)
                data["notices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBoolResultDto {
    success: boolean;
    message: string | null;
    relatedobject: string;
    errors: string[] | null;
    notices: NoticeDto[] | null;
}

export class ChangeNumberOfGuestsDto implements IChangeNumberOfGuestsDto {
    partybookingid!: string;
    numberofguests!: number;

    constructor(data?: IChangeNumberOfGuestsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partybookingid = _data["partybookingid"] !== undefined ? _data["partybookingid"] : <any>null;
            this.numberofguests = _data["numberofguests"] !== undefined ? _data["numberofguests"] : <any>null;
        }
    }

    static fromJS(data: any): ChangeNumberOfGuestsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeNumberOfGuestsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partybookingid"] = this.partybookingid !== undefined ? this.partybookingid : <any>null;
        data["numberofguests"] = this.numberofguests !== undefined ? this.numberofguests : <any>null;
        return data;
    }
}

export interface IChangeNumberOfGuestsDto {
    partybookingid: string;
    numberofguests: number;
}

export class CountryDto implements ICountryDto {
    name!: string | null;
    culture!: string | null;
    currency!: string | null;
    timezone!: string | null;
    entrancevat!: number;
    /** The VAT % for the child class booking (25 = 25%). */
    childclassvat!: number;
    companyname!: string | null;
    companyorgno!: string | null;
    createuserinnav!: boolean;
    guid!: string;
    /** The countrys sms sender display name */
    smsfrom!: string | null;
    /** The countrys mail sender display name */
    mailfrom!: string | null;
    sitebaseaddress!: string | null;
    orderbaseaddress!: string | null;
    profilebaseaddress!: string | null;
    partybaseaddress!: string | null;
    regions!: RegionDto[] | null;
    futureorderingmerchantid!: string | null;
    futureorderingnavtendertype!: string | null;
    companyaddress!: string | null;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.culture = _data["culture"] !== undefined ? _data["culture"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.timezone = _data["timezone"] !== undefined ? _data["timezone"] : <any>null;
            this.entrancevat = _data["entrancevat"] !== undefined ? _data["entrancevat"] : <any>null;
            this.childclassvat = _data["childclassvat"] !== undefined ? _data["childclassvat"] : <any>null;
            this.companyname = _data["companyname"] !== undefined ? _data["companyname"] : <any>null;
            this.companyorgno = _data["companyorgno"] !== undefined ? _data["companyorgno"] : <any>null;
            this.createuserinnav = _data["createuserinnav"] !== undefined ? _data["createuserinnav"] : <any>null;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.smsfrom = _data["smsfrom"] !== undefined ? _data["smsfrom"] : <any>null;
            this.mailfrom = _data["mailfrom"] !== undefined ? _data["mailfrom"] : <any>null;
            this.sitebaseaddress = _data["sitebaseaddress"] !== undefined ? _data["sitebaseaddress"] : <any>null;
            this.orderbaseaddress = _data["orderbaseaddress"] !== undefined ? _data["orderbaseaddress"] : <any>null;
            this.profilebaseaddress = _data["profilebaseaddress"] !== undefined ? _data["profilebaseaddress"] : <any>null;
            this.partybaseaddress = _data["partybaseaddress"] !== undefined ? _data["partybaseaddress"] : <any>null;
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(RegionDto.fromJS(item));
            }
            else {
                this.regions = <any>null;
            }
            this.futureorderingmerchantid = _data["futureorderingmerchantid"] !== undefined ? _data["futureorderingmerchantid"] : <any>null;
            this.futureorderingnavtendertype = _data["futureorderingnavtendertype"] !== undefined ? _data["futureorderingnavtendertype"] : <any>null;
            this.companyaddress = _data["companyaddress"] !== undefined ? _data["companyaddress"] : <any>null;
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["culture"] = this.culture !== undefined ? this.culture : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["timezone"] = this.timezone !== undefined ? this.timezone : <any>null;
        data["entrancevat"] = this.entrancevat !== undefined ? this.entrancevat : <any>null;
        data["childclassvat"] = this.childclassvat !== undefined ? this.childclassvat : <any>null;
        data["companyname"] = this.companyname !== undefined ? this.companyname : <any>null;
        data["companyorgno"] = this.companyorgno !== undefined ? this.companyorgno : <any>null;
        data["createuserinnav"] = this.createuserinnav !== undefined ? this.createuserinnav : <any>null;
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["smsfrom"] = this.smsfrom !== undefined ? this.smsfrom : <any>null;
        data["mailfrom"] = this.mailfrom !== undefined ? this.mailfrom : <any>null;
        data["sitebaseaddress"] = this.sitebaseaddress !== undefined ? this.sitebaseaddress : <any>null;
        data["orderbaseaddress"] = this.orderbaseaddress !== undefined ? this.orderbaseaddress : <any>null;
        data["profilebaseaddress"] = this.profilebaseaddress !== undefined ? this.profilebaseaddress : <any>null;
        data["partybaseaddress"] = this.partybaseaddress !== undefined ? this.partybaseaddress : <any>null;
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item.toJSON());
        }
        data["futureorderingmerchantid"] = this.futureorderingmerchantid !== undefined ? this.futureorderingmerchantid : <any>null;
        data["futureorderingnavtendertype"] = this.futureorderingnavtendertype !== undefined ? this.futureorderingnavtendertype : <any>null;
        data["companyaddress"] = this.companyaddress !== undefined ? this.companyaddress : <any>null;
        return data;
    }
}

export interface ICountryDto {
    name: string | null;
    culture: string | null;
    currency: string | null;
    timezone: string | null;
    entrancevat: number;
    /** The VAT % for the child class booking (25 = 25%). */
    childclassvat: number;
    companyname: string | null;
    companyorgno: string | null;
    createuserinnav: boolean;
    guid: string;
    /** The countrys sms sender display name */
    smsfrom: string | null;
    /** The countrys mail sender display name */
    mailfrom: string | null;
    sitebaseaddress: string | null;
    orderbaseaddress: string | null;
    profilebaseaddress: string | null;
    partybaseaddress: string | null;
    regions: RegionDto[] | null;
    futureorderingmerchantid: string | null;
    futureorderingnavtendertype: string | null;
    companyaddress: string | null;
}

/** Meta data for countries */
export class CountryMetadataDto implements ICountryMetadataDto {
    /** Available country phone number codes
E.g. 46 for Sweden.
Sorted in countries where Leo's are active and then by increasing country code. */
    readonly countryPhoneNumberCodes!: number[];
    /** Available cultures -> phone number codes.
E.g. "sv-SE" -> 46. */
    readonly cultureToCountryCodes!: { [key: string]: number; };

    constructor(data?: ICountryMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.countryPhoneNumberCodes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countryPhoneNumberCodes"])) {
                (<any>this).countryPhoneNumberCodes = [] as any;
                for (let item of _data["countryPhoneNumberCodes"])
                    (<any>this).countryPhoneNumberCodes!.push(item);
            }
            else {
                (<any>this).countryPhoneNumberCodes = <any>null;
            }
            if (_data["cultureToCountryCodes"]) {
                (<any>this).cultureToCountryCodes = {} as any;
                for (let key in _data["cultureToCountryCodes"]) {
                    if (_data["cultureToCountryCodes"].hasOwnProperty(key))
                        (<any>(<any>this).cultureToCountryCodes)![key] = _data["cultureToCountryCodes"][key] !== undefined ? _data["cultureToCountryCodes"][key] : <any>null;
                }
            }
            else {
                (<any>this).cultureToCountryCodes = <any>null;
            }
        }
    }

    static fromJS(data: any): CountryMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countryPhoneNumberCodes)) {
            data["countryPhoneNumberCodes"] = [];
            for (let item of this.countryPhoneNumberCodes)
                data["countryPhoneNumberCodes"].push(item);
        }
        if (this.cultureToCountryCodes) {
            data["cultureToCountryCodes"] = {};
            for (let key in this.cultureToCountryCodes) {
                if (this.cultureToCountryCodes.hasOwnProperty(key))
                    (<any>data["cultureToCountryCodes"])[key] = this.cultureToCountryCodes[key] !== undefined ? this.cultureToCountryCodes[key] : <any>null;
            }
        }
        return data;
    }
}

/** Meta data for countries */
export interface ICountryMetadataDto {
    /** Available country phone number codes
E.g. 46 for Sweden.
Sorted in countries where Leo's are active and then by increasing country code. */
    countryPhoneNumberCodes: number[];
    /** Available cultures -> phone number codes.
E.g. "sv-SE" -> 46. */
    cultureToCountryCodes: { [key: string]: number; };
}

export class GuestAttendenceDto implements IGuestAttendenceDto {
    bookingId!: string;
    inviteId!: string;
    isAttending!: boolean;

    constructor(data?: IGuestAttendenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingId = _data["bookingId"] !== undefined ? _data["bookingId"] : <any>null;
            this.inviteId = _data["inviteId"] !== undefined ? _data["inviteId"] : <any>null;
            this.isAttending = _data["isAttending"] !== undefined ? _data["isAttending"] : <any>null;
        }
    }

    static fromJS(data: any): GuestAttendenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestAttendenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId !== undefined ? this.bookingId : <any>null;
        data["inviteId"] = this.inviteId !== undefined ? this.inviteId : <any>null;
        data["isAttending"] = this.isAttending !== undefined ? this.isAttending : <any>null;
        return data;
    }
}

export interface IGuestAttendenceDto {
    bookingId: string;
    inviteId: string;
    isAttending: boolean;
}

export class GuestDto implements IGuestDto {
    guestname!: string | null;
    parentname!: string | null;
    age!: number | null;
    birthdaydate!: string | null;
    birthday!: boolean;
    ismainguest!: boolean;
    phonecountrycode!: number;
    phone!: string | null;
    email!: string | null;
    gender!: string | null;
    otherinfo!: string | null;
    guestid!: string;
    inviteid!: string;
    partybookingid!: string;
    disableconfirmation!: boolean;
    disablesendinvite!: boolean;
    notices!: NoticeDto[] | null;

    constructor(data?: IGuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guestname = _data["guestname"] !== undefined ? _data["guestname"] : <any>null;
            this.parentname = _data["parentname"] !== undefined ? _data["parentname"] : <any>null;
            this.age = _data["age"] !== undefined ? _data["age"] : <any>null;
            this.birthdaydate = _data["birthdaydate"] !== undefined ? _data["birthdaydate"] : <any>null;
            this.birthday = _data["birthday"] !== undefined ? _data["birthday"] : <any>null;
            this.ismainguest = _data["ismainguest"] !== undefined ? _data["ismainguest"] : <any>null;
            this.phonecountrycode = _data["phonecountrycode"] !== undefined ? _data["phonecountrycode"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.otherinfo = _data["otherinfo"] !== undefined ? _data["otherinfo"] : <any>null;
            this.guestid = _data["guestid"] !== undefined ? _data["guestid"] : <any>null;
            this.inviteid = _data["inviteid"] !== undefined ? _data["inviteid"] : <any>null;
            this.partybookingid = _data["partybookingid"] !== undefined ? _data["partybookingid"] : <any>null;
            this.disableconfirmation = _data["disableconfirmation"] !== undefined ? _data["disableconfirmation"] : <any>null;
            this.disablesendinvite = _data["disablesendinvite"] !== undefined ? _data["disablesendinvite"] : <any>null;
            if (Array.isArray(_data["notices"])) {
                this.notices = [] as any;
                for (let item of _data["notices"])
                    this.notices!.push(NoticeDto.fromJS(item));
            }
            else {
                this.notices = <any>null;
            }
        }
    }

    static fromJS(data: any): GuestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestname"] = this.guestname !== undefined ? this.guestname : <any>null;
        data["parentname"] = this.parentname !== undefined ? this.parentname : <any>null;
        data["age"] = this.age !== undefined ? this.age : <any>null;
        data["birthdaydate"] = this.birthdaydate !== undefined ? this.birthdaydate : <any>null;
        data["birthday"] = this.birthday !== undefined ? this.birthday : <any>null;
        data["ismainguest"] = this.ismainguest !== undefined ? this.ismainguest : <any>null;
        data["phonecountrycode"] = this.phonecountrycode !== undefined ? this.phonecountrycode : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["otherinfo"] = this.otherinfo !== undefined ? this.otherinfo : <any>null;
        data["guestid"] = this.guestid !== undefined ? this.guestid : <any>null;
        data["inviteid"] = this.inviteid !== undefined ? this.inviteid : <any>null;
        data["partybookingid"] = this.partybookingid !== undefined ? this.partybookingid : <any>null;
        data["disableconfirmation"] = this.disableconfirmation !== undefined ? this.disableconfirmation : <any>null;
        data["disablesendinvite"] = this.disablesendinvite !== undefined ? this.disablesendinvite : <any>null;
        if (Array.isArray(this.notices)) {
            data["notices"] = [];
            for (let item of this.notices)
                data["notices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGuestDto {
    guestname: string | null;
    parentname: string | null;
    age: number | null;
    birthdaydate: string | null;
    birthday: boolean;
    ismainguest: boolean;
    phonecountrycode: number;
    phone: string | null;
    email: string | null;
    gender: string | null;
    otherinfo: string | null;
    guestid: string;
    inviteid: string;
    partybookingid: string;
    disableconfirmation: boolean;
    disablesendinvite: boolean;
    notices: NoticeDto[] | null;
}

export class GuestResponseDto implements IGuestResponseDto {
    status!: string | null;
    guestmessage!: string | null;
    /** Allergy information supplied by the guest when answering an invitation. */
    guestallergymessage!: string | null;
    guestname!: string | null;
    parentname!: string | null;
    age!: number | null;
    birthdaydate!: string | null;
    birthday!: boolean;
    ismainguest!: boolean;
    phonecountrycode!: number;
    phone!: string | null;
    email!: string | null;
    gender!: string | null;
    otherinfo!: string | null;
    guestid!: string;
    inviteid!: string;
    partybookingid!: string;
    disableconfirmation!: boolean;
    disablesendinvite!: boolean;
    notices!: NoticeDto[] | null;

    constructor(data?: IGuestResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.guestmessage = _data["guestmessage"] !== undefined ? _data["guestmessage"] : <any>null;
            this.guestallergymessage = _data["guestallergymessage"] !== undefined ? _data["guestallergymessage"] : <any>null;
            this.guestname = _data["guestname"] !== undefined ? _data["guestname"] : <any>null;
            this.parentname = _data["parentname"] !== undefined ? _data["parentname"] : <any>null;
            this.age = _data["age"] !== undefined ? _data["age"] : <any>null;
            this.birthdaydate = _data["birthdaydate"] !== undefined ? _data["birthdaydate"] : <any>null;
            this.birthday = _data["birthday"] !== undefined ? _data["birthday"] : <any>null;
            this.ismainguest = _data["ismainguest"] !== undefined ? _data["ismainguest"] : <any>null;
            this.phonecountrycode = _data["phonecountrycode"] !== undefined ? _data["phonecountrycode"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : <any>null;
            this.otherinfo = _data["otherinfo"] !== undefined ? _data["otherinfo"] : <any>null;
            this.guestid = _data["guestid"] !== undefined ? _data["guestid"] : <any>null;
            this.inviteid = _data["inviteid"] !== undefined ? _data["inviteid"] : <any>null;
            this.partybookingid = _data["partybookingid"] !== undefined ? _data["partybookingid"] : <any>null;
            this.disableconfirmation = _data["disableconfirmation"] !== undefined ? _data["disableconfirmation"] : <any>null;
            this.disablesendinvite = _data["disablesendinvite"] !== undefined ? _data["disablesendinvite"] : <any>null;
            if (Array.isArray(_data["notices"])) {
                this.notices = [] as any;
                for (let item of _data["notices"])
                    this.notices!.push(NoticeDto.fromJS(item));
            }
            else {
                this.notices = <any>null;
            }
        }
    }

    static fromJS(data: any): GuestResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["guestmessage"] = this.guestmessage !== undefined ? this.guestmessage : <any>null;
        data["guestallergymessage"] = this.guestallergymessage !== undefined ? this.guestallergymessage : <any>null;
        data["guestname"] = this.guestname !== undefined ? this.guestname : <any>null;
        data["parentname"] = this.parentname !== undefined ? this.parentname : <any>null;
        data["age"] = this.age !== undefined ? this.age : <any>null;
        data["birthdaydate"] = this.birthdaydate !== undefined ? this.birthdaydate : <any>null;
        data["birthday"] = this.birthday !== undefined ? this.birthday : <any>null;
        data["ismainguest"] = this.ismainguest !== undefined ? this.ismainguest : <any>null;
        data["phonecountrycode"] = this.phonecountrycode !== undefined ? this.phonecountrycode : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["gender"] = this.gender !== undefined ? this.gender : <any>null;
        data["otherinfo"] = this.otherinfo !== undefined ? this.otherinfo : <any>null;
        data["guestid"] = this.guestid !== undefined ? this.guestid : <any>null;
        data["inviteid"] = this.inviteid !== undefined ? this.inviteid : <any>null;
        data["partybookingid"] = this.partybookingid !== undefined ? this.partybookingid : <any>null;
        data["disableconfirmation"] = this.disableconfirmation !== undefined ? this.disableconfirmation : <any>null;
        data["disablesendinvite"] = this.disablesendinvite !== undefined ? this.disablesendinvite : <any>null;
        if (Array.isArray(this.notices)) {
            data["notices"] = [];
            for (let item of this.notices)
                data["notices"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGuestResponseDto {
    status: string | null;
    guestmessage: string | null;
    /** Allergy information supplied by the guest when answering an invitation. */
    guestallergymessage: string | null;
    guestname: string | null;
    parentname: string | null;
    age: number | null;
    birthdaydate: string | null;
    birthday: boolean;
    ismainguest: boolean;
    phonecountrycode: number;
    phone: string | null;
    email: string | null;
    gender: string | null;
    otherinfo: string | null;
    guestid: string;
    inviteid: string;
    partybookingid: string;
    disableconfirmation: boolean;
    disablesendinvite: boolean;
    notices: NoticeDto[] | null;
}

export class ImageDto implements IImageDto {
    guid!: string;
    name!: string | null;
    urlname!: string | null;
    created!: string | null;
    extension!: string | null;
    description!: string | null;
    width!: number;
    height!: number;

    constructor(data?: IImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.urlname = _data["urlname"] !== undefined ? _data["urlname"] : <any>null;
            this.created = _data["created"] !== undefined ? _data["created"] : <any>null;
            this.extension = _data["extension"] !== undefined ? _data["extension"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
        }
    }

    static fromJS(data: any): ImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["urlname"] = this.urlname !== undefined ? this.urlname : <any>null;
        data["created"] = this.created !== undefined ? this.created : <any>null;
        data["extension"] = this.extension !== undefined ? this.extension : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        return data;
    }
}

export interface IImageDto {
    guid: string;
    name: string | null;
    urlname: string | null;
    created: string | null;
    extension: string | null;
    description: string | null;
    width: number;
    height: number;
}

export class NoticeDto implements INoticeDto {
    message!: string | null;
    level!: NoticeNoticeLevelDto;

    constructor(data?: INoticeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.level = _data["level"] !== undefined ? _data["level"] : <any>null;
        }
    }

    static fromJS(data: any): NoticeDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoticeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["level"] = this.level !== undefined ? this.level : <any>null;
        return data;
    }
}

export interface INoticeDto {
    message: string | null;
    level: NoticeNoticeLevelDto;
}

export enum NoticeNoticeLevelDto {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class PlaygroundDto implements IPlaygroundDto {
    name!: string | null;
    translatednames!: { [key: string]: string; } | null;
    slug!: string | null;
    guid!: string | null;
    streetadress!: string | null;
    postalcode!: string | null;
    city!: string | null;
    phone!: string | null;
    adminemail!: string | null;
    contactemailchildclass!: string | null;
    contactemailpartybooking!: string | null;
    contactemailgroupbooking!: string | null;
    region!: RegionDto | null;
    regionid!: string | null;
    playcentertype!: PlaycenterType;
    maplink!: string | null;
    costcenter!: string | null;
    priceextrabirthdaychild!: number;
    artnoextrabirthdaychild!: string | null;
    navartnoextrabirthdaychild!: string | null;
    disabled!: boolean;
    usenavdynamics!: boolean;
    partybookingopeningdatetime!: string | null;
    entrancebookingopeningdate!: string | null;
    /** Content to display for the user on the party opening screen, in all the markets languages. */
    partybookingopeningcontent!: { [key: string]: PartyBookingOpeningContentDto; };
    areas!: AreaDto[] | null;
    blockreservationsminutes!: number;
    usefoodexport!: boolean;

    constructor(data?: IPlaygroundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.partybookingopeningcontent = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (_data["translatednames"]) {
                this.translatednames = {} as any;
                for (let key in _data["translatednames"]) {
                    if (_data["translatednames"].hasOwnProperty(key))
                        (<any>this.translatednames)![key] = _data["translatednames"][key] !== undefined ? _data["translatednames"][key] : <any>null;
                }
            }
            else {
                this.translatednames = <any>null;
            }
            this.slug = _data["slug"] !== undefined ? _data["slug"] : <any>null;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.streetadress = _data["streetadress"] !== undefined ? _data["streetadress"] : <any>null;
            this.postalcode = _data["postalcode"] !== undefined ? _data["postalcode"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.adminemail = _data["adminemail"] !== undefined ? _data["adminemail"] : <any>null;
            this.contactemailchildclass = _data["contactemailchildclass"] !== undefined ? _data["contactemailchildclass"] : <any>null;
            this.contactemailpartybooking = _data["contactemailpartybooking"] !== undefined ? _data["contactemailpartybooking"] : <any>null;
            this.contactemailgroupbooking = _data["contactemailgroupbooking"] !== undefined ? _data["contactemailgroupbooking"] : <any>null;
            this.region = _data["region"] ? RegionDto.fromJS(_data["region"]) : <any>null;
            this.regionid = _data["regionid"] !== undefined ? _data["regionid"] : <any>null;
            this.playcentertype = _data["playcentertype"] !== undefined ? _data["playcentertype"] : <any>null;
            this.maplink = _data["maplink"] !== undefined ? _data["maplink"] : <any>null;
            this.costcenter = _data["costcenter"] !== undefined ? _data["costcenter"] : <any>null;
            this.priceextrabirthdaychild = _data["priceextrabirthdaychild"] !== undefined ? _data["priceextrabirthdaychild"] : <any>null;
            this.artnoextrabirthdaychild = _data["artnoextrabirthdaychild"] !== undefined ? _data["artnoextrabirthdaychild"] : <any>null;
            this.navartnoextrabirthdaychild = _data["navartnoextrabirthdaychild"] !== undefined ? _data["navartnoextrabirthdaychild"] : <any>null;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : <any>null;
            this.usenavdynamics = _data["usenavdynamics"] !== undefined ? _data["usenavdynamics"] : <any>null;
            this.partybookingopeningdatetime = _data["partybookingopeningdatetime"] !== undefined ? _data["partybookingopeningdatetime"] : <any>null;
            this.entrancebookingopeningdate = _data["entrancebookingopeningdate"] !== undefined ? _data["entrancebookingopeningdate"] : <any>null;
            if (_data["partybookingopeningcontent"]) {
                this.partybookingopeningcontent = {} as any;
                for (let key in _data["partybookingopeningcontent"]) {
                    if (_data["partybookingopeningcontent"].hasOwnProperty(key))
                        (<any>this.partybookingopeningcontent)![key] = _data["partybookingopeningcontent"][key] ? PartyBookingOpeningContentDto.fromJS(_data["partybookingopeningcontent"][key]) : new PartyBookingOpeningContentDto();
                }
            }
            else {
                this.partybookingopeningcontent = <any>null;
            }
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(AreaDto.fromJS(item));
            }
            else {
                this.areas = <any>null;
            }
            this.blockreservationsminutes = _data["blockreservationsminutes"] !== undefined ? _data["blockreservationsminutes"] : <any>null;
            this.usefoodexport = _data["usefoodexport"] !== undefined ? _data["usefoodexport"] : <any>null;
        }
    }

    static fromJS(data: any): PlaygroundDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaygroundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (this.translatednames) {
            data["translatednames"] = {};
            for (let key in this.translatednames) {
                if (this.translatednames.hasOwnProperty(key))
                    (<any>data["translatednames"])[key] = this.translatednames[key] !== undefined ? this.translatednames[key] : <any>null;
            }
        }
        data["slug"] = this.slug !== undefined ? this.slug : <any>null;
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["streetadress"] = this.streetadress !== undefined ? this.streetadress : <any>null;
        data["postalcode"] = this.postalcode !== undefined ? this.postalcode : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["adminemail"] = this.adminemail !== undefined ? this.adminemail : <any>null;
        data["contactemailchildclass"] = this.contactemailchildclass !== undefined ? this.contactemailchildclass : <any>null;
        data["contactemailpartybooking"] = this.contactemailpartybooking !== undefined ? this.contactemailpartybooking : <any>null;
        data["contactemailgroupbooking"] = this.contactemailgroupbooking !== undefined ? this.contactemailgroupbooking : <any>null;
        data["region"] = this.region ? this.region.toJSON() : <any>null;
        data["regionid"] = this.regionid !== undefined ? this.regionid : <any>null;
        data["playcentertype"] = this.playcentertype !== undefined ? this.playcentertype : <any>null;
        data["maplink"] = this.maplink !== undefined ? this.maplink : <any>null;
        data["costcenter"] = this.costcenter !== undefined ? this.costcenter : <any>null;
        data["priceextrabirthdaychild"] = this.priceextrabirthdaychild !== undefined ? this.priceextrabirthdaychild : <any>null;
        data["artnoextrabirthdaychild"] = this.artnoextrabirthdaychild !== undefined ? this.artnoextrabirthdaychild : <any>null;
        data["navartnoextrabirthdaychild"] = this.navartnoextrabirthdaychild !== undefined ? this.navartnoextrabirthdaychild : <any>null;
        data["disabled"] = this.disabled !== undefined ? this.disabled : <any>null;
        data["usenavdynamics"] = this.usenavdynamics !== undefined ? this.usenavdynamics : <any>null;
        data["partybookingopeningdatetime"] = this.partybookingopeningdatetime !== undefined ? this.partybookingopeningdatetime : <any>null;
        data["entrancebookingopeningdate"] = this.entrancebookingopeningdate !== undefined ? this.entrancebookingopeningdate : <any>null;
        if (this.partybookingopeningcontent) {
            data["partybookingopeningcontent"] = {};
            for (let key in this.partybookingopeningcontent) {
                if (this.partybookingopeningcontent.hasOwnProperty(key))
                    (<any>data["partybookingopeningcontent"])[key] = this.partybookingopeningcontent[key] ? this.partybookingopeningcontent[key].toJSON() : <any>null;
            }
        }
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        data["blockreservationsminutes"] = this.blockreservationsminutes !== undefined ? this.blockreservationsminutes : <any>null;
        data["usefoodexport"] = this.usefoodexport !== undefined ? this.usefoodexport : <any>null;
        return data;
    }
}

export interface IPlaygroundDto {
    name: string | null;
    translatednames: { [key: string]: string; } | null;
    slug: string | null;
    guid: string | null;
    streetadress: string | null;
    postalcode: string | null;
    city: string | null;
    phone: string | null;
    adminemail: string | null;
    contactemailchildclass: string | null;
    contactemailpartybooking: string | null;
    contactemailgroupbooking: string | null;
    region: RegionDto | null;
    regionid: string | null;
    playcentertype: PlaycenterType;
    maplink: string | null;
    costcenter: string | null;
    priceextrabirthdaychild: number;
    artnoextrabirthdaychild: string | null;
    navartnoextrabirthdaychild: string | null;
    disabled: boolean;
    usenavdynamics: boolean;
    partybookingopeningdatetime: string | null;
    entrancebookingopeningdate: string | null;
    /** Content to display for the user on the party opening screen, in all the markets languages. */
    partybookingopeningcontent: { [key: string]: PartyBookingOpeningContentDto; };
    areas: AreaDto[] | null;
    blockreservationsminutes: number;
    usefoodexport: boolean;
}

/** Time-zone information about a playground. */
export class PlaygroundTimeZoneInformationDto implements IPlaygroundTimeZoneInformationDto {
    /** The id of the playground. */
    playgroundId!: string;
    /** The Iana time-zone (can be used for momentjs). */
    ianaTimeZone!: string;
    /** The Windows time-zone. */
    windowsTimeZone!: string;

    constructor(data?: IPlaygroundTimeZoneInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playgroundId = _data["playgroundId"] !== undefined ? _data["playgroundId"] : <any>null;
            this.ianaTimeZone = _data["ianaTimeZone"] !== undefined ? _data["ianaTimeZone"] : <any>null;
            this.windowsTimeZone = _data["windowsTimeZone"] !== undefined ? _data["windowsTimeZone"] : <any>null;
        }
    }

    static fromJS(data: any): PlaygroundTimeZoneInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaygroundTimeZoneInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playgroundId"] = this.playgroundId !== undefined ? this.playgroundId : <any>null;
        data["ianaTimeZone"] = this.ianaTimeZone !== undefined ? this.ianaTimeZone : <any>null;
        data["windowsTimeZone"] = this.windowsTimeZone !== undefined ? this.windowsTimeZone : <any>null;
        return data;
    }
}

/** Time-zone information about a playground. */
export interface IPlaygroundTimeZoneInformationDto {
    /** The id of the playground. */
    playgroundId: string;
    /** The Iana time-zone (can be used for momentjs). */
    ianaTimeZone: string;
    /** The Windows time-zone. */
    windowsTimeZone: string;
}

export class PriceDto implements IPriceDto {
    pricevalue!: number | null;
    vat!: number;
    currency!: string | null;
    locationid!: string | null;
    locationname!: string | null;

    constructor(data?: IPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pricevalue = _data["pricevalue"] !== undefined ? _data["pricevalue"] : <any>null;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : <any>null;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : <any>null;
            this.locationid = _data["locationid"] !== undefined ? _data["locationid"] : <any>null;
            this.locationname = _data["locationname"] !== undefined ? _data["locationname"] : <any>null;
        }
    }

    static fromJS(data: any): PriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pricevalue"] = this.pricevalue !== undefined ? this.pricevalue : <any>null;
        data["vat"] = this.vat !== undefined ? this.vat : <any>null;
        data["currency"] = this.currency !== undefined ? this.currency : <any>null;
        data["locationid"] = this.locationid !== undefined ? this.locationid : <any>null;
        data["locationname"] = this.locationname !== undefined ? this.locationname : <any>null;
        return data;
    }
}

export interface IPriceDto {
    pricevalue: number | null;
    vat: number;
    currency: string | null;
    locationid: string | null;
    locationname: string | null;
}

export class RegionDto implements IRegionDto {
    name!: string | null;
    guid!: string;
    country!: CountryDto | null;
    countryid!: string | null;
    playgrounds!: PlaygroundDto[] | null;

    constructor(data?: IRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.country = _data["country"] ? CountryDto.fromJS(_data["country"]) : <any>null;
            this.countryid = _data["countryid"] !== undefined ? _data["countryid"] : <any>null;
            if (Array.isArray(_data["playgrounds"])) {
                this.playgrounds = [] as any;
                for (let item of _data["playgrounds"])
                    this.playgrounds!.push(PlaygroundDto.fromJS(item));
            }
            else {
                this.playgrounds = <any>null;
            }
        }
    }

    static fromJS(data: any): RegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["country"] = this.country ? this.country.toJSON() : <any>null;
        data["countryid"] = this.countryid !== undefined ? this.countryid : <any>null;
        if (Array.isArray(this.playgrounds)) {
            data["playgrounds"] = [];
            for (let item of this.playgrounds)
                data["playgrounds"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRegionDto {
    name: string | null;
    guid: string;
    country: CountryDto | null;
    countryid: string | null;
    playgrounds: PlaygroundDto[] | null;
}

export class RemindGuestDto implements IRemindGuestDto {
    invitationids!: string[] | null;
    partybookingid!: string;

    constructor(data?: IRemindGuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invitationids"])) {
                this.invitationids = [] as any;
                for (let item of _data["invitationids"])
                    this.invitationids!.push(item);
            }
            else {
                this.invitationids = <any>null;
            }
            this.partybookingid = _data["partybookingid"] !== undefined ? _data["partybookingid"] : <any>null;
        }
    }

    static fromJS(data: any): RemindGuestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemindGuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invitationids)) {
            data["invitationids"] = [];
            for (let item of this.invitationids)
                data["invitationids"].push(item);
        }
        data["partybookingid"] = this.partybookingid !== undefined ? this.partybookingid : <any>null;
        return data;
    }
}

export interface IRemindGuestDto {
    invitationids: string[] | null;
    partybookingid: string;
}

export class RoomDto implements IRoomDto {
    name!: string | null;
    translatednames!: { [key: string]: string; } | null;
    translateddescriptions!: { [key: string]: string; } | null;
    description!: string | null;
    guid!: string | null;
    size!: number;
    maxguests!: number;
    recommendedmaxguests!: number;
    blockid!: string;
    block!: string | null;
    area!: AreaDto | null;
    areaid!: string | null;
    disabled!: boolean;
    image!: ImageDto | null;
    images!: ImageDto[] | null;
    theme!: RoomThemeDto | null;
    themeid!: string | null;

    constructor(data?: IRoomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            if (_data["translatednames"]) {
                this.translatednames = {} as any;
                for (let key in _data["translatednames"]) {
                    if (_data["translatednames"].hasOwnProperty(key))
                        (<any>this.translatednames)![key] = _data["translatednames"][key] !== undefined ? _data["translatednames"][key] : <any>null;
                }
            }
            else {
                this.translatednames = <any>null;
            }
            if (_data["translateddescriptions"]) {
                this.translateddescriptions = {} as any;
                for (let key in _data["translateddescriptions"]) {
                    if (_data["translateddescriptions"].hasOwnProperty(key))
                        (<any>this.translateddescriptions)![key] = _data["translateddescriptions"][key] !== undefined ? _data["translateddescriptions"][key] : <any>null;
                }
            }
            else {
                this.translateddescriptions = <any>null;
            }
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.size = _data["size"] !== undefined ? _data["size"] : <any>null;
            this.maxguests = _data["maxguests"] !== undefined ? _data["maxguests"] : <any>null;
            this.recommendedmaxguests = _data["recommendedmaxguests"] !== undefined ? _data["recommendedmaxguests"] : <any>null;
            this.blockid = _data["blockid"] !== undefined ? _data["blockid"] : <any>null;
            this.block = _data["block"] !== undefined ? _data["block"] : <any>null;
            this.area = _data["area"] ? AreaDto.fromJS(_data["area"]) : <any>null;
            this.areaid = _data["areaid"] !== undefined ? _data["areaid"] : <any>null;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : <any>null;
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>null;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            else {
                this.images = <any>null;
            }
            this.theme = _data["theme"] ? RoomThemeDto.fromJS(_data["theme"]) : <any>null;
            this.themeid = _data["themeid"] !== undefined ? _data["themeid"] : <any>null;
        }
    }

    static fromJS(data: any): RoomDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (this.translatednames) {
            data["translatednames"] = {};
            for (let key in this.translatednames) {
                if (this.translatednames.hasOwnProperty(key))
                    (<any>data["translatednames"])[key] = this.translatednames[key] !== undefined ? this.translatednames[key] : <any>null;
            }
        }
        if (this.translateddescriptions) {
            data["translateddescriptions"] = {};
            for (let key in this.translateddescriptions) {
                if (this.translateddescriptions.hasOwnProperty(key))
                    (<any>data["translateddescriptions"])[key] = this.translateddescriptions[key] !== undefined ? this.translateddescriptions[key] : <any>null;
            }
        }
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["size"] = this.size !== undefined ? this.size : <any>null;
        data["maxguests"] = this.maxguests !== undefined ? this.maxguests : <any>null;
        data["recommendedmaxguests"] = this.recommendedmaxguests !== undefined ? this.recommendedmaxguests : <any>null;
        data["blockid"] = this.blockid !== undefined ? this.blockid : <any>null;
        data["block"] = this.block !== undefined ? this.block : <any>null;
        data["area"] = this.area ? this.area.toJSON() : <any>null;
        data["areaid"] = this.areaid !== undefined ? this.areaid : <any>null;
        data["disabled"] = this.disabled !== undefined ? this.disabled : <any>null;
        data["image"] = this.image ? this.image.toJSON() : <any>null;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["theme"] = this.theme ? this.theme.toJSON() : <any>null;
        data["themeid"] = this.themeid !== undefined ? this.themeid : <any>null;
        return data;
    }
}

export interface IRoomDto {
    name: string | null;
    translatednames: { [key: string]: string; } | null;
    translateddescriptions: { [key: string]: string; } | null;
    description: string | null;
    guid: string | null;
    size: number;
    maxguests: number;
    recommendedmaxguests: number;
    blockid: string;
    block: string | null;
    area: AreaDto | null;
    areaid: string | null;
    disabled: boolean;
    image: ImageDto | null;
    images: ImageDto[] | null;
    theme: RoomThemeDto | null;
    themeid: string | null;
}

export class RoomThemeDto implements IRoomThemeDto {
    name!: string | null;
    guid!: string | null;
    image!: ImageDto | null;

    constructor(data?: IRoomThemeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : <any>null;
        }
    }

    static fromJS(data: any): RoomThemeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomThemeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["image"] = this.image ? this.image.toJSON() : <any>null;
        return data;
    }
}

export interface IRoomThemeDto {
    name: string | null;
    guid: string | null;
    image: ImageDto | null;
}

export class TimeSlotDto implements ITimeSlotDto {
    starttime!: string;
    displaystarttime!: string;
    comment!: string | null;
    endtime!: string;
    guid!: string;
    usealternativemailtemplate!: boolean | null;
    openbydefault!: boolean | null;
    status!: string | null;
    partysettingid!: string | null;
    blockid!: string | null;
    playcenter!: string | null;

    constructor(data?: ITimeSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.starttime = _data["starttime"] !== undefined ? _data["starttime"] : <any>null;
            this.displaystarttime = _data["displaystarttime"] !== undefined ? _data["displaystarttime"] : <any>null;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : <any>null;
            this.endtime = _data["endtime"] !== undefined ? _data["endtime"] : <any>null;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.usealternativemailtemplate = _data["usealternativemailtemplate"] !== undefined ? _data["usealternativemailtemplate"] : <any>null;
            this.openbydefault = _data["openbydefault"] !== undefined ? _data["openbydefault"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.partysettingid = _data["partysettingid"] !== undefined ? _data["partysettingid"] : <any>null;
            this.blockid = _data["blockid"] !== undefined ? _data["blockid"] : <any>null;
            this.playcenter = _data["playcenter"] !== undefined ? _data["playcenter"] : <any>null;
        }
    }

    static fromJS(data: any): TimeSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["starttime"] = this.starttime !== undefined ? this.starttime : <any>null;
        data["displaystarttime"] = this.displaystarttime !== undefined ? this.displaystarttime : <any>null;
        data["comment"] = this.comment !== undefined ? this.comment : <any>null;
        data["endtime"] = this.endtime !== undefined ? this.endtime : <any>null;
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["usealternativemailtemplate"] = this.usealternativemailtemplate !== undefined ? this.usealternativemailtemplate : <any>null;
        data["openbydefault"] = this.openbydefault !== undefined ? this.openbydefault : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["partysettingid"] = this.partysettingid !== undefined ? this.partysettingid : <any>null;
        data["blockid"] = this.blockid !== undefined ? this.blockid : <any>null;
        data["playcenter"] = this.playcenter !== undefined ? this.playcenter : <any>null;
        return data;
    }
}

export interface ITimeSlotDto {
    starttime: string;
    displaystarttime: string;
    comment: string | null;
    endtime: string;
    guid: string;
    usealternativemailtemplate: boolean | null;
    openbydefault: boolean | null;
    status: string | null;
    partysettingid: string | null;
    blockid: string | null;
    playcenter: string | null;
}

export class ForgotPasswordModel implements IForgotPasswordModel {
    email!: string | null;

    constructor(data?: IForgotPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): ForgotPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }
}

export interface IForgotPasswordModel {
    email: string | null;
}

export class ForgotPasswordModelResponse implements IForgotPasswordModelResponse {
    message!: string | null;
    success!: boolean;
    email!: string | null;

    constructor(data?: IForgotPasswordModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
        }
    }

    static fromJS(data: any): ForgotPasswordModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        return data;
    }
}

export interface IForgotPasswordModelResponse {
    message: string | null;
    success: boolean;
    email: string | null;
}

/** Model used to register a new user. */
export class RegisterUserDto implements IRegisterUserDto {
    /** Request for creating a new user using the minimum amount of data required. */
    details!: BasicUserCreateRequest;
    preferredPlaycenterId!: string;
    password!: string;
    registrationSource!: RegisterUserRegistrationSourceValueDto;

    constructor(data?: IRegisterUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.details = new BasicUserCreateRequest();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.details = _data["details"] ? BasicUserCreateRequest.fromJS(_data["details"]) : new BasicUserCreateRequest();
            this.preferredPlaycenterId = _data["preferredPlaycenterId"] !== undefined ? _data["preferredPlaycenterId"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.registrationSource = _data["registrationSource"] !== undefined ? _data["registrationSource"] : <any>null;
        }
    }

    static fromJS(data: any): RegisterUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegisterUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : <any>null;
        data["preferredPlaycenterId"] = this.preferredPlaycenterId !== undefined ? this.preferredPlaycenterId : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["registrationSource"] = this.registrationSource !== undefined ? this.registrationSource : <any>null;
        return data;
    }
}

/** Model used to register a new user. */
export interface IRegisterUserDto {
    /** Request for creating a new user using the minimum amount of data required. */
    details: BasicUserCreateRequest;
    preferredPlaycenterId: string;
    password: string;
    registrationSource: RegisterUserRegistrationSourceValueDto;
}

export enum RegisterUserRegistrationSourceValueDto {
    Site = "Site",
    Onboarding = "Onboarding",
    MyAccount = "MyAccount",
    IdServer = "IdServer",
    EntranceBooking = "EntranceBooking",
    PartyBooking = "PartyBooking",
}

export class ResetPasswordModelRequest implements IResetPasswordModelRequest {
    password!: string | null;
    code!: string | null;
    userid!: string | null;

    constructor(data?: IResetPasswordModelRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
            this.userid = _data["userid"] !== undefined ? _data["userid"] : <any>null;
        }
    }

    static fromJS(data: any): ResetPasswordModelRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordModelRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        data["userid"] = this.userid !== undefined ? this.userid : <any>null;
        return data;
    }
}

export interface IResetPasswordModelRequest {
    password: string | null;
    code: string | null;
    userid: string | null;
}

export class ResetPasswordModelResponse implements IResetPasswordModelResponse {
    message!: string | null;
    success!: boolean;
    userid!: string | null;

    constructor(data?: IResetPasswordModelResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.userid = _data["userid"] !== undefined ? _data["userid"] : <any>null;
        }
    }

    static fromJS(data: any): ResetPasswordModelResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordModelResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["userid"] = this.userid !== undefined ? this.userid : <any>null;
        return data;
    }
}

export interface IResetPasswordModelResponse {
    message: string | null;
    success: boolean;
    userid: string | null;
}

/** Model for updating an user. */
export class UpdateProfileModel implements IUpdateProfileModel {
    firstname!: string | null;
    lastname!: string | null;
    city!: string | null;
    streetAddress!: string | null;
    coAddress!: string | null;
    postalCode!: string | null;
    phone!: string | null;
    countrycode!: number | null;
    email!: string | null;
    preferredplaycenterid!: string | null;
    /** GDPR If the users disallow notifications on emails for newsletters, offers. */
    gdprdisallowinformation!: boolean | null;
    /** GDPR If the users disallow notifications on sms for newsletters, offers. */
    gdprdisallowsms!: boolean | null;
    /** GDPR If the users allow notifications on sms for newsletters, offers from partners. */
    gdprallowpartnerinformation!: boolean | null;
    /** GDPR If the users disallow notifications on sms for newsletters, offers from partners. */
    gdprallowpartnersms!: boolean | null;

    constructor(data?: IUpdateProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstname = _data["firstname"] !== undefined ? _data["firstname"] : <any>null;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : <any>null;
            this.city = _data["City"] !== undefined ? _data["City"] : <any>null;
            this.streetAddress = _data["StreetAddress"] !== undefined ? _data["StreetAddress"] : <any>null;
            this.coAddress = _data["CoAddress"] !== undefined ? _data["CoAddress"] : <any>null;
            this.postalCode = _data["PostalCode"] !== undefined ? _data["PostalCode"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.countrycode = _data["countrycode"] !== undefined ? _data["countrycode"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.preferredplaycenterid = _data["preferredplaycenterid"] !== undefined ? _data["preferredplaycenterid"] : <any>null;
            this.gdprdisallowinformation = _data["gdprdisallowinformation"] !== undefined ? _data["gdprdisallowinformation"] : <any>null;
            this.gdprdisallowsms = _data["gdprdisallowsms"] !== undefined ? _data["gdprdisallowsms"] : <any>null;
            this.gdprallowpartnerinformation = _data["gdprallowpartnerinformation"] !== undefined ? _data["gdprallowpartnerinformation"] : <any>null;
            this.gdprallowpartnersms = _data["gdprallowpartnersms"] !== undefined ? _data["gdprallowpartnersms"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstname"] = this.firstname !== undefined ? this.firstname : <any>null;
        data["lastname"] = this.lastname !== undefined ? this.lastname : <any>null;
        data["City"] = this.city !== undefined ? this.city : <any>null;
        data["StreetAddress"] = this.streetAddress !== undefined ? this.streetAddress : <any>null;
        data["CoAddress"] = this.coAddress !== undefined ? this.coAddress : <any>null;
        data["PostalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["countrycode"] = this.countrycode !== undefined ? this.countrycode : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["preferredplaycenterid"] = this.preferredplaycenterid !== undefined ? this.preferredplaycenterid : <any>null;
        data["gdprdisallowinformation"] = this.gdprdisallowinformation !== undefined ? this.gdprdisallowinformation : <any>null;
        data["gdprdisallowsms"] = this.gdprdisallowsms !== undefined ? this.gdprdisallowsms : <any>null;
        data["gdprallowpartnerinformation"] = this.gdprallowpartnerinformation !== undefined ? this.gdprallowpartnerinformation : <any>null;
        data["gdprallowpartnersms"] = this.gdprallowpartnersms !== undefined ? this.gdprallowpartnersms : <any>null;
        return data;
    }
}

/** Model for updating an user. */
export interface IUpdateProfileModel {
    firstname: string | null;
    lastname: string | null;
    city: string | null;
    streetAddress: string | null;
    coAddress: string | null;
    postalCode: string | null;
    phone: string | null;
    countrycode: number | null;
    email: string | null;
    preferredplaycenterid: string | null;
    /** GDPR If the users disallow notifications on emails for newsletters, offers. */
    gdprdisallowinformation: boolean | null;
    /** GDPR If the users disallow notifications on sms for newsletters, offers. */
    gdprdisallowsms: boolean | null;
    /** GDPR If the users allow notifications on sms for newsletters, offers from partners. */
    gdprallowpartnerinformation: boolean | null;
    /** GDPR If the users disallow notifications on sms for newsletters, offers from partners. */
    gdprallowpartnersms: boolean | null;
}

export class AddToRoleModel implements IAddToRoleModel {
    userguid!: string | null;
    rolename!: string | null;

    constructor(data?: IAddToRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userguid = _data["userguid"] !== undefined ? _data["userguid"] : <any>null;
            this.rolename = _data["rolename"] !== undefined ? _data["rolename"] : <any>null;
        }
    }

    static fromJS(data: any): AddToRoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new AddToRoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userguid"] = this.userguid !== undefined ? this.userguid : <any>null;
        data["rolename"] = this.rolename !== undefined ? this.rolename : <any>null;
        return data;
    }
}

export interface IAddToRoleModel {
    userguid: string | null;
    rolename: string | null;
}

export class LocationListItem implements ILocationListItem {
    name!: string | null;
    streetadress!: string | null;
    playcentertype!: PlaycenterType;
    slug!: string | null;
    translatednames!: { [key: string]: string; } | null;
    parentid!: string | null;
    guid!: string;
    disabled!: boolean;
    datatypename!: string | null;
    objecttype!: string | null;
    namepath!: string[] | null;
    path!: string[] | null;
    children!: LocationListItem[] | null;

    constructor(data?: ILocationListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.streetadress = _data["streetadress"] !== undefined ? _data["streetadress"] : <any>null;
            this.playcentertype = _data["playcentertype"] !== undefined ? _data["playcentertype"] : <any>null;
            this.slug = _data["slug"] !== undefined ? _data["slug"] : <any>null;
            if (_data["translatednames"]) {
                this.translatednames = {} as any;
                for (let key in _data["translatednames"]) {
                    if (_data["translatednames"].hasOwnProperty(key))
                        (<any>this.translatednames)![key] = _data["translatednames"][key] !== undefined ? _data["translatednames"][key] : <any>null;
                }
            }
            else {
                this.translatednames = <any>null;
            }
            this.parentid = _data["parentid"] !== undefined ? _data["parentid"] : <any>null;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : <any>null;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : <any>null;
            this.datatypename = _data["datatypename"] !== undefined ? _data["datatypename"] : <any>null;
            this.objecttype = _data["objecttype"] !== undefined ? _data["objecttype"] : <any>null;
            if (Array.isArray(_data["namepath"])) {
                this.namepath = [] as any;
                for (let item of _data["namepath"])
                    this.namepath!.push(item);
            }
            else {
                this.namepath = <any>null;
            }
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(item);
            }
            else {
                this.path = <any>null;
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(LocationListItem.fromJS(item));
            }
            else {
                this.children = <any>null;
            }
        }
    }

    static fromJS(data: any): LocationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new LocationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["streetadress"] = this.streetadress !== undefined ? this.streetadress : <any>null;
        data["playcentertype"] = this.playcentertype !== undefined ? this.playcentertype : <any>null;
        data["slug"] = this.slug !== undefined ? this.slug : <any>null;
        if (this.translatednames) {
            data["translatednames"] = {};
            for (let key in this.translatednames) {
                if (this.translatednames.hasOwnProperty(key))
                    (<any>data["translatednames"])[key] = this.translatednames[key] !== undefined ? this.translatednames[key] : <any>null;
            }
        }
        data["parentid"] = this.parentid !== undefined ? this.parentid : <any>null;
        data["guid"] = this.guid !== undefined ? this.guid : <any>null;
        data["disabled"] = this.disabled !== undefined ? this.disabled : <any>null;
        data["datatypename"] = this.datatypename !== undefined ? this.datatypename : <any>null;
        data["objecttype"] = this.objecttype !== undefined ? this.objecttype : <any>null;
        if (Array.isArray(this.namepath)) {
            data["namepath"] = [];
            for (let item of this.namepath)
                data["namepath"].push(item);
        }
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item);
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILocationListItem {
    name: string | null;
    streetadress: string | null;
    playcentertype: PlaycenterType;
    slug: string | null;
    translatednames: { [key: string]: string; } | null;
    parentid: string | null;
    guid: string;
    disabled: boolean;
    datatypename: string | null;
    objecttype: string | null;
    namepath: string[] | null;
    path: string[] | null;
    children: LocationListItem[] | null;
}

export class PartyBookingOpeningContentDto implements IPartyBookingOpeningContentDto {
    pageTitle!: string;
    pageSubtitle!: string;
    cardImageId!: string;
    cardTitle!: string;
    cardText!: string;
    alertText!: string | null;
    calendarEventTitle!: string;
    calendarEventText!: string;
    addToCalenderButtonText!: string;

    constructor(data?: IPartyBookingOpeningContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageTitle = _data["pageTitle"] !== undefined ? _data["pageTitle"] : <any>null;
            this.pageSubtitle = _data["pageSubtitle"] !== undefined ? _data["pageSubtitle"] : <any>null;
            this.cardImageId = _data["cardImageId"] !== undefined ? _data["cardImageId"] : <any>null;
            this.cardTitle = _data["cardTitle"] !== undefined ? _data["cardTitle"] : <any>null;
            this.cardText = _data["cardText"] !== undefined ? _data["cardText"] : <any>null;
            this.alertText = _data["alertText"] !== undefined ? _data["alertText"] : <any>null;
            this.calendarEventTitle = _data["calendarEventTitle"] !== undefined ? _data["calendarEventTitle"] : <any>null;
            this.calendarEventText = _data["calendarEventText"] !== undefined ? _data["calendarEventText"] : <any>null;
            this.addToCalenderButtonText = _data["addToCalenderButtonText"] !== undefined ? _data["addToCalenderButtonText"] : <any>null;
        }
    }

    static fromJS(data: any): PartyBookingOpeningContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingOpeningContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageTitle"] = this.pageTitle !== undefined ? this.pageTitle : <any>null;
        data["pageSubtitle"] = this.pageSubtitle !== undefined ? this.pageSubtitle : <any>null;
        data["cardImageId"] = this.cardImageId !== undefined ? this.cardImageId : <any>null;
        data["cardTitle"] = this.cardTitle !== undefined ? this.cardTitle : <any>null;
        data["cardText"] = this.cardText !== undefined ? this.cardText : <any>null;
        data["alertText"] = this.alertText !== undefined ? this.alertText : <any>null;
        data["calendarEventTitle"] = this.calendarEventTitle !== undefined ? this.calendarEventTitle : <any>null;
        data["calendarEventText"] = this.calendarEventText !== undefined ? this.calendarEventText : <any>null;
        data["addToCalenderButtonText"] = this.addToCalenderButtonText !== undefined ? this.addToCalenderButtonText : <any>null;
        return data;
    }
}

export interface IPartyBookingOpeningContentDto {
    pageTitle: string;
    pageSubtitle: string;
    cardImageId: string;
    cardTitle: string;
    cardText: string;
    alertText: string | null;
    calendarEventTitle: string;
    calendarEventText: string;
    addToCalenderButtonText: string;
}

export enum ApplicationNoticeType {
    EntranceBooking = "EntranceBooking",
    ChildClassBooking = "ChildClassBooking",
    PartyBooking = "PartyBooking",
}

export enum DateCriteriaComparable {
    NotSet = "NotSet",
    PartyDate = "PartyDate",
    BookDate = "BookDate",
    EventDate = "EventDate",
}

export enum ChildClassBookingPaymentStatus {
    Pending = "Pending",
    Paid = "Paid",
    Refunded = "Refunded",
}

export enum ChildClassClassType {
    SportKidz = "SportKidz",
    SportKidzTrial = "SportKidzTrial",
    LeoCamp = "LeoCamp",
}

export enum ChildClassTransactionLineType {
    Default = "Default",
    Credit = "Credit",
}

export enum ChildClassTransactionType {
    Capture = "Capture",
    Credit = "Credit",
    AwaitingPayment = "AwaitingPayment",
}

export enum CriteriaLessEqualMore {
    LessThan = "LessThan",
    Equal = "Equal",
    MoreThan = "MoreThan",
    NotEqual = "NotEqual",
}

export enum UserEntranceDiscountType {
    Generic = "generic",
    Repurchase = "repurchase",
    Revisit = "revisit",
}

export enum EntranceBookStatus {
    Unset = "Unset",
    Reserved = "Reserved",
    Confirmed = "Confirmed",
    ReservedForChange = "ReservedForChange",
    Cancelled = "Cancelled",
}

export enum GiftCardOrderPaymentStatus {
    AwaitingPayment = "AwaitingPayment",
    Paid = "Paid",
    PaymentFailed = "PaymentFailed",
}

export enum PlaycenterType {
    Leo = "Leo",
    HopLop = "HopLop",
}

export enum MediaType {
    Jpeg = "Jpeg",
    Gif = "Gif",
    Png = "Png",
    Bmp = "Bmp",
    Tiff = "Tiff",
}

export enum PackageItemType {
    Default = "Default",
    Addon = "Addon",
    Exchange = "Exchange",
}

export enum PublishStatus {
    Draft = "Draft",
    Published = "Published",
    Unpublished = "Unpublished",
}

export enum PassOrderPaymentStatus {
    AwaitingPayment = "AwaitingPayment",
    Paid = "Paid",
    PaymentFailed = "PaymentFailed",
}

export enum DurationType {
    Day = "Day",
    Month = "Month",
    Year = "Year",
}

export enum DurationType2 {
    Days = "Days",
    Months = "Months",
    Years = "Years",
}

export enum SerialTicketArticleInactiveReason {
    None = "None",
    SoldOut = "SoldOut",
    PosArticle = "PosArticle",
}

export enum SerialTicketOrderPaymentStatus {
    AwaitingPayment = "AwaitingPayment",
    Paid = "Paid",
    PaymentFailed = "PaymentFailed",
    Refunded = "Refunded",
}

export enum PassArticleInactiveReason {
    None = "None",
    SoldOut = "SoldOut",
    PosArticle = "PosArticle",
}

export enum PassArticleType {
    Period = "Period",
    OpenEndDate = "OpenEndDate",
}

export class PasswordOptions implements IPasswordOptions {
    requiredLength!: number;
    requiredUniqueChars!: number;
    requireNonAlphanumeric!: boolean;
    requireLowercase!: boolean;
    requireUppercase!: boolean;
    requireDigit!: boolean;

    constructor(data?: IPasswordOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requiredLength = _data["requiredLength"] !== undefined ? _data["requiredLength"] : <any>null;
            this.requiredUniqueChars = _data["requiredUniqueChars"] !== undefined ? _data["requiredUniqueChars"] : <any>null;
            this.requireNonAlphanumeric = _data["requireNonAlphanumeric"] !== undefined ? _data["requireNonAlphanumeric"] : <any>null;
            this.requireLowercase = _data["requireLowercase"] !== undefined ? _data["requireLowercase"] : <any>null;
            this.requireUppercase = _data["requireUppercase"] !== undefined ? _data["requireUppercase"] : <any>null;
            this.requireDigit = _data["requireDigit"] !== undefined ? _data["requireDigit"] : <any>null;
        }
    }

    static fromJS(data: any): PasswordOptions {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requiredLength"] = this.requiredLength !== undefined ? this.requiredLength : <any>null;
        data["requiredUniqueChars"] = this.requiredUniqueChars !== undefined ? this.requiredUniqueChars : <any>null;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric !== undefined ? this.requireNonAlphanumeric : <any>null;
        data["requireLowercase"] = this.requireLowercase !== undefined ? this.requireLowercase : <any>null;
        data["requireUppercase"] = this.requireUppercase !== undefined ? this.requireUppercase : <any>null;
        data["requireDigit"] = this.requireDigit !== undefined ? this.requireDigit : <any>null;
        return data;
    }
}

export interface IPasswordOptions {
    requiredLength: number;
    requiredUniqueChars: number;
    requireNonAlphanumeric: boolean;
    requireLowercase: boolean;
    requireUppercase: boolean;
    requireDigit: boolean;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export class SwaggerApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerApiException = true;

    static isSwaggerApiException(obj: any): obj is SwaggerApiException {
        return obj.isSwaggerApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerApiException(message, status, response, headers, result);
}